"use strict";

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function () {
  angular.module('meanApp', ['ui.router', 'ui.bootstrap', 'ngAnimate', 'ngImgCrop', 'hmTouchEvents', 'rzModule', 'as.sortable', 'ngFitText', 'ngCookies']);
  function config($stateProvider, $urlRouterProvider, $locationProvider) {
    $urlRouterProvider.rule(function ($injector, $location) {
      var path = $location.path(),
        hasTrailingSlash = path[path.length - 1] === '/';
      if (hasTrailingSlash) {
        //if last charcter is a slash, return the same url without the slash
        var newPath = path.substr(0, path.length - 1);
        return newPath;
        //return path+'/';//always add a trailing slash
      }
    });
    $stateProvider.state('home', {
      url: '/',
      templateUrl: '/home/home.view.html',
      controller: 'homeCtrl',
      controllerAs: 'vm'
    }).state('recipeSearchResult', {
      url: '/recherche/resultats?tags',
      templateUrl: '/search/results.search.view.html',
      controller: 'searchCtrl',
      controllerAs: 'vm'
    }).state('recipeTextSearchResult', {
      url: '/recherche/resultats?search',
      templateUrl: '/search/results.search.view.html',
      controller: 'searchCtrl',
      controllerAs: 'vm'
    }).state('recipeSearchStep', {
      url: '/recherche/etape/:step',
      templateUrl: function templateUrl($stateParams) {
        // Can not inject dependencies
        var templateURL = '/search/step.one.search.view.html';
        switch ($stateParams.step) {
          case '1':
            templateURL = '/search/step.one.search.view.html';
            break;
          case '2':
            templateURL = '/search/step.two.search.view.html';
            break;
          case '3':
            templateURL = '/search/step.three.search.view.html';
            break;
          case '4':
            templateURL = '/search/step.four.search.view.html';
            break;
        }
        return templateURL;
      },
      controller: 'searchCtrl',
      controllerAs: 'vm'
    }).state('recipecreation', {
      url: '/creer-ma-recette',
      templateUrl: '/recipe/step.one.creation.view.html',
      controller: 'recipeCtrl',
      controllerAs: 'vm'
    }).state('recipecreationstep', {
      url: '/recette/:id/edit/etape/:step',
      templateUrl: function templateUrl($stateParams) {
        // Can not inject dependencies
        console.log('state params are', $stateParams);
        var templateURL = '/recipe/step.one.creation.view.html';
        switch ($stateParams.step) {
          case '1':
            templateURL = '/recipe/step.one.creation.view.html';
            break;
          case '2':
            templateURL = '/recipe/step.two.creation.view.html';
            break;
          case '3':
            templateURL = '/recipe/step.three.creation.view.html';
            break;
        }
        return templateURL;
      },
      controller: 'recipeCtrl',
      controllerAs: 'vm'
    }).state('recipe', {
      url: '/recette/:id',
      templateUrl: 'recipe/recipe.view.html',
      controller: 'recipeReadCtrl',
      controllerAs: 'vm'
    }).state('recipeInstructions', {
      url: '/recette/:id/preparation',
      templateUrl: 'recipe/recipe.instructions.view.html',
      controller: 'recipeReadCtrl',
      controllerAs: 'vm'
    }).state('recipeExport', {
      url: '/recette/:id/export',
      templateUrl: 'recipe/recipe.export.view.html',
      controller: 'recipeReadCtrl',
      controllerAs: 'vm'
    }).state('ingredientEdit', {
      url: '/ingredient/:slug/edit',
      templateUrl: '/ingredient/ingredient.edit.view.html',
      controller: 'ingredientsCtrl',
      controllerAs: 'vm'
    }).state('ingredient', {
      url: '/ingredient/:slug',
      templateUrl: '/ingredient/ingredient.view.html',
      controller: 'ingredientCtrl',
      controllerAs: 'vm'
    }).state('profile', {
      url: '/profil/:id',
      templateUrl: '/profile/profile.view.html',
      controller: 'profileCtrl',
      controllerAs: 'vm'
    }).state('profile.settings', {
      url: '/parametres',
      templateUrl: '/profile/settings.view.html'
    }).state('profile.info', {
      url: '/information',
      templateUrl: '/profile/info.view.html'
    }).state('profile.recipes', {
      controller: 'profileRecipesCtrl',
      controllerAs: 'subVm',
      url: '/recettes',
      templateUrl: '/profile/recipes.view.html'
    }).state('profile.likes', {
      controller: 'profileRecipesCtrl',
      controllerAs: 'subVm',
      url: '/recettes/aimees',
      templateUrl: '/profile/recipes.view.html'
    }).state('profile.bookmarks', {
      controller: 'profileRecipesCtrl',
      controllerAs: 'subVm',
      url: '/recettes/sauvegardees',
      templateUrl: '/profile/recipes.view.html'
    }).state('admin', {
      url: '/admin',
      templateUrl: '/admin/admin.view.html',
      //controller: 'adminCtrl',
      controllerAs: 'vm'
    }).state('admin.recipes', {
      url: '/recettes',
      templateUrl: '/admin/recipes.view.html',
      controller: 'recipesAdminCtrl',
      controllerAs: 'vm'
    }).state('admin.users', {
      url: '/utilisateurs',
      templateUrl: '/admin/users.view.html',
      controller: 'usersCtrl',
      controllerAs: 'vm'
    }).state('admin.ingredients', {
      url: '/ingredients',
      templateUrl: '/admin/ingredients.view.html',
      controller: 'ingredientsCtrl',
      controllerAs: 'vm'
    }).state('admin.measures', {
      url: '/mesures',
      templateUrl: '/admin/measures.view.html',
      controller: 'measuresCtrl',
      controllerAs: 'vm'
    }).state('admin.departments', {
      url: '/rayons',
      templateUrl: '/admin/departments.view.html',
      controller: 'departmentsCtrl',
      controllerAs: 'vm'
    }).state('admin.allergens', {
      url: '/allergenes',
      templateUrl: '/admin/allergens.view.html',
      controller: 'allergensCtrl',
      controllerAs: 'vm'
    }).state('admin.features', {
      url: '/proprietes',
      templateUrl: '/admin/features.view.html',
      controller: 'featuresCtrl',
      controllerAs: 'vm'
    }).state('recipesDiscovery', {
      url: '/recettes/tag/:tag/page/:page',
      templateUrl: '/discovery/recipe.discovery.view.html',
      controller: 'recipesDiscoveryCtrl',
      controllerAs: 'vm'
    }).state('ingredientWidget', {
      url: '/widget/ingredient/:slug',
      templateUrl: '/widgetDemo/ingredient.widget.view.html',
      controller: 'ingredientCtrl',
      controllerAs: 'vm'
    }).state('recipeWidget', {
      url: '/widget/recette/:slug',
      templateUrl: '/widgetDemo/recipe.widget.view.html',
      controller: 'recipeReadCtrl',
      controllerAs: 'vm'
    }).state('recipeWidgetNone', {
      url: '/widget/recette',
      templateUrl: '/widgetDemo/recipe.widget.view.html',
      controller: 'recipeReadCtrl',
      controllerAs: 'vm'
    }).state('contact', {
      url: '/contact',
      controller: 'contactCtrl',
      templateUrl: '/about/contact.view.html' //this is a static view so no controller here
    }).state('faq', {
      url: '/foire-aux-questions',
      controller: 'faqCtrl',
      controllerAs: 'vm',
      templateUrl: '/about/faq.view.html' //this is a static view so no controller here
    }).state('about', {
      url: '/about',
      controllerAs: 'vm',
      controller: 'aboutCtrl',
      templateUrl: '/about/about.view.html' //this is a static view so no controller here
    }).state('premium', {
      url: '/premium',
      controllerAs: 'vm',
      controller: 'premiumCtrl',
      templateUrl: '/premium/premium.view.html' //this is a static view so no controller here
    }).state('premiumPaymentSuccess', {
      url: '/premium/payment-success',
      controllerAs: 'vm',
      controller: 'premiumCtrl',
      templateUrl: '/premium/success.view.html' //this is a static view so no controller here
    });
    /**.caseInsensitiveMatch = true;**/
    // use the HTML5 History API this also remove the # tag that is appended to all the URLs. Ugly !
    $locationProvider.html5Mode({
      enabled: true,
      requireBase: false
    });
    $urlRouterProvider.otherwise('/');
  }
  function run($rootScope, $location, context) {
    $rootScope.$on('$locationChangeSuccess', function (rootScope, currentPath, previousPath) {
      var currentState = context.getCurrentState();
      if (currentState) {
        context.setPreviousState(currentState);
      }
      if ($location.$$path) {
        context.setCurrentState($location.$$path);
      }
    });
  }
  angular.module('meanApp').config(['$stateProvider', '$urlRouterProvider', '$locationProvider', config]).run(['$rootScope', '$location', 'context', run]);
})();
var cacheName = 'hello-pwa';

//be careful because 
var filesToCache = [
//'/',
//'/index.html',//try to 'cache' the index ans see what happens when changes are pushed
'/lib/angular/angular.min.js', '/lib/angular/angular-ui-router.min.js', '/lib/angular/angular-animate.min.js', '/lib/angular-bootstrap/ui-bootstrap-tpls-1.3.2.min.js',
//'/app.min.js',
'/lib/imagecrop/ng-img-crop.js', '/lib/infinite-scroll/infinite-scroll.js', '/lib/angular-slider/rzslider.min.js', '/lib/angular-hammer/hammer.min.js', '/lib/angular-hammer/angular.hammer.js', '/lib/odometer/odometer.min.js', '/lib/ngDragToReorder/ngDragToReorder.js', '/lib/angular/angular.min.js', '/lib/fit-text/ng-FitText.min.js',
//'/bundle.css',
'/lib/fob-font/style.css', '/lib/imagecrop/ng-img-crop.css', '/lib/angular-slider/rzslider.min.css', '/lib/ngDragToReorder/ng-sortable.min.css' /*,
                                                                                                                                                '/common/directives/navigation/navigation.template.html',
                                                                                                                                                '/common/directives/alert/alert.template.html',
                                                                                                                                                '/common/directives/footer/footer.template.html',
                                                                                                                                                '/home/home.view.html',
                                                                                                                                                '/common/directives/userthumb/userthumb.template.html',
                                                                                                                                                '/home/header.view.html',
                                                                                                                                                '/home/allfeatures.view.html',
                                                                                                                                                '/home/firstfeature.view.html',
                                                                                                                                                '/home/secondfeature.view.html',
                                                                                                                                                '/auth/subscribe.view.html',
                                                                                                                                                '/common/directives/tag/tag.template.html',
                                                                                                                                                '/home/persona.view.html',
                                                                                                                                                '/html/fraise.html',
                                                                                                                                                '/html/bacon.html'*/];

/* Start the service worker and cache all of the app's content */
//this is used for caching when offline
self.addEventListener('install', function (e) {
  e.waitUntil(caches.open(cacheName).then(function (cache) {
    //special promise so if one resource fail to load it still continues working
    return Promise.all(filesToCache.map(function (url) {
      return cache.add(url)["catch"](function (reason) {
        return console.log(url, "failed: ", String(reason));
      });
    }));
  }, function (e) {
    console.log('the install failed', e);
  }));
});

/* Serve cached content when offline */
//this is applied on EVERY resource that can be cached
self.addEventListener('fetch', function (e) {
  e.respondWith(caches.match(e.request).then(function (response) {
    return response || fetch(e.request);
  }, function (e) {
    console.log('it failed fetching the files', e);
  }));
});
(function () {
  angular.module('meanApp').controller('aboutCtrl', aboutCtrl);
  aboutCtrl.$inject = ['$scope', '$rootScope', '$location', 'context', '$state'];
  function aboutCtrl($scope, $rootScope, $location, context, $state) {
    var vm = this;
    context.set({
      contextName: 'A propos',
      title: 'Contact, Foire aux questions, Création de widget',
      goBack: true
    });
    vm.goToContact = function () {
      $state.go('contact');
    };
    vm.goToFAQ = function () {
      $state.go('faq');
    };
    vm.goToWidget = function () {
      $state.go('recipeWidgetNone');
    };
  }
})();
(function () {
  angular.module('meanApp').controller('contactCtrl', contactCtrl);
  contactCtrl.$inject = ['$scope', '$rootScope', '$location', 'context', '$state'];
  function contactCtrl($scope, $rootScope, $location, context, $state) {
    //var vm = this;

    context.set({
      title: "Contact par email, What's app, Facebook, Linkedin, ou Instagram",
      contextName: 'Contact',
      goBack: true
    });
  }
})();
(function () {
  angular.module('meanApp').controller('faqCtrl', faqCtrl);
  faqCtrl.$inject = ['$scope', '$rootScope', '$location', 'context', '$sce'];
  function faqCtrl($scope, $rootScope, $location, context, $sce) {
    var vm = this;
    vm.questions = [{
      question: $sce.trustAsHtml("Je souhaite <span class='colored'>perdre du poids</span>, comment faire ?"),
      answer: $sce.trustAsHtml("Vous n'êtes pas seul(e) à vous poser cette question ! La nutrition est un aspect plus qu'essentiel à la perte de poids. Heureusement vous êtes sur le bon site ! Nous vous suggérons de privilégier les Nutritags <a href='recherche/resultats?tags=lowcalory'>Hypocalorique</a>, <a href='recherche/resultats?tags=paleo'>Paléo</a>, <a href='recherche/resultats?tags=protein'>Hyperprotéiné</a>, et <a href='recherche/resultats?tags=lowcarb'> Peu de glucides.</a> car ils favorisent la perte de poids. Aussi, regardez le Nutriscore ! Un Nutriscore faible indique que la recette a tendance à avoir un effet néfaste sur votre santé !! Bonne chance ! et tenez nous au courant de vos progrès :) ")
    }, {
      question: $sce.trustAsHtml("Je cherche à prendre de la <span class='colored'>masse musculaire</span>, comment faire ?"),
      answer: $sce.trustAsHtml("Rien de plus simple, il vous suffira de favoriser l'usage du Nutritag <a href='recherche/resultats?tags=protein'>Hyperprotéiné</a>, des recettes plus protéinées que la moyenne vous seront proposées. Vous êtes Vegan ? Pas de soucis, combinez le Nutritag <a href='recherche/resultats?tags=vegan'>Végétalien<>/a ou <a href='recherche/resultats?tags=vegetarian'>Végétarien</a> avec le Nutritag Hyperprotéiné !")
    }, {
      question: $sce.trustAsHtml("Je veux manger <span class='colored'>éco-responsable</span>, comment faire ?"),
      answer: $sce.trustAsHtml("Il a été prouvé scientifiquement que certaines pratiques alimentaires étaient plus carbonées, et donc moins bonnes pour l'environnement. D'autres seraient plus vertueuses. C'est le cas du véganisme. Mais saviez-vous que l'on peut agir pour la planète sans être uniquement végétarien cf. Nutritags <a href='recherche/resultats?tags=vegan'>Végétalien</a>/<a href='recherche/resultats?tags=vegetarian'>Végétarien</a>? L'on peut par exemple aussi se soucier de la provenance des aliments. Par exemple mieux vaut consommer une fraise de france métropole qu'une banane ou un autre fruit provenant des îles lointaines. Le Nutritag <a href='recherche/resultats?tags=local'>Local</a> permet de proposer les recettes qui font usage d'aliments pouvant être fabriqués en France. Mais ce n'est pas tout ! Nous pouvons aller encore plus loin ! Si il est préférable de consommer une fraise locale qu'une banane, il est aussi important de s'assurer de la saisonnalité du fruit :) C'est ici que le Nutritag <a href='recherche/resultats?tags=season'>De saison</a> intervient ! On vous proposera alors des recettes du moment qui comprennent des ingrédients de saison (qui ne nécessitent pas du chauffage ou lumière artificielle en plein hiver!) Bon appétit !!! ")
    }, {
      question: $sce.trustAsHtml("Je suis étudiant et j’ai <span class='colored'>ni le temps ni l’argent</span> pour cuisiner, comment faire ?"),
      answer: $sce.trustAsHtml("Vous n'êtes pas le seul dans ce cas là ! Heureusement fraiseoubacon à la solution pour vous, combinez les Nutritags <a href='/recherche/resultats?tags=fast,eco'>Rapide, et Economique</a>, et le tour est joué ! Si vous n'avez pas de four, vous pourrez également spécifier le Nutritag <a href='/recherche/resultats?tags=nooven'>Sans four</a>")
    }, {
      question: $sce.trustAsHtml("J’ai des <span class='colored'>allergies</span>, comment faire ?"),
      answer: $sce.trustAsHtml("Le moteur de recherche fraiseoubacon s'adapte aussi aux goûts et contraintes de chacun ! Pour cela la dernière étape de recherche permet de personnaliser encore plus les résultats. Il suffit d'avoir un compte (c'est gratuit), et de lister les allergies que vous pouvez avoir :). Si votre compte n'est pas encore créé, n'attendez plus, <a href='recherche/etape/4'>cliquez ici</a>")
    }, {
      question: $sce.trustAsHtml("Je déteste les oignons et le brocoli, comment faire ?"),
      answer: $sce.trustAsHtml("Le moteur de recherche de recette fraiseoubacon s'adapte aussi à vos préférences alimentaires ! Il vous suffira de préciser à la dernière étape de recherche de sélectionner les aliments que vous appréciez moins. Les résultats comportant les ingrédients non désirables auront moins de probabilité d'apparaître, vous pouvez aussi ajouter les aliments qui vous aimez déguster. Si votre compte n'est pas encore créé, n'attendez plus, <a href='recherche/etape/4'>cliquez ici</a>")
    }, {
      question: $sce.trustAsHtml("Je souhaite calculer le <span class='colored'>Nutriscore</span>, et toutes les <span class='colored'>infos nutritionnelles</span> d’une recette pour ensuite <span class='colored'>l’afficher sur mon blog ou site</span>"),
      answer: $sce.trustAsHtml("Fraiseoubacon possède des <a href='/creer-ma-recette'>outils puissants</a> permettant de calculer instantanément les infos nutritionnelles de votre recette. En trois étapes, décrivez les caractéristiques générales, une photo, les ingrédients, puis les instructions. Voilà ! Les composantes de la recette seront calculées automatiquement. Ensuite il suffira de créer <a href='/widget/recette/'>la widget associée ici</a>, et de copier/coller le HTML sur votre site ou blog :)")
    }, {
      question: $sce.trustAsHtml("Je veux pouvoir retrouver facilement les recettes qui m’intéressent, comment faire ?"),
      answer: $sce.trustAsHtml("Fraiseoubacon vous permet d'aimer ou de sauvegarder des recettes pour pouvoir les retrouver facilement dans votre espace personnel. Pour cela, créez votre compte en deux clicks !")
    }, {
      question: $sce.trustAsHtml("Fraiseoubacon existe-t-elle sous forme <span class='colored'>d'application installable</span> sur mon smartphone ?"),
      answer: $sce.trustAsHtml("La réponse est oui, c'est une PWA, à ce titre elle est installable !! Mais Fraiseoubacon n'est pas installable depuis des stores. Pour Android, lors de la visite du site un popup s'affiche en bas de l'écran pour l'installer sur votre écran d'accueil, plus d'infos sur <a target='_blank' href='https://support.google.com/chrome/answer/9658361?co=GENIE.Platform%3DAndroid&hl=fr'>l'installation Android</a>. Sur <a target='_blank' href='https://www.igen.fr/ios/2019/04/les-progressive-web-apps-sintegrent-un-petit-peu-mieux-ios-122-107473#:~:text=Pour%20installer%20une%20PWA%20sur,en%20arri%C3%A8re%20dans%20une%20PWA.'> Iphone</a>, il suffit de cliquer sur 'Ajouter sur l'écran d'accueil'")
    }, {
      question: $sce.trustAsHtml("Je veux devenir <span class='colored'> partenaire</span> de fraiseoubacon"),
      answer: $sce.trustAsHtml("Nous n'attendions que vous ! <a href='/contact'>Contactez-nous</a> pour formaliser votre demande :). Réponse garantie sous 24h")
    }, {
      question: $sce.trustAsHtml("J’ai des remarques ou retours à propos de fraiseoubacon"),
      answer: $sce.trustAsHtml("Nous adorons les retours de nos utilisateurs, <a href='/contact'>contactez-nous</a>, vous aurez une réponse garantie en 24h. A très vite !")
    }, {
      question: $sce.trustAsHtml("Ma question n'est pas listée ici, comment faire ?"),
      answer: $sce.trustAsHtml("Nous sommes là pour vous aider !! <a href='/contact'>Contactez-nous</a> et nous ferons le maximum pour vous répondre dans la journée ! :)")
    }];
    context.set({
      title: "Foire aux questions, réponses à vos questions",
      contextName: 'F.A.Q.',
      goBack: true
    });
  }
})();
(function () {
  angular.module('meanApp').controller('allergensCtrl', allergensCtrl);
  allergensCtrl.$inject = ['$location', 'allergensManager', 'Allergen', '$rootScope', 'alert', '$scope', 'confirmationModal'];
  function allergensCtrl($location, allergensManager, Allergen, $rootScope, alert, $scope, confirmationModal) {
    var vm = this;
    //console.log('the current user is ', $rootScope.currentUser);
    vm.allergens = {};
    $rootScope.$watch('currentUser', function () {
      if ($rootScope.currentUser) {
        if ($rootScope.currentUser.role === 'admin') {
          loadAllergens();
        } else {
          $location.path('/');
        }
      }
    }, function (err) {
      console.log(err);
    });
    var loadAllergens = function loadAllergens() {
      allergensManager.getAll().then(function (result) {
        vm.allergens = result.collection;
      }, function (err) {
        console.log('error loafing all allergens');
      });
    };
    vm.confirmationQuestion = 'Voulez vous vraiment supprimer cet allergène ?';
    vm.onConfirmationModalClick = function () {
      allergensManager["delete"]($scope.allergenIDToDelete).then(function () {
        this.$close();
        alert.push('success', 'Cet allergène a été supprimé définitivement de la base de données');
      }.bind($scope), function () {
        this.$close();
        alert.push('danger', "Cet allergène n'a pas pu être supprimé");
      }.bind($scope));
    };
    vm.removeAllergen = function (id) {
      $scope.allergenIDToDelete = id;
      $scope.modalInstance = confirmationModal.open($scope, 'allergensCtrl');
    };
    vm.onAllergenSubmit = function () {
      if (typeof vm.id !== 'undefined' && vm.name) {
        var newAllergen = new Allergen({
          easyID: vm.id,
          name: vm.name
        });
        newAllergen.save().then(function (allergen) {
          var instanceAllergen = allergensManager.set(allergen);
          vm.allergens.push(instanceAllergen);
          alert.push('success', 'Nouveau rayon ajouté en base de données');
        }, function (error) {
          //TOOD préciser si déja en base de données ou quoi
          alert.push('danger', 'Rayon non ajouté en base de données');
        });
      }
    };
  }
})();
(function () {
  angular.module('meanApp').controller('departmentsCtrl', departmentsCtrl);
  departmentsCtrl.$inject = ['$location', 'departmentsManager', 'allergensManager', 'featuresManager', 'Department', '$rootScope', 'alert', '$scope', 'confirmationModal'];
  function departmentsCtrl($location, departmentsManager, allergensManager, featuresManager, Department, $rootScope, alert, $scope, confirmationModal) {
    var vm = this;
    //console.log('the current user is ', $rootScope.currentUser);
    vm.departments = [];
    vm.selectedAllergens = [];
    vm.selectedFeatures = [];
    $rootScope.$watch('currentUser', function () {
      if ($rootScope.currentUser) {
        if ($rootScope.currentUser.role === 'admin') {
          loadDepartments();
          loadAllergens();
          loadFeatures();
        } else {
          $location.path('/');
        }
      }
    }, function (err) {
      console.log(err);
    });
    var loadDepartments = function loadDepartments() {
      departmentsManager.getAll().then(function (result) {
        vm.departments = result.collection;
      }, function (err) {
        console.log('error loafing all departments');
      });
    };
    var loadAllergens = function loadAllergens() {
      allergensManager.getAll().then(function (result) {
        vm.initAllergens = result.collection;
        vm.allergens = result.collection;
      }, function (err) {
        console.log('error loafing all departments');
      });
    };
    var loadFeatures = function loadFeatures() {
      featuresManager.getAll().then(function (result) {
        vm.initFeatures = result.collection;
        vm.features = result.collection;
      }, function (err) {
        console.log('error loafing all departments');
      });
    };
    vm.confirmationQuestion = 'Voulez vous vraiment supprimer ce rayon ?';
    vm.onConfirmationModalClick = function () {
      departmentsManager["delete"]($scope.departmentIDToDelete).then(function () {
        this.$close();
        alert.push('success', 'Cette mesure a été supprimée définitivement de la base de données');
      }.bind($scope), function () {
        this.$close();
        alert.push('danger', "Cette mesure n'a pas pu être supprimée");
      }.bind($scope));
    };
    vm.removeDepartment = function (id) {
      $scope.departmentIDToDelete = id;
      $scope.modalInstance = confirmationModal.open($scope, 'departmentsCtrl');
    };
    vm.onReset = function () {
      //TODO reset the model binded
      vm.id = '';
      vm.name = '';
      vm.allergens.forEach(function (allergen) {
        allergen.selected = false; //reinit all the allergens
      });
      vm.features.forEach(function (feature) {
        feature.selected = false; //reinit all the allergens
      });
    };
    vm.editDepartment = function (department) {
      vm.editionMode = true;
      vm._id = department._id;
      vm.id = department.easyID;
      vm.name = department.name;
      vm.allergens.forEach(function (allergen) {
        allergen.selected = false; //reinit all the allergens
        //then apply the allergens from the backend
        department.probableAllergens.forEach(function (allergenBackEnd) {
          if (allergenBackEnd._id === allergen._id) {
            allergen.selected = true;
          }
        });
      });
      vm.features.forEach(function (feature) {
        feature.selected = false; //reinit all the allergens
        //then apply the allergens from the backend
        department.probableFeatures.forEach(function (featureBackEnd) {
          if (featureBackEnd._id === feature._id) {
            feature.selected = true;
          }
        });
      });
    };
    vm.onDepartmentSubmit = function () {
      if (vm.editionMode === true) {
        //retrieve the department
        departmentsManager.get(vm._id).then(function (department) {
          department.update({
            easyID: vm.id,
            name: vm.name,
            probableAllergens: vm.allergens.filter(function (allergen) {
              return allergen.selected === true;
            }),
            probableFeatures: vm.features.filter(function (allergen) {
              return allergen.selected === true;
            })
          }).then(function () {
            alert.push('success', 'Le rayon a été mis à jour en base de données');
          }, function (error) {
            alert.push('danger', "Le rayon n'a pas été mis à jour en base de données");
          });
        });
      } else {
        if (typeof vm.id !== 'undefined' && vm.name) {
          var newDepartment = new Department({
            easyID: vm.id,
            name: vm.name,
            probableAllergens: vm.allergens.filter(function (allergen) {
              return allergen.selected === true;
            }),
            probableFeatures: vm.features.filter(function (allergen) {
              return allergen.selected === true;
            })
          });
          newDepartment.save().then(function (department) {
            var instanceAllergen = departmentsManager.set(department);
            vm.departments.push(instanceAllergen);
            vm.onReset();
            alert.push('success', 'Nouveau rayon ajouté en base de données');
          }, function (error) {
            //TOOD préciser si déja en base de données ou quoi
            alert.push('danger', 'Rayon non ajouté en base de données');
          });
        }
      }
    };
  }
})();
(function () {
  angular.module('meanApp').controller('featuresCtrl', featuresCtrl);
  featuresCtrl.$inject = ['$location', 'featuresManager', 'Feature', '$rootScope', 'alert', '$scope', 'confirmationModal'];
  function featuresCtrl($location, featuresManager, Feature, $rootScope, alert, $scope, confirmationModal) {
    var vm = this;
    //console.log('the current user is ', $rootScope.currentUser);
    vm.features = {};
    $rootScope.$watch('currentUser', function () {
      if ($rootScope.currentUser) {
        if ($rootScope.currentUser.role === 'admin') {
          loadFeatures();
        } else {
          $location.path('/');
        }
      }
    }, function (err) {
      console.log(err);
    });
    var loadFeatures = function loadFeatures() {
      featuresManager.getAll().then(function (result) {
        vm.features = result.collection;
      }, function (err) {
        console.log('error loafing all features');
      });
    };
    vm.confirmationQuestion = 'Voulez vous vraiment supprimer cette propriété de recette ?';
    vm.onConfirmationModalClick = function () {
      featuresManager["delete"]($scope.featureIDToDelete).then(function () {
        this.$close();
        alert.push('success', 'Cette propriété a été supprimée définitivement de la base de données');
      }.bind($scope), function () {
        this.$close();
        alert.push('danger', "Cet propriété n'a pas pu être supprimée");
      }.bind($scope));
    };
    vm.removeFeature = function (id) {
      $scope.featureIDToDelete = id;
      $scope.modalInstance = confirmationModal.open($scope, 'featuresCtrl');
    };
    vm.onFeatureSubmit = function () {
      if (typeof vm.id !== 'undefined' && vm.name) {
        var newFeature = new Feature({
          easyID: vm.id,
          name: vm.name
        });
        newFeature.save().then(function (feature) {
          var instanceFeature = featuresManager.set(feature);
          vm.features.push(instanceFeature);
          alert.push('success', 'Nouveau feature ajouté en base de données');
        }, function (error) {
          //TOOD préciser si déja en base de données ou quoi
          alert.push('danger', 'Feature non ajouté en base de données');
        });
      }
    };
  }
})();
(function () {
  angular.module('meanApp').controller('ingredientsCtrl', ingredientsCtrl);
  ingredientsCtrl.$inject = ['$location', '$state', 'measuresManager', 'departmentsManager', 'allergensManager', 'ingredientsManager', 'productsManager', 'featuresManager', 'Ingredient', 'confirmationModal', '$rootScope', '$uibModal', 'alert', '$scope'];
  function ingredientsCtrl($location, $state, measuresManager, departmentsManager, allergensManager, ingredientsManager, productsManager, featuresManager, Ingredient, confirmationModal, $rootScope, $uibModal, alert, $scope) {
    var vm = this;

    //if on the edition of an ingredient :
    if ($location.path().indexOf('/ingredient/') > -1 && $location.path().indexOf('/edit') > -1) {
      ingredientsManager.get($state.params.slug).then(function (result) {
        vm.ingredient = result;
      }, function (err) {
        console.log('error loading the ingredient');
      });
    }
    vm.ingredients = []; //not used yet
    vm.ingredient = {};
    vm.measures = [];
    vm.departmentOptions = [];
    vm.allMonthsClickedStatus = false; //by default
    vm.ingredient.percentageFruitsAndVegetables = 0;
    //vm.ingredient.isSuperIngredient = false;

    // data for the sizing
    $scope.pixelSideEditor = {
      width: '100px',
      height: '100px'
    };
    $scope.imageSource = '';
    $scope.myCroppedImage = '';
    //$scope.pictureUploading = false;
    $scope.myAeraType = 'square';
    $scope.resultImageSize = 600;
    vm.monthsSoldInFrance = [{
      _id: 0,
      name: 'Jan'
    }, {
      _id: 1,
      name: 'Fev'
    }, {
      _id: 2,
      name: 'Mar'
    }, {
      _id: 3,
      name: 'Avr'
    }, {
      _id: 4,
      name: 'Mai'
    }, {
      _id: 5,
      name: 'Juin'
    }, {
      _id: 6,
      name: 'Juil'
    }, {
      _id: 7,
      name: 'Aou'
    }, {
      _id: 8,
      name: 'Sept'
    }, {
      _id: 9,
      name: 'Oct'
    }, {
      _id: 10,
      name: 'Nov'
    }, {
      _id: 11,
      name: 'Dec'
    }];
    vm.onSearchOpenFood = function () {
      productsManager.search(vm.searchIngredient, 30).then(function (result) {
        vm.superIngredientsSearchResult = result;
        var categories = {},
          categoryValue,
          mostUsedCategory,
          nbResult = vm.superIngredientsSearchResult.length;
        vm.superIngredientsSearchResult.forEach(function (item, indexProduct) {
          //find the most popular categories for the first ingredients
          if (indexProduct < 11) {
            item.categories_hierarchy.forEach(function (category) {
              categoryValue = categories[category];
              categories[category] = typeof categoryValue !== 'undefined' ? categoryValue + 2 : 2;
            });
          }
        });
        console.log('categories are', categories);

        //find the most common category
        Object.keys(categories).forEach(function (key) {
          if (!mostUsedCategory) {
            mostUsedCategory = key;
          } else if (categories[key] > categories[mostUsedCategory]) {
            mostUsedCategory = key;
          }
        });
        vm.superIngredientsSearchResult.forEach(function (item, indexItem) {
          //find the most popular categories
          var score = 0,
            itemCatLength = item.categories_hierarchy.length;
          item.categories_hierarchy.forEach(function (category) {
            categoryValue = categories[category] || 0.6;
            score += categoryValue / itemCatLength / (indexItem + 1); //make it square so it is even mote insignificant if only product within a category
          });
          console.log('score is ', score);
          item.selected = score >= 1;
        });
      }, function (err) {
        console.log('erreur loading search results from OpenFood');
        console.log(err);
      });
    };
    vm.onAllMonthsClicked = function () {
      vm.monthsSoldInFrance.forEach(function (item) {
        item.active = !vm.allMonthsClickedStatus;
      });
      vm.allMonthsClickedStatus = !vm.allMonthsClickedStatus;
    };
    vm.onDepartmentChange = function () {
      console.log('department id picked is ', vm.ingredient.department);
      var department = vm.departmentOptions.filter(function (department) {
        return department._id === vm.ingredient.department;
      });

      //only for data coming from
      if (department[0] && vm.isOpenFoodDB !== true) {
        vm.probableAllergens = department[0].probableAllergens;
        vm.probableFeatures = department[0].probableFeatures;

        //and reinit the allergenrisk and features
        //vm.ingredient.allergensRisk= [];
        //vm.ingredient.features= [];
      }
    };
    var setOptimizedWidthAndHeight = function setOptimizedWidthAndHeight(width, height) {
      //compute a square but not larger than 400px max
      var minSide = Math.min(width, height),
        minSideIsWidth = minSide === width,
        effectiveSide = 100,
        effectiveHeight,
        effectiveWidth;
      if (minSide > 400) {
        effectiveSide = 400;
      } else if (minSide > 100) {
        effectiveSide = minSide;
      }
      if (!minSideIsWidth) {
        effectiveWidth = effectiveSide;
        effectiveHeight = parseInt(effectiveWidth * height / width, 10);
      } else {
        effectiveHeight = effectiveSide;
        effectiveWidth = parseInt(width * effectiveHeight / height, 10);
      }
      var widthAvailable = window.document.getElementsByClassName('website-container')[0].offsetWidth - 20; //remove the margins

      //regulate the width
      if (widthAvailable < effectiveWidth) {
        effectiveWidth = widthAvailable;
        effectiveHeight = parseInt(height * effectiveWidth / width);
      }
      $scope.pixelSideEditor = {
        width: effectiveWidth + 'px',
        height: effectiveHeight + 'px'
      };
    };
    vm.onFileChange = function (imageSource, width, height) {
      $scope.imageSource = imageSource;
      console.log('image width is ' + width, 'height', height);
      setOptimizedWidthAndHeight(width, height);

      //here open a modal in order to edit the picture
      vm.modal = $uibModal.open({
        templateUrl: 'profile/change.picture.modal.view.html',
        scope: $scope,
        backdrop: 'static'
      });
      vm.modal.rendered.then(function () {
        console.log('modal change picture is rendered');
        //this.document.body.get modal-content
        var widthAvailable = window.document.getElementsByClassName('modal-content')[0].offsetWidth - 20;
        //what if prortrait image ?
        if (widthAvailable < width) {
          $scope.pixelSideEditor = {
            width: widthAvailable + 'px',
            height: parseInt(height * widthAvailable / width) + 'px'
          };
          //$scope.$apply();
        }
      });
    };
    var dataURLtoFile = function dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {
        type: mime
      });
    };

    //TODO rename the function to someone more generic
    $scope.saveProfilePicture = function () {
      var fileBuiltFromeBase64 = dataURLtoFile(this.myCroppedImage, 'recipe'),
        fd = new FormData();
      fd.append('file', fileBuiltFromeBase64); //pass the file newly created

      /**Object.keys(vm.recipe).forEach(function(key) {
      	fd.append(key, JSON.stringify((vm.recipe[key])));
      });**/
      console.log($scope, this);
      //$scope.pictureUploading = true;
      //this.pictureUploading = true;
      console.log('the filename is', fileBuiltFromeBase64.filename);
      //put the button in loading mode

      console.log('the recipe object is', vm.ingredient);
      if (vm.ingredient._id) {
        console.log('todo save ingredient picture to back end');
        vm.ingredient.updateWithPicture(fd).then(function (ingredient) {
          vm.modal.close();
          alert.push('success', 'Image sauvegardée');
        });
        //save using PUT with just the image
        /**vm.recipe.updateWithPicture(fd).then(function(recipe) {
        	//then get the ID and put it into the recipe object :)
        	//angular.extend(vm.recipe, recipe);
        	//vm.recipe = recipe;
        	//console.log('thumb construction', vm.recipe.getThumb('s'));
        		this.modal.close();
        	alert.push('success', 'Image sauvegardée');
        }.bind(this), function(error) {
        	//TOOD préciser si déja en base de données ou quoi
        	alert.push('danger', "Votre image n'a pu être sauvegardée");
        });**/
      } else {
        // create and POST the recipe
        //TODO transform the recipe in a suitable structure for the API
        /**var newRecipe = new Recipe(vm.recipe); //pass the parameters as init
        newRecipe.saveAsDraft(fd).then(function(recipe) {
        	//then get the ID and put it into the recipe object :)
        	//angular.extend(vm.recipe, recipe);
        	vm.recipe = recipe;
        	console.log('thum construction', vm.recipe.getThumb('s'));
        		this.modal.close();
        	alert.push('success', 'Image sauvegardée');
        }.bind(this), function(error) {
        	//TOOD préciser si déja en base de données ou quoi
        	alert.push('danger', "Votre image n'a pu être sauvegardée");
        });**/
      }
    };
    vm.onPrefillClick = function () {
      //TODO set more matching between allergens and easyIDs
      //TOOD put the stuff in the allergen model or somewhere else but not here
      var matchingBetweenOpenFoodAllergensAndEasyID = {
          'en:gluten': 0,
          'en:milk': 6,
          'en:eggs': 2,
          'en:mustard': 9,
          'en:fish': 3
        },
        allergenFiltered = [],
        featureFiltered = [];

      //1- prefill the probableAllergens and features
      vm.probableAllergens = vm.allergens;
      //for each allergen proba set active in the
      vm.allergensProbability.forEach(function (allergenRisk) {
        //set the risk and if active
        var allergenFiltered = vm.probableAllergens.filter(function (allergen) {
          return allergen.easyID === matchingBetweenOpenFoodAllergensAndEasyID[allergenRisk.name];
        });
        if (allergenFiltered[0]) {
          allergenFiltered[0].risk = allergenRisk.percent;
          allergenFiltered[0].active = true;
          allergenFiltered[0].risk = allergenFiltered[0].getRisk();
        }
      });
      vm.probableFeatures = vm.features;
      vm.probableFeatures.forEach(function (feature) {
        var selected, filtered, isFeature;
        switch (feature.easyID) {
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 7:
          case 8:
            //for each ingredient must have the ID feature
            selected = true;
            vm.matchedIngredients.forEach(function (ingredient) {
              //take the ingredient selected
              match = ingredient.matches.filter(function (item) {
                return item.selected === true;
              });
              if (match[0]) {
                //now check the presence of the feature or not
                isFeature = match[0].features.filter(function (featureItem) {
                  return featureItem.easyID === feature.easyID;
                });
                selected = selected && isFeature.length > 0;
              }
            });
            break;
          case 6:
            selected = false;
            vm.matchedIngredients.forEach(function (ingredient) {
              //take the ingredient selected
              match = ingredient.matches.filter(function (item) {
                return item.selected === true;
              });
              if (match[0]) {
                //now check the presence of the feature or not
                isFeature = match[0].features.filter(function (featureItem) {
                  return featureItem.easyID === feature.easyID;
                });
                selected = selected || isFeature.length > 0;
              }
            });
            break;
          default:
            console.log('nothing to do');
        }
        feature.active = selected;
      });
      var measures;
      //now fill the quantities
      if (vm.isLiquid) {
        //check the ml measure
        measures = vm.measures.filter(function (measure) {
          return measure.easyID === 2;
        });
        if (measures[0]) {
          measures[0].active = true;
          vm.onMeasureChange(measures[0]);
        }
      } else {
        //check the g measure
        measures = vm.measures.filter(function (measure) {
          return measure.easyID === 0;
        });
        if (measures[0]) {
          measures[0].active = true;
          vm.onMeasureChange(measures[0]);
        }
      }
      vm.ingredient.novaGroup = parseInt(vm.algoResult.averageNovaGroup.average);
      vm.ingredient.percentageFruitsAndVegetables = vm.algoResult.averageFruitsAndVegetables.average;
    };
    $rootScope.$watch('currentUser', function () {
      if ($rootScope.currentUser) {
        if ($rootScope.currentUser.role === 'admin') {
          loadIngredients();
          loadAllergens();
          loadFeatures();
          loadDepartments();
          loadMeasures();
        } else {
          $location.path('/');
        }
      }
    }, function (err) {
      console.log(err);
    });
    var loadAllergens = function loadAllergens() {
      allergensManager.getAll().then(function (result) {
        vm.allergens = result.collection;
      }, function (err) {
        console.log('error loading all allergens');
      });
    };
    var loadFeatures = function loadFeatures() {
      featuresManager.getAll().then(function (result) {
        vm.features = result.collection;
      }, function (err) {
        console.log('error loading all features');
      });
    };
    var fillFeatures = function fillFeatures() {
      vm.probableFeatures = vm.features;
      var IDs = [];
      vm.ingredient.features.forEach(function (feature) {
        IDs.push(feature._id);
      });
      vm.probableFeatures.forEach(function (feature) {
        feature.active = IDs.indexOf(feature._id) > -1;
      });
    };
    var fillAllergens = function fillAllergens() {
      var IDs = [];
      vm.ingredient.allergensRisk.forEach(function (allergenRisk) {
        if (allergenRisk.risk) {
          IDs.push(allergenRisk.allergen._id);
        }
      });
      vm.probableAllergens = vm.allergens;
      vm.probableAllergens.forEach(function (allergen) {
        allergen.active = IDs.indexOf(allergen._id) > -1;
        if (allergen.active === true) {
          vm.ingredient.allergensRisk.forEach(function (allergenRisk) {
            if (allergenRisk.allergen._id === allergen._id) {
              allergen.risk = allergenRisk.risk;
            }
          });
        }
      });
    };
    var fillMeasures = function fillMeasures() {
      /**var IDs = [];
      vm.ingredient.measures.forEach(function(measure) {
      	IDs.push(measure._id);
      });**/

      vm.measures.forEach(function (measure) {
        measure.active = vm.ingredient.measures.indexOf(measure._id) > -1;
      });
      console.log('measures updated ', vm.measures);
    };
    var loadMeasures = function loadMeasures() {
      measuresManager.getAll().then(function (result) {
        vm.measures = result.collection;
        var measure,
          l = vm.measures.length;
        for (var i = 0, l; i < l; i++) {
          measure = vm.measures[i];
          measure.active = false; //to be merged for editing
          //to be merged when editing the measures
        }
      }, function (err) {
        console.log('error loafing all measures');
      });
    };
    var findMeasure = function findMeasure(easyID) {
      var arrayMeasureFiltered = vm.measures.filter(function (measure) {
        return measure.easyID === easyID;
      });
      return arrayMeasureFiltered[0] || null;
    };
    vm.onMeasureChange = function (measure) {
      var easyID = measure.easyID;
      //g and kg are the same
      if (easyID === 0) {
        findMeasure(1).active = measure.active;
      }
      if (easyID === 1) {
        findMeasure(0).active = measure.active;
      }

      //if g is set the others liquid are opposite
      if (easyID < 2 && measure.active) {
        findMeasure(2).active = !measure.active;
        findMeasure(3).active = !measure.active;
        findMeasure(4).active = !measure.active;
      }

      //ml cl and cl are the same
      if (easyID === 2) {
        findMeasure(3).active = measure.active;
        findMeasure(4).active = measure.active;
      }
      if (easyID === 3) {
        findMeasure(2).active = measure.active;
        findMeasure(4).active = measure.active;
      }
      if (easyID === 4) {
        findMeasure(3).active = measure.active;
        findMeasure(2).active = measure.active;
      }

      //if cl is set the others g are opposite and spoons are reset too
      if (easyID > 1 && easyID < 5 && measure.active) {
        findMeasure(0).active = !measure.active;
        findMeasure(1).active = !measure.active;
        if (measure.active === true) {
          findMeasure(5).active = true;
          findMeasure(6).active = true;
        }
      }

      //spoons quantities are always the same
      if (easyID === 5) {
        findMeasure(6).active = measure.active;
      }
      if (easyID === 6) {
        findMeasure(5).active = measure.active;
      }
      if (easyID === 7) {
        //if portion is selected make a field appear
        if (measure.active) {
          if (vm.algoResult) {
            vm.ingredient.servingQuantity = vm.algoResult.averageQuantity.average ? vm.algoResult.averageQuantity.average : 0;
          } else {
            vm.ingredient.servingQuantity = 100;
          }
        } else {
          vm.ingredient.servingQuantity = 0;
        }
      }
    };
    var loadDepartments = function loadDepartments() {
      departmentsManager.getAll().then(function (result) {
        vm.departmentOptions = result.collection;
        vm.departmentOptions.forEach(function (item, index) {
          if (index < 4) {
            item.type = "Légumes";
          } else if (index < 8) {
            item.type = "Fruits";
          } else if (index < 13) {
            item.type = "Boucherie";
          } else if (index < 18) {
            item.type = "Charcuterie";
          } else if (index < 22) {
            item.type = "Poissonnerie";
          } else if (index < 26) {
            item.type = "Boulangerie";
          } else if (index < 31) {
            item.type = "Lait, Beurre, Oeufs";
          } else if (index < 41) {
            item.type = "Fromages";
          } else if (index < 46) {
            item.type = "Yaourts";
          } else if (index < 51) {
            item.type = "Desserts";
          } else if (index < 54) {
            item.type = "Eaux";
          } else if (index < 59) {
            item.type = "Jus de fruits, sodas";
          } else if (index < 62) {
            item.type = "Bières et cidres";
          } else if (index < 65) {
            item.type = "Spiritueux";
          } else if (index < 71) {
            item.type = "Vins et Champagnes";
          } else if (index < 82) {
            item.type = "Epicerie salée";
          } else if (index < 88) {
            item.type = "Epicerie sucrée";
          } else if (index < 95) {
            item.type = "Petit déjeuner";
          } else if (index < 97) {
            item.type = "Produits du monde";
          } else if (index < 99) {
            item.type = "Dessert";
          }
        });

        //for each department add a group type
        vm.onDepartmentChange(); //in order to set the allergens and the features

        if ($location.path().indexOf('/ingredient/') > -1 && $location.path().indexOf('/edit') > -1) {
          //fill features
          fillFeatures();
          fillAllergens();
          fillMeasures();
          vm.monthsSoldInFrance.forEach(function (monthNumber) {
            monthNumber.active = vm.ingredient.monthsSoldInFrance.indexOf(monthNumber._id) > -1;
          });
        }

        //vm.monthsSoldInFrance.
      }, function (err) {
        console.log('error loafing all departments for ingredients creation');
      });
    };
    var loadIngredients = function loadIngredients() {
      //TODOdo a pagination
      ingredientsManager.getAll().then(function (result) {
        vm.ingredients = result.collection;
      }, function (err) {
        console.log('erreur loading all profiles');
        console.log(err);
      });
    };
    vm.onAddIngredient = function (isEditMode) {
      //reinit the values
      vm.ingredient.measures = [];
      vm.ingredient.monthsSoldInFrance = [];
      vm.ingredient.allergensRisk = [];
      vm.ingredient.features = [];
      var reducedArray = [];
      //retrieve the measures and put it on the ingredient structure
      if (vm.measures && vm.measures.length > 0) {
        reducedArray = vm.measures.filter(function (item) {
          return item.active === true;
        });
        reducedArray.forEach(function (item) {
          vm.ingredient.measures.push(item._id);
        });
      }
      reducedArray = vm.monthsSoldInFrance.filter(function (item) {
        return item.active === true;
      });
      reducedArray.forEach(function (item) {
        vm.ingredient.monthsSoldInFrance.push(item._id);
      });
      if (vm.probableAllergens && vm.probableAllergens.length > 0) {
        reducedArray = vm.probableAllergens.filter(function (item) {
          return item.active === true;
        });
        reducedArray.forEach(function (item) {
          vm.ingredient.allergensRisk.push({
            risk: item.risk || 'HIGH',
            //by default risk is high
            allergen: item._id
          });
        });
      }
      if (vm.probableFeatures && vm.probableFeatures.length > 0) {
        reducedArray = vm.probableFeatures.filter(function (item) {
          return item.active === true;
        });
        reducedArray.forEach(function (item) {
          vm.ingredient.features.push(item._id);
        });
      }
      if (vm.matchedIngredients) {
        var matchedIngredient;
        vm.ingredient.ingredients = [];
        vm.matchedIngredients.forEach(function (ingredient) {
          matchedIngredient = ingredient.matches.filter(function (match) {
            return match.selected === true;
          });
          if (matchedIngredient[0]) {
            vm.ingredient.ingredients.push(matchedIngredient[0]._id);
          }
        });
      }
      var matchingNutrientKeyDB = {
        'averageFiber': 291,
        'averageEnergy': 208,
        'averageCarbohydrates': 205,
        'averageFat': 204,
        'averageSaturatedFat': 606,
        'averageProtein': 203,
        'averageSodium': 307,
        'averageSugar': 269
      };

      //read all the keys
      var nutrientsQuantity = [];
      if (vm.algoResult) {
        Object.keys(vm.algoResult).forEach(function (key) {
          if (matchingNutrientKeyDB[key]) {
            nutrientsQuantity.push({
              quantity: vm.algoResult[key].average,
              nutrient: matchingNutrientKeyDB[key]
            });
          }
        });
      }
      if (nutrientsQuantity.length) {
        vm.ingredient.nutrientsQuantity = nutrientsQuantity;
      }
      if (vm.sortedProducts) {
        vm.ingredient.IDOpenDB = vm.sortedProducts[vm.indexProductChosen].id;
      }
      console.log(vm.ingredient);
      if (isEditMode === true) {
        vm.ingredient.update(vm.ingredient).then(function () {
          alert.push('success', "L'ingrédient a été mis à jour");
        }, function () {
          alert.push('danger', "L'ingrédient n'a pas été mis à jour, veuillez réessayer ultérieurement");
        });
      } else {
        var newIngredient = new Ingredient(vm.ingredient);
        newIngredient.save().then(function (ingredient) {
          var instanceIngredient = ingredientsManager.set(ingredient);
          vm.ingredients.push(instanceIngredient);
          alert.push('success', 'Nouvel ingrédient ajouté en base de données');
        }, function (error) {
          //TODO préciser si déja en base de données ou quoi
          alert.push('danger', 'Ingredient non ajouté en base de données');
        });
      }
    };
    vm.confirmationQuestion = 'Voulez vous vraiment supprimer cet ingrédient ?';
    vm.onConfirmationModalClick = function () {
      ingredientsManager["delete"]($scope.ingredientIDToDelete).then(function () {
        this.$close();
        alert.push('success', 'Cet ingrédient a été supprimé définitivement de la base de données');
      }.bind($scope), function () {
        this.$close();
        alert.push('danger', "Cet ingrédient n'a pas pu être supprimé");
      }.bind($scope));
    };
    vm.removeIngredient = function (id) {
      $scope.ingredientIDToDelete = id;
      $scope.modalInstance = confirmationModal.open($scope, 'ingredientsCtrl');
    };
    var setMatchingIngredients = function setMatchingIngredients(product, onComplete, onFailure) {
      var ingredientOfProduct = product.ingredients,
        ingredientName,
        index = 0,
        length = ingredientOfProduct.length;
      ingredientOfProduct.forEach(function (ingredient) {
        ingredientName = ingredient.text;
        //TODO maybe here remove some unwanted characters (set a list of carachters to be removed ?)
        ingredientName = ingredientName.replace(new RegExp('_', 'g'), '');
        ingredientsManager.search(ingredientName).then(function (results) {
          //TODO if no result for one of the ingredient then return the onFailure callback function !!!
          if (results[0]) {
            results[0].selected = true; //always select first item returned
          }
          this.matches = results;
          index++;
          if (index === length) {
            onComplete();
          }
          //TODO send result to view only when ALL ingredients have been computed
          //TODO 2 what about if there is never a product that can fit all ingredients ?
        }.bind(ingredient), function (err) {
          console.log('erreur loading all profiles');
          console.log(err);
        });
      });
    };
    vm.onMatchedIngredientClick = function (matchedIngredient, ingredientMatches) {
      ingredientMatches.forEach(function (item) {
        item.selected = item._id === matchedIngredient._id;
      });
    };

    //this remove ingredient from the matching ingredients
    vm.onRemoveMatchedIngredient = function (ingredient, matchedIngredients) {
      vm.matchedIngredients = matchedIngredients.filter(function (ingredientItem) {
        return ingredientItem.id !== ingredient.id;
      });
    };
    vm.onAlgorithmClick = function () {
      //0- products that have been unselected
      //0.1 TODO maybe try to find the irrelevant products and eliminate them (by department maybe ???)
      //1- find all the products that have been selected

      var productsFiltered = vm.superIngredientsSearchResult.filter(function (product) {
          return product.selected === true; //temporary until we have test terminated
        }),
        averages = {
          averageNovaGroup: {},
          averageFruitsAndVegetables: {},
          averageFiber: {},
          //fibres
          averageEnergy: {},
          //en KJ 
          averageCarbohydrates: {},
          //glucides
          averageFat: {},
          //all the fat
          averageSaturatedFat: {},
          //saturated fat
          averageQuantity: {},
          averageProtein: {},
          //proteines
          averageSalt: {},
          //sel
          averageSodium: {},
          //sodium
          averageSugar: {} //sucres
        },
        allergensCount = {},
        liquidCount = 0,
        solidCount = 0;
      Object.keys(averages).forEach(function (key) {
        averages[key] = {
          counter: 0,
          average: 0
        };
      });

      //2- compute the average:
      //2.1 nova
      //2.2 nutriscores //no must be computed later on
      //2.3 percentageFruitsAndVegetables
      //2.4 nutriments facts including fiber
      //2.5 what allergens are high risk or low risk  
      //2.6 if only low risk then extend the search number ? and go to 1.

      productsFiltered.forEach(function (product, index) {
        //TEMPORARY TRY to find all the product quantity and the quantity itself

        var nutriments = product['nutriments'],
          nova_group = product['nova_group'],
          fruits_vegetables_nuts_100g_estimate = product['fruits-vegetables-nuts_100g_estimate'],
          product_quantity = product['product_quantity'],
          quantity = product['quantity'] ? product['quantity'].toLowerCase() : '',
          allergens = product['allergens_tags'];
        allergens.forEach(function (allergen) {
          var counter = allergensCount[allergen];
          if (typeof counter === 'undefined') {
            allergensCount[allergen] = 1;
          } else {
            allergensCount[allergen]++;
          }
        });
        if (quantity.indexOf(' l') > 0 || quantity.indexOf(' cl') > 0 || quantity.indexOf(' ml') > 0) {
          liquidCount++;
        }
        if (quantity.indexOf(' g') > 0) {
          solidCount++;
        }

        //TODO factorize all these function, amount of lines can be reduced
        if (typeof nova_group !== 'undefined' && parseFloat(nova_group) > 0) {
          averages['averageNovaGroup'].average += parseFloat(nova_group);
          averages['averageNovaGroup'].counter++;
        }
        if (typeof fruits_vegetables_nuts_100g_estimate !== 'undefined' && parseFloat(fruits_vegetables_nuts_100g_estimate) > 0) {
          averages['averageFruitsAndVegetables'].average += parseFloat(fruits_vegetables_nuts_100g_estimate);
          averages['averageFruitsAndVegetables'].counter++;
        }
        if (typeof nutriments.fiber_100g !== 'undefined' && parseFloat(nutriments.fiber_100g) > 0) {
          averages['averageFiber'].average += parseFloat(nutriments.fiber_100g);
          averages['averageFiber'].counter++;
        }
        if (typeof nutriments.energy_value !== 'undefined' && parseFloat(nutriments.energy_value) > 0) {
          averages['averageEnergy'].average += nutriments.energy_unit === 'kcal' ? parseFloat(nutriments.energy_value) : parseFloat(nutriments.energy_value) / 4.184; //convert in kcal ? YES otherwise creates issues
          averages['averageEnergy'].counter++;
        }
        if (typeof nutriments.carbohydrates_100g !== 'undefined' && parseFloat(nutriments.carbohydrates_100g) > 0) {
          averages['averageCarbohydrates'].average += parseFloat(nutriments.carbohydrates_100g);
          averages['averageCarbohydrates'].counter++;
        }
        if (typeof nutriments.fat_100g !== 'undefined' && parseFloat(nutriments.fat_100g) > 0) {
          averages['averageFat'].average += parseFloat(nutriments.fat_100g);
          averages['averageFat'].counter++;
        }
        if (typeof nutriments['saturated-fat_100g'] !== 'undefined' && parseFloat(nutriments['saturated-fat_100g']) > 0) {
          averages['averageSaturatedFat'].average += parseFloat(nutriments['saturated-fat_100g']);
          averages['averageSaturatedFat'].counter++;
        }
        if (typeof product_quantity !== 'undefined' && parseFloat(product_quantity) > 0) {
          averages['averageQuantity'].average += parseFloat(product_quantity);
          averages['averageQuantity'].counter++;
        }
        if (typeof nutriments['proteins_100g'] !== 'undefined' && parseFloat(nutriments['proteins_100g']) > 0) {
          averages['averageProtein'].average += parseFloat(nutriments['proteins_100g']);
          averages['averageProtein'].counter++;
        }
        if (typeof nutriments['salt_100g'] !== 'undefined' && parseFloat(nutriments['salt_100g']) > 0) {
          averages['averageSalt'].average += parseFloat(nutriments['salt_100g']);
          averages['averageSalt'].counter++;
        }
        if (typeof nutriments['sodium_100g'] !== 'undefined' && parseFloat(nutriments['sodium_100g']) > 0) {
          averages['averageSodium'].average += parseFloat(nutriments['sodium_100g']);
          averages['averageSodium'].counter++;
        }
        if (typeof nutriments['sugars_100g'] !== 'undefined' && parseFloat(nutriments['sugars_100g']) > 0) {
          averages['averageSugar'].average += parseFloat(nutriments['sugars_100g']);
          averages['averageSugar'].counter++;
        }
      });

      //TODO maybe extend the number of products if allergens is always present to see if there is some alternative ???
      Object.keys(averages).forEach(function (key) {
        if (averages[key].counter !== 0) {
          console.log('for ' + key + ' the global sum is' + averages[key].average);
          averages[key].average = averages[key].average / averages[key].counter;
          if (key === 'averageSodium') {
            averages[key].average = averages[key].average * 1000; //convert into mg
          }
          if (key === 'averageNovaGroup') {
            averages[key].average = Math.round(averages[key].average);
          }
          averages[key].average = Math.round(averages[key].average * 10) / 10;
        }
      });
      vm.algoResult = averages;
      console.log(averages);
      console.log(allergensCount);
      console.log('number of products studied' + productsFiltered.length);

      //3- find the ingredients into it by taking the product with the less number of ingredients
      vm.sortedProducts = productsFiltered.sort(function (item1, item2) {
        var length1 = item1.ingredients ? item1.ingredients.length : 0,
          length2 = item2.ingredients ? item2.ingredients.length : 0,
          ans = 0;
        if ((length1 === 0 || length2 === 0) && length1 + length2 !== 0) {
          ans = length1 === 0 ? 1 : -1;
        } else if (length1 > length2) {
          ans = 1;
        } else if (length1 < length2) {
          ans = -1;
        }
        return ans;
      });

      //console.log('Shortest ingredients', productsFiltered[0].ingredients);

      vm.allergensProbability = [];
      Object.keys(allergensCount).forEach(function (allergen) {
        vm.allergensProbability.push({
          name: allergen,
          percent: Math.round(100 * (allergensCount[allergen] / productsFiltered.length))
        });
      });

      //TEST API TEMPORARY
      //var stringSearch = 'wheat flour';
      vm.indexProductChosen = 0;
      vm.lengthProductChosen = productsFiltered.length;
      //3.1 match by doing search on the ingredients database
      //3.2 if all the ingredients do not match take the second product with less ingredients ?

      vm.onNewProductChosen();
      vm.isLiquid = liquidCount > solidCount;
    };
    vm.onNewProductChosen = function (goNext) {
      if (typeof goNext !== 'undefined') {
        console.log('gotnext is', goNext);
        if (goNext === true) {
          vm.indexProductChosen++;
        } else {
          vm.indexProductChosen--;
        }
      }
      console.log('typeof indexproduct chosen', _typeof(vm.indexProductChosen));
      setMatchingIngredients(vm.sortedProducts[vm.indexProductChosen], function () {
        vm.matchedIngredients = vm.sortedProducts[vm.indexProductChosen].ingredients;
        console.log('matched ingredients are', vm.matchedIngredients);
      });
    };
  }
})();
(function () {
  angular.module('meanApp').controller('measuresCtrl', measuresCtrl);
  measuresCtrl.$inject = ['$location', 'measuresManager', 'Measure', '$rootScope', 'alert', '$scope', 'confirmationModal'];
  function measuresCtrl($location, measuresManager, Measure, $rootScope, alert, $scope, confirmationModal) {
    var vm = this;
    //console.log('the current user is ', $rootScope.currentUser);
    vm.measures = {};
    $rootScope.$watch('currentUser', function () {
      if ($rootScope.currentUser) {
        if ($rootScope.currentUser.role === 'admin') {
          loadMeasures();
        } else {
          $location.path('/');
        }
      }
    }, function (err) {
      console.log(err);
    });
    var loadMeasures = function loadMeasures() {
      measuresManager.getAll().then(function (result) {
        vm.measures = result.collection;
      }, function (err) {
        console.log('error loafing all measures');
      });
    };
    vm.confirmationQuestion = 'Voulez vous vraiment supprimer cette mesure ?';
    vm.onConfirmationModalClick = function () {
      measuresManager["delete"]($scope.measureIDToDelete).then(function () {
        this.$close();
        alert.push('success', 'Cette mesure a été supprimée définitivement de la base de données');
      }.bind($scope), function () {
        this.$close();
        alert.push('danger', "Cette mesure n'a pas pu être supprimée");
      }.bind($scope));
    };
    vm.removeMeasure = function (id) {
      $scope.measureIDToDelete = id;
      $scope.modalInstance = confirmationModal.open($scope, 'measuresCtrl');
    };
    vm.onMeasureSubmit = function () {
      if (typeof vm.id !== 'undefined' && vm.name) {
        var newMeasure = new Measure({
          easyID: vm.id,
          name: vm.name
        });
        newMeasure.save().then(function (measure) {
          var instanceMeasure = measuresManager.set(measure);
          vm.measures.push(instanceMeasure);
          alert.push('success', 'Nouvelle mesure ajoutée en base de données');
        }, function (error) {
          //TOOD préciser si déja en base de données ou quoi
          alert.push('danger', 'Mesure non ajoutée en base de données');
        });
      }
    };
  }
})();
(function () {
  angular.module('meanApp').controller('recipesAdminCtrl', recipesAdminCtrl);
  recipesAdminCtrl.$inject = ['$scope', '$location', 'recipesManager', '$rootScope', 'alert', 'confirmationModal'];
  function recipesAdminCtrl($scope, $location, recipesManager, $rootScope, alert, confirmationModal) {
    var vm = this;
    //console.log('the current user is ', $rootScope.currentUser);
    vm.recipes = {};
    vm.filters = {};
    vm.totalPages = 0;
    vm.totalNbRecipes = 0;
    vm.currentPage = 1;
    $rootScope.$watch('currentUser', function () {
      if ($rootScope.currentUser) {
        if ($rootScope.currentUser.role === 'admin') {
          loadRecipes();
        } else {
          $location.path('/');
        }
      }
    }, function (err) {
      console.log(err);
    });
    var loadRecipes = function loadRecipes() {
      recipesManager.getAllRecipesAdmin(vm.currentPage, vm.filters).then(function (result) {
        vm.recipes = result.collection;
        vm.totalPages = result.pages;
        vm.totalNbRecipes = result.total;
      }, function (err) {
        console.log('erreur loading all profiles');
        console.log(err);
      });
    };
    vm.pageChanged = function () {
      loadRecipes();
    };
    vm.filterOnDrafts = function () {
      vm.filters.isDraft = true;
      loadRecipes();
    };
    vm.executeCleverAlgo = function () {
      recipesManager.executeCleverAlgo();
    };
    vm.filterOnUnknownIngredients = function () {
      vm.filters.unknownIngredientsQuantity = true;
      loadRecipes();
    };
    vm.confirmationQuestion = 'Voulez vous vraiment supprimer cette recette ? Cette opération sera irréversible';
    vm.onConfirmationModalClick = function () {
      recipesManager["delete"]($scope.recipeIDToDelete).then(function () {
        this.$close();
        alert.push('success', 'Cette mesure a été supprimée définitivement de la base de données');
      }.bind($scope), function () {
        this.$close();
        alert.push('danger', "Cette mesure n'a pas pu être supprimée");
      }.bind($scope));
    };

    //just remove a recipe while calling API
    vm.removeRecipe = function (recipeId) {
      $scope.recipeIDToDelete = recipeId;
      $scope.modalInstance = confirmationModal.open($scope, 'recipesAdminCtrl');
    };

    /*vm.onEmailSubmit = function() {
            if (vm.email) {
                var newAuthorUser = recipesManager.set({
                    email: vm.email,
                    role: 'author'
                });
                newAuthorUser.save()
                .then(function (user) {
                    alert.push('success', 'Nouvel utililisateur ajouté en base de données');
                }, function (error) {
                    //TOOD préciser si déja en base de données ou quoi
                    alert.push('danger', 'Utilisateur non ajouté en base de données, car erreur');
                });
            }
        };*/

    vm.availableOptions = [{
      id: 'member',
      name: 'Membre'
    }, {
      id: 'author',
      name: 'Auteur'
    }, {
      id: 'admin',
      name: 'Administrateur',
      disabled: true
    }];
    vm.onChangeRole = function () {
      //conditions :
      //1- user that is admin cant have another role
      //2- no user can become admin through this interface

      //at least option has changed
      if (vm.selectedOption.id !== vm.searchUser.role) {
        vm.searchUser.update({
          role: vm.selectedOption.id
        }).then(function (user) {
          alert.push('success', 'Le role a bien ete changé');
        }, function (error) {
          //TOOD préciser si déja en base de données ou quoi
          alert.push('danger', 'role non changé, une erreur est survenue');
        });
      }
    };

    /*vm.onSearchUserSubmit = function() {
            if (vm.emailSearch) {
                usersManager.searchUserByEmail(vm.emailSearch)
                .then(function(user) {
                    vm.searchUser = user;
                    vm.selectedOption = { id : vm.searchUser.role};
                }, function(err) {
                    console.log('erreur searching the profile');
                    console.log(err);
                });
            }
        };*/
  }
})();
(function () {
  angular.module('meanApp').controller('usersCtrl', usersCtrl);
  usersCtrl.$inject = ['$location', 'usersManager', '$rootScope', 'alert'];
  function usersCtrl($location, usersManager, $rootScope, alert) {
    var vm = this;
    //console.log('the current user is ', $rootScope.currentUser);
    vm.users = {};
    vm.filters = {};
    vm.totalPages = 0;
    vm.totalUsers = 0;
    vm.currentPage = 1;
    $rootScope.$watch('currentUser', function () {
      if ($rootScope.currentUser) {
        if ($rootScope.currentUser.role === 'admin') {
          loadProfiles();
        } else {
          $location.path('/');
        }
      }
    }, function (err) {
      console.log(err);
    });
    var loadProfiles = function loadProfiles() {
      usersManager.getAllUsers(vm.currentPage, vm.filters).then(function (result) {
        console.log('users', result);
        vm.users = result.collection;
        vm.totalPages = result.pages;
        vm.totalUsers = result.total;
        console.log(vm.users[0].getInitials());
      }, function (err) {
        console.log('erreur loading all profiles');
        console.log(err);
      });
    };
    vm.pageChanged = function () {
      loadProfiles();
    };
    vm.toggleRoleFilter = function (filter) {
      if (filter) {
        vm.filters.role = filter;
        loadProfiles();
      }
    };
    vm.toggleProviderFilter = function (filter) {
      if (filter) {
        vm.filters.provider = filter;
        loadProfiles();
      }
    };
    vm.toggleActivationFilter = function (filter) {
      if (filter) {
        vm.filters.active = filter;
        loadProfiles();
      }
    };
    vm.removeUser = function (userId) {
      usersManager["delete"](userId).then(function () {
        alert.push('success', 'Cet utilisateur a été supprimé définitivement de la base de données');
        //loadProfiles();
      }, function () {
        alert.push('danger', "Cet utilisateur n'a pas pu être supprimé");
      });
    };
    vm.onEmailSubmit = function () {
      if (vm.email) {
        var newAuthorUser = usersManager.set({
          email: vm.email,
          role: 'author'
        });
        newAuthorUser.save().then(function (user) {
          alert.push('success', 'Nouvel utililisateur ajouté en base de données');
        }, function (error) {
          //TOOD préciser si déja en base de données ou quoi
          alert.push('danger', 'Utilisateur non ajouté en base de données, car erreur');
        });
      }
    };
    vm.availableOptions = [{
      id: 'member',
      name: 'Membre'
    }, {
      id: 'author',
      name: 'Auteur'
    }, {
      id: 'admin',
      name: 'Administrateur',
      disabled: true
    }];
    vm.onChangeRole = function () {
      //conditions : 
      //1- user that is admin cant have another role
      //2- no user can become admin through this interface

      //at least option has changed
      if (vm.selectedOption.id !== vm.searchUser.role) {
        vm.searchUser.update({
          role: vm.selectedOption.id
        }).then(function (user) {
          alert.push('success', 'Le role a bien ete changé');
        }, function (error) {
          //TOOD préciser si déja en base de données ou quoi
          alert.push('danger', 'role non changé, une erreur est survenue');
        });
      }
    };
    vm.onSearchUserSubmit = function () {
      if (vm.emailSearch) {
        usersManager.searchUserByEmail(vm.emailSearch).then(function (user) {
          vm.searchUser = user;
          vm.selectedOption = {
            id: vm.searchUser.role
          };
        }, function (err) {
          console.log('erreur searching the profile');
          console.log(err);
        });
      }
    };
  }
})();
(function () {
  angular.module('meanApp').controller('recipesDiscoveryCtrl', recipesDiscoveryCtrl);
  recipesDiscoveryCtrl.$inject = ['$scope', '$location', 'recipesManager', '$rootScope', 'alert', '$state', 'context', 'tagService'];
  function recipesDiscoveryCtrl($scope, $location, recipesManager, $rootScope, alert, $state, context, tagService) {
    var vm = this;
    //console.log('the current user is ', $rootScope.currentUser);
    vm.recipes = {};
    vm.filters = {};
    vm.totalPages = 0;
    vm.totalNbRecipes = 0;
    vm.currentPage = parseInt($state.params.page) || 1;
    //console.log('the page parameter is ', $state.params.page, vm.currentPage);
    //console.log(tagCtrl.matchingWording);
    vm.tagTranslated = tagService.wording[$state.params.tag];
    vm.tag = $state.params.tag;
    context.set({
      title: tagService.titles[$state.params.tag],
      contextName: 'Liste de recettes'
    });
    //https://stackoverflow.com/questions/16808107/how-to-generate-links-in-angular-ui-bootstrap-pagination
    //TODO : would be best to make a proper directive to not pollute the global scope
    //https://stackoverflow.com/questions/39371403/override-the-default-pagination-template-of-ui-bootstrap
    $rootScope.createRecipeHrefLink = function (pageNumber) {
      var tagName = $state.params.tag;
      if (pageNumber === 0 || pageNumber > vm.totalPages) {
        return '';
      }
      return '/recettes/tag/' + tagName + '/page/' + pageNumber;
    };
    var loadRecipes = function loadRecipes() {
      console.log('current page is ', vm.currentPage);
      recipesManager.searchRecipesAdvanced([$state.params.tag], vm.currentPage).then(function (recipes) {
        vm.test = 'prout';
        vm.currentPage = parseInt($state.params.page) || 1;
        vm.recipes = recipes.docs;
        vm.totalNbRecipes = parseInt(recipes.total);
        vm.totalPages = Math.ceil(vm.totalNbRecipes / 6);
      });
    };

    //trigger once
    loadRecipes();
    vm.pageChanged = function () {
      //loadRecipes();
    };
    //use this to generate links
    //https://stackoverflow.com/questions/16808107/how-to-generate-links-in-angular-ui-bootstrap-pagination
  }
})();
/* eslint-disable no-undef */
(function () {
  //this directive is used only for previewing the widget in fob.com

  angular.module('meanApp').controller('ingredientCtrl', ingredientCtrl);
  ingredientCtrl.$inject = ['$location', '$state', '$scope', 'ingredientsManager', 'context', 'nutritionService', 'tagService', 'colors', '$sce', '$compile'];
  function ingredientCtrl($location, $state, $scope, ingredientsManager, context, nutritionService, tagService, Colors, $sce, $compile) {
    var vm = this;
    var NUTRIENTS_WHITELIST_IDS = [291, 203, 208, 606, 307, 269];
    //console.log('the current user is ', $rootScope.currentUser);
    vm.ingredient = {};
    vm.interactions = {};
    vm.sliderOpen = false;
    vm.nutriscoreLetter = 'C'; //default for waiting the real result
    console.log($state.params.slug);
    vm.widgetPreviewOptions = {
      image: true,
      nutriscore: true,
      monthProduction: true,
      goodThings: true,
      badThings: true,
      nutritags: true
    };
    var date = new Date();
    vm.bulletLeft = parseInt(100 * (date.getMonth() * 29.5 + date.getDate()) / 366);
    vm.resetContext = function () {
      var actions = [{
        iconName: 'heart-o',
        actionTitle: 'Miam!' + (vm.interactions.isLiked ? ' ✔' : ''),
        dropdownActionCallback: function dropdownActionCallback() {
          vm.onLikeIngredient();
        }
      }, {
        iconName: 'dead',
        actionTitle: 'Beurk!' + (vm.interactions.isDisliked ? ' ✔' : ''),
        dropdownActionCallback: function dropdownActionCallback() {
          vm.ondislikeIngredient();
        }
      }, {
        iconName: 'widget',
        actionTitle: 'Widget',
        dropdownActionCallback: function dropdownActionCallback() {
          vm.goToWidgetisation();
        }
      }];
      if (navigator && navigator.share) {
        actions.push({
          iconName: 'share',
          actionTitle: 'Partager',
          dropdownActionCallback: function dropdownActionCallback() {
            navigator.share({
              title: vm.ingredient.name,
              url: document.URL,
              text: vm.ingredient.name + ' : Toutes les infos nutritionnelles sur Fraiseoubacon.com :)'
            });
          }
        });
      }
      context.set({
        title: vm.ingredient.name + ": toutes ses informations nutritionnelles",
        dropDownActions: actions,
        colorBackground: vm.ingredient.hexDominantColor
      });
    };
    console.log('ingreident controller, before the ingredientsmanager call');
    //this forces the call normally TODO optimize and cache if the call had already been made
    ingredientsManager.get($state.params.slug, true).then(function (result) {
      result.nutrientsQuantity = result.nutrientsQuantity.filter(function (nutrientsQuantity) {
        return nutrientsQuantity.nutrient && nutrientsQuantity.nutrient._id && NUTRIENTS_WHITELIST_IDS.indexOf(nutrientsQuantity.nutrient._id) > -1;
      });
      vm.ingredient = result;
      vm.typedIngredient = vm.ingredient.name;
      context.set({
        contextName: result.name,
        title: result.name + ": toutes ses informations nutritionnelles",
        //iconAction : 'heart-o',
        //iconCallback : vm.onClickHeartNavbar,
        colorBackground: vm.ingredient.hexDominantColor
      });
      parseIngredient(vm.ingredient);
      setMonths(vm.ingredient);
      vm.nutriscoreLetter = vm.ingredient.getNutriscoreLetter();

      //retrieve the interactions, when we are in callback make the buttons available again
      vm.ingredient.getInteractions().then(function (data) {
        vm.interactions = data;
        vm.resetContext();
        console.log('the api interactions on ingredient succeeded', data);
      }, function () {
        console.log('the api like on ingredient failed');
      });
    }, function (err) {
      console.log('error loading the ingredient', err);
    });
    vm.goodThings = [];
    vm.badThings = [];
    vm.monthsProduction = [];
    var setMonths = function setMonths(ingredient) {
      var monthsProduced = ingredient.monthsSoldInFrance,
        monthsSmartPercentage = [],
        goodColor = '#29894d',
        badColor = '#BBBBBB',
        //'#ef8303',
        colorStatus = monthsProduced.indexOf(0) > -1 ? goodColor : badColor,
        newColorStatus,
        percentageIncrease = 100 / 12,
        percentage = 0,
        //init percentage
        isProduced;
      for (var i = 0, l = 12; i < l; i++) {
        console.log('index is ', i);
        isProduced = monthsProduced.indexOf(i) > -1;
        newColorStatus = isProduced ? goodColor : badColor;
        vm.monthsProduction.push(isProduced);
        percentage += percentageIncrease;
        monthsSmartPercentage.push({
          color: newColorStatus,
          percentage: percentage
        });
      }
      var cssStyleLinear = 'linear-gradient( to right, ',
        commar = '';
      monthsSmartPercentage.forEach(function (itemSmart, index) {
        commar = index === 0 ? '' : ',';
        cssStyleLinear += commar + ' ' + itemSmart.color + ' ' + itemSmart.percentage + '%';
      });
      cssStyleLinear += ')';
      vm.timelineStyle = cssStyleLinear;
    };

    //level colors 1 great, 2, good, 3, bad, 4 very bad
    var parseIngredient = function parseIngredient(ingredient) {
      //1 take every ingredient and push it in the bad or good section, or neither one nor the other
      console.log(ingredient);
      //console.log('color to hsl is', hexToHSL(ingredient.hexDominantColor));

      //take the closest color available
      //ingredient.hexDominantColor = Colors.getClosestColorPossible(ingredient.hexDominantColor);//hexToHSL(ingredient.hexDominantColor);
      ingredient.hexDominantColorAlpha = Colors.hexToHSLLighter(ingredient.hexDominantColor, 70);
      ingredient.linearStyle = 'linear-gradient(to right top, ' + ingredient.hexDominantColor + ' 40%, ' + ingredient.hexDominantColorAlpha + ' 100%)';

      //vm.recipe.hexDominantColor = Colors.getClosestColorPossible(vm.recipe.hexDominantColor);

      if (ingredient.price < 5) {
        vm.goodThings.push({
          name: 'Economique',
          description: 'Ce produit est économique',
          level: 1,
          iconName: 'fob-moneybox'
        });
      }

      //push local and fruits/legumes
      ingredient.features.forEach(function (feature) {
        if (feature.easyID === 8) {
          vm.goodThings.push({
            name: 'Local',
            description: 'Ce produit peut provenir de France métropolitaine',
            level: 1,
            iconName: 'fob-crosshair'
          });
        }
      });
      if (ingredient.percentageFruitsAndVegetables > 80) {
        vm.goodThings.push({
          name: 'Fruits & Légumes',
          description: 'Ce produit contient plus de 80% de fruits et légumes',
          level: 1,
          iconName: 'fob-carrot-and-apple'
        });
      }
      var infoGoodAndBad = nutritionService.getGoodAndBadThings(ingredient.nutrientsQuantity);
      vm.goodThings = vm.goodThings.concat(infoGoodAndBad.goodThings);
      vm.badThings = vm.badThings.concat(infoGoodAndBad.badThings);
    };
    vm.onPanDown = function (event) {
      console.log('pan down detected', event);
      /**if (event.srcEvent && event.srcEvent.stopPropagation) {
      console.log('will stope event propagation pan up');
      //event.gesture.preventDefault();
      event.srcEvent.preventDefault();
      event.srcEvent.stopPropagation();
      }**/

      var element = event.element;
      console.log('the parent div', element.parent());
      //console.log('pan down scroll position event scroll top', element.parent()[0].scrollTop);
      //console.log('pan down scroll position event scroll top', element.scrollTop());
      if (element.parent()[0].scrollTop !== 0) {
        return false;
      }
      if (event.isFinal) {
        console.log('final event');
        //here we have two options, whether take it back to the normal position
        if (Math.abs(event.deltaY) > 10) {
          //element.parent().removeClass('slider-open');
          vm.onSliderToggle();
        }
        //element.css('transform', 'translateY(0px)');
      } else {
        //element.css('transform', 'translateY(' +event.deltaY+'px)');
      }
    };
    vm.onPanUp = function (event) {
      if (vm.sliderOpen) {
        /**do not listen to this event when slide is open, we don't need that*/
        return false;
      }
      console.log('pan up detected', event);
      //alert('pan up detected');
      //NotE : if domevents activated we got an element nodejs otherwise a Jquery node
      var element = event.element;
      /**if(element.parent().hasClass('slider-open')) {
      console.log('on pan up is false');
      return false;
      }**/
      //if(event.isFinal) {
      vm.onSliderToggle();
      return false;
      //alert('pan up final');
      //here we have two options, whether take it back to the normal position
      /**if(Math.abs(event.deltaY) > 10 ) {
      	vm.onSliderToggle();
      	return false;
      	//element.parent().addClass('slider-open');
      }**/
      //element.css('transform', 'translateY(0px)');
      //second option expand the container
      //}
      /*else {
      //element.css('transform', 'translateY(' +event.deltaY+'px)');
      }*/
    };
    vm.onPanEnd = function (event) {
      var selector = event.deltaX > 0 ? 'heart-container' : 'yurk-container',
        element = angular.element(document.getElementsByClassName(selector)[0]),
        maxSwipeDetectionReach = 70;
      if (Math.abs(event.deltaX) >= maxSwipeDetectionReach) {
        /*var contextInstance = context.get();
        context.set({
        iconAction: (event.deltaX > 0) ? 'heart' : 'heart-o'
        });*/
        element.css('transition', 'opacity 2000ms cubic-bezier( 0.5, 0, 0.5, 1 ), display 5000ms cubic-bezier( 0.5, 0, 0.5, 1 )');
        element.css('opacity', 0);
        setTimeout(function () {
          element.css('display', 'none');
        }, 2000);
      } else {
        element.css('display', 'none');
      }
    };
    vm.onPanCancel = function (event) {
      var selector = event.deltaX > 0 ? 'heart-container' : 'yurk-container',
        element = angular.element(document.getElementsByClassName(selector)[0]);
      element.css('display', 'none');
    };
    vm.onPanStart = function (event) {
      /**if(event.pointerType == 'touch' && (Math.abs(event.deltaY) > Math.abs(event.deltaX))){ 
      console.log('pan start cancelled');
      return false; 
      }**/

      var selector = event.deltaX > 0 ? 'heart-container' : 'yurk-container',
        element = angular.element(document.getElementsByClassName(selector)[0]);
      element.css('transition', '');
      element.css('display', 'flex');
    };
    vm.onPanRight = function (event) {
      /**if(event.pointerType == 'touch' && (Math.abs(event.deltaY) > Math.abs(event.deltaX))){ 
      console.log('pan right cancelled');
      return false; 
      }**/

      var element = angular.element(document.getElementsByClassName('heart-container')[0]),
        maxSwipeDetectionReach = 70; //value in pixel

      if (event.deltaX > maxSwipeDetectionReach) {
        element.css('opacity', 1);
      } else {
        element.css('opacity', Math.round(10 * event.deltaX / maxSwipeDetectionReach) / 10);
      }
      if (event.isFinal === true) {
        vm.onPanEnd(event);
      }
    };
    vm.onPanLeft = function (event) {
      /**if(event.pointerType == 'touch' && (Math.abs(event.deltaY) > Math.abs(event.deltaX))){ 
      console.log('pan left cancelled');
      return false; 
      }**/

      var element = angular.element(document.getElementsByClassName('yurk-container')[0]),
        maxSwipeDetectionReach = 70,
        deltaXAbs = Math.abs(event.deltaX);
      if (deltaXAbs > maxSwipeDetectionReach) {
        element.css('opacity', 1);
      } else {
        element.css('opacity', Math.round(10 * deltaXAbs / maxSwipeDetectionReach) / 10);
      }
      if (event.isFinal === true) {
        vm.onPanEnd(event);
      }
    };
    var activateNumbers = function activateNumbers() {
      //1- find all the data-odometer-value
      var value, od;
      document.querySelectorAll('.nutrition-fact-quantity').forEach(function (nodeEl) {
        value = nodeEl.getAttribute('data-odometer-value');
        if (Odometer) {
          od = new Odometer({
            el: nodeEl,
            value: 0,
            format: '( ddd),d',
            theme: 'default'
          });
          od.update(value);
        }
      });
    };
    vm.triggerOdometer = function () {
      setTimeout(activateNumbers, 1500);
    };
    vm.onSliderToggle = function () {
      vm.sliderOpen = !vm.sliderOpen;
      vm.triggerOdometer();
    };
    vm.onLikeIngredient = function () {
      if (vm.interactions.isLiked) {
        vm.ingredient.unlike();
      } else {
        vm.interactions.isDisliked = false;
        vm.ingredient.like();
      }
      vm.interactions.isLiked = !vm.interactions.isLiked;
      vm.resetContext(); //reset the context for mobile
    };
    vm.ondislikeIngredient = function () {
      if (vm.interactions.isDisliked) {
        vm.ingredient.undislike();
      } else {
        vm.interactions.isLiked = false;
        vm.ingredient.dislike();
      }
      vm.interactions.isDisliked = !vm.interactions.isDisliked;
      vm.resetContext(); //reset the context for mobile
    };
    vm.absoluteRef = function (id) {
      return 'url(' + $location.absUrl() + '#' + id + ')';
    };
    vm.getWidgetData = function () {
      var widgetData = {
        _id: vm.ingredient._id,
        name: vm.ingredient.name,
        price: vm.ingredient.price,
        slug: vm.ingredient.slug,
        hexDominantColor: vm.ingredient.hexDominantColor,
        percentageFruitsAndVegetables: vm.ingredient.percentageFruitsAndVegetables,
        nutrientsQuantity: vm.ingredient.nutrientsQuantity.map(function (nutrientQuantity) {
          //return a cleaned and lighter structure for the widget
          return {
            nutrient: {
              _id: nutrientQuantity.nutrient._id,
              unit: nutrientQuantity.nutrient.unit
            },
            quantity: nutrientQuantity.quantity
          };
        }),
        monthsSoldInFrance: vm.ingredient.monthsSoldInFrance,
        //features : vm.ingredient.features,
        nutriscoreLetter: vm.ingredient.nutriscoreLetter,
        tagNames: vm.ingredient.getTagNames()
      };
      //here reduce the amount od data passed
      return JSON.stringify(widgetData);
    };
    vm.getTagTranslated = function (tag) {
      return tagService.wording[tag];
    };

    /**vm.widgetPreviewOptions = {
    'image' : true,
    'nutriscore': true,
    'monthProduction': true,
    'goodThings': true,
    'badThings' : true,
    'nutritags' : true
    };**/

    vm.getClassesToHide = function () {
      var classes = '';
      if (vm.widgetPreviewOptions.image === false) {
        classes += 'aa ';
      }
      if (vm.widgetPreviewOptions.nutriscore === false) {
        classes += 'bb ';
      }
      if (vm.widgetPreviewOptions.monthProduction === false) {
        classes += 'cc ';
      }
      if (vm.widgetPreviewOptions.goodThings === false) {
        classes += 'dd ';
      }
      if (vm.widgetPreviewOptions.badThings === false) {
        classes += 'ee ';
      }
      if (vm.widgetPreviewOptions.nutritags === false) {
        classes += 'ff ';
      }
      //vm.classes= classes;
      return classes;
    };
    vm.onCopyInClipboard = function () {
      navigator.clipboard.writeText(vm.getCodeToSelect()).then(function () {
        vm.copyButtonClicked = true;
      }, function () {
        //note n°3 : if this fails (like on safari for instance... :( ) may be fallback here on the old execCommand API
      });
    };
    vm.getCodeToSelect = function () {
      var domain = document.location.origin;
      return $sce.trustAsHtml("<div class='" + vm.getClassesToHide() + "' ng-app=\"meanApp\" id=\"fob-widget\" ng-controller=\"ingredientWidgetCtrl\" widget-data='" + vm.getWidgetData() + "'>Infos nutritionnelles</div><script type=\"text/javascript\" src=\"" + domain + "/ing.w1.js\"></script>");
    };
    vm.triggerCodePreview = function () {
      //1- we need to load the ingredient-nutrition widget file
      var domain = document.location.origin;
      vm.loadScript(domain + '/widget/ingredient-nutrition.js', function () {
        var widgetEl = angular.element(document.getElementById('fob-widget'));
        $compile(widgetEl.contents())($scope);
      });
    };
    vm.onPreviewChange = function () {
      //vm.getCodeToSelect();
      var widgetEl = angular.element(document.getElementById('fob-widget'));
      $compile(widgetEl.contents())($scope);
    };

    //TODO to be moved in a utils
    vm.loadScript = function (url, callback) {
      if (url) {
        var script = document.querySelector("script[src*='" + url + "']");
        //if (!script) {
        var heads = document.getElementsByTagName('head');
        if (heads && heads.length) {
          var head = heads[0];
          if (head) {
            script = document.createElement('script');
            script.setAttribute('src', url);
            script.setAttribute('type', 'text/javascript');
            script.onload = function () {
              callback && callback();
            };
            script.onerror = function () {
              callback && callback();
            };
            //if (charset) script.setAttribute('charset', charset);
            head.appendChild(script);
          }
        }
        //}
        return script;
      }
    };
    vm.goToWidgetisation = function () {
      $state.go('ingredientWidget', {
        slug: vm.ingredient.slug
      });
    };
    vm.ingredientsSearchResult = function (ingredientName) {
      vm.ingredientSelectedBackupName = ingredientName;
      //here return a promise
      return ingredientsManager.searchAutocomplete(ingredientName).then(function (results) {
        console.log('results of ingredient search', results);
        //only push if at least one result
        /*if(results.length > 0) {
        results.push({
        word: WORDING_FOR_THE_NON_RELEVANT_INGREDIENT,
        data : [WORDING_FOR_THE_NON_RELEVANT_INGREDIENT]
        });
        }*/
        //add here a non matched result
        return results;
      }, function (err) {
        console.log('erreur loading all profiles');
        console.log(err);
      });
    };
    vm.typeaheadOnSelect = function (item) {
      //here perform a call to the back end and get more info about this ingredient
      var slugOfIngredient = item.data[0];
      vm.goodThings = [];
      vm.badThings = [];
      vm.monthsProduction = [];
      ingredientsManager.get(slugOfIngredient, true).then(function (result) {
        result.nutrientsQuantity = result.nutrientsQuantity.filter(function (nutrientsQuantity) {
          return nutrientsQuantity.nutrient && nutrientsQuantity.nutrient._id && NUTRIENTS_WHITELIST_IDS.indexOf(nutrientsQuantity.nutrient._id) > -1;
        });
        vm.ingredient = result;
        parseIngredient(vm.ingredient);
        setMonths(vm.ingredient);
        vm.nutriscoreLetter = vm.ingredient.getNutriscoreLetter();
      }, function () {
        console.log('error loading the ingredient');
      });
    };
  }
})();
(function () {
  angular.module('meanApp').controller('subscribeCtrl', subscribeCtrl);
  subscribeCtrl.$inject = ['alert', '$rootScope', '$scope', '$location', 'authentication', 'isLogin', 'loginModal', 'usersManager', 'currentUser'];
  function subscribeCtrl(alert, $rootScope, $scope, $location, authentication, isLogin, loginModal, usersManager, currentUser) {
    var vm = this;
    vm.locationPathSaved = $location.path();
    //$location.path('/');
    var successFunction = function (result) {
      var userDataFromBackEnd = result.user;
      angular.extend(this.currentUser, userDataFromBackEnd);
      currentUser.set(this.currentUser);
      console.log(result);
      var modal = loginModal.get();
      if (modal) {
        modal.close();
      }
      //this will trigger new controller and retrieve the currentuser ?
      $location.path(vm.locationPathSaved);
      alert.push('success', 'Bienvenue sur fraiseoubacon.com');
    }.bind(this);

    //init values
    vm.credentials = {
      email: '',
      password: ''
    };
    vm.submitLoading = false;
    vm.isLogin = isLogin;
    vm.fbLoading = false; //display the facebook button in loading state
    vm.showPassword = false;
    vm.noEmailError = false;
    vm.sendNewPassword = function () {
      //todo un email doit etre spécifié
      if (!vm.email) {
        vm.noEmailError = true;
      } else {
        vm.credentials = {
          email: vm.email
        };
        var user = usersManager.set(vm.credentials);
        user.resetPassword(vm.credentials).error(function (err) {
          var modal = loginModal.get();
          if (modal) {
            modal.close();
          }
          alert.push('danger', 'Une erreur est survenue, merci de réessayer ultérieurement.');
        }).success(function (result) {
          var modal = loginModal.get();
          if (modal) {
            modal.close();
          }
          alert.push('success', 'Votre mot de passe a été réinitialisé, veuillez consulter votre boite mail.');
        });
      }
    };
    vm.onEyeClicked = function () {
      vm.showPassword = !vm.showPassword;
    };

    //TODO differentiate register and login because user can make a mistake by signing in on registering
    vm.onSubmit = function () {
      vm.showPassword = false; //for better security
      vm.emailError = false; //remove the errors
      vm.submitLoading = false;
      if (vm.email && vm.password) {
        vm.credentials = {
          email: vm.email,
          password: vm.password
        };
        if (!vm.isLogin) {
          this.currentUser = usersManager.set(vm.credentials);
          this.currentUser.register().then(successFunction, function (err) {
            if (err && err.code === 11000) {
              vm.emailError = true;
              vm.password = '';
            }
          });
        } else {
          //here is the login process
          //distinguish two use cases auth is successful, wrong because email does not exist, wrong because password is false
          vm.passwordError = false;
          this.currentUser = usersManager.set(vm.credentials);
          if (this.currentUser) {
            console.log('currentuser initiated');
            this.currentUser.login().then(successFunction, function (err) {
              vm.passwordError = true;
              //alert.push('danger', 'Votre email et/ou votre mot de passe sont erronés');
            });
          } else {
            console.log('there is no currnet user :o');
          }
        }
      }
    };
  }
})();
(function () {
  angular.module('meanApp').controller('premiumCtrl', premiumCtrl);
  premiumCtrl.$inject = ['$scope', '$rootScope', '$location', 'context', 'httpAuth', '$state', 'loginModal'];
  function premiumCtrl($scope, $rootScope, $location, context, httpAuth, $state, loginModal) {
    var vm = this;
    context.set({
      contextName: 'Page de paiement',
      title: 'Page de paiement',
      goBack: true
    });
    vm.goToCheckout = function () {
      // call to api here
      // price_1LzOkhFwZN5AyzAzIAuQj4X5
      // check if the user is connected
      console.log('email is', $rootScope.currentUser.email);
      if ($rootScope.currentUser.email) {
        httpAuth.post('/api/create-checkout-session/', {
          priceId: 'price_1LzOkhFwZN5AyzAzIAuQj4X5',
          //TODO put that price in a constant ?
          email: $rootScope.currentUser.email
        }, {
          headers: {
            "Content-Type": "application/json"
          }
        }).success(function (data) {
          window.open(data.data);
        });
      } else {
        loginModal.open(true);
      }
    };
    vm.manageSubscription = function () {
      window.open('https://billing.stripe.com/p/login/test_5kA3dG1h9dkZ0Y88ww');
    };
  }
})();
(function () {
  angular.module('meanApp').controller('profileCtrl', profileCtrl);
  profileCtrl.$inject = ['$scope', '$location', '$state', '$rootScope', 'usersManager', 'recipesManager', 'alert', '$uibModal', '$window', 'context', 'currentUser'];
  function profileCtrl($scope, $location, $state, $rootScope, usersManager, recipesManager, alert, $uibModal, $window, context, currentUser) {
    console.log('in the profile controller');
    console.log('state params are ', $state);
    var vm = this;
    $scope.$state = $state;
    $scope.editionMode = false;
    usersManager.get($state.params.id).then(function (result) {
      $scope.user = result;
      console.log('$rootscope is', $rootScope);
      currentUser.get().then(function (currentUserModel) {
        if ($scope.user._id === currentUserModel._id) {
          //only add more if current user
          context.set({
            //iconAction : 'more',
            //for each actions an icon and a title and an action callback
            dropDownActions: [{
              iconName: 'user',
              actionTitle: 'Profil',
              dropdownActionCallback: function dropdownActionCallback() {
                //reset the name of the context
                $state.go('profile.info');
                context.set({
                  contextName: currentUserModel.name
                });
              }
            }, {
              iconName: 'cook',
              actionTitle: 'Mes recettes',
              dropdownActionCallback: function dropdownActionCallback() {
                //reset the name of the context
                $state.go('profile.recipes');
                context.set({
                  contextName: 'Mes Recettes'
                });
              }
            }, {
              iconName: 'bookmark',
              actionTitle: 'Sauvegardes',
              dropdownActionCallback: function dropdownActionCallback() {
                //reset the name of the context
                $state.go('profile.bookmarks');
                context.set({
                  contextName: 'Recettes sauvegardées'
                });
              }
            }, {
              iconName: 'heart',
              actionTitle: 'Recettes aimées',
              dropdownActionCallback: function dropdownActionCallback() {
                //reset the name of the context
                $state.go('profile.likes');
                context.set({
                  contextName: 'Recettes aimées'
                });
              }
            }, {
              iconName: 'cog',
              actionTitle: 'Paramètres',
              dropdownActionCallback: function dropdownActionCallback() {
                //reset the name of the context
                $state.go('profile.settings');
                context.set({
                  contextName: 'Paramètres'
                });
              }
            }]
          });
        }
      });
      context.set({
        contextName: result.name
      });
    });
    context.set({
      iconAction: null //, //only if current user
      //iconCallback : vm.onClickHeartNavbar,
      //colorBackground : '#fe5f55'
    });

    //default size or editor
    $scope.pixelSideEditor = {
      'width': '100px',
      'height': '100px'
    };
    $scope.imageSource = ''; //"data:image/gif;base64,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";
    $scope.myCroppedImage = '';
    $scope.resultImageSize = 150;
    var dataURLtoFile = function dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {
        type: mime
      });
    };
    var setOptimizedWidthAndHeight = function setOptimizedWidthAndHeight(width, height) {
      //compute a square but not larger than 400px max
      var minSide = Math.min(width, height),
        minSideIsWidth = minSide === width,
        effectiveSide = 100,
        effectiveHeight,
        effectiveWidth;
      if (minSide > 400) {
        effectiveSide = 400;
      } else if (minSide > 100) {
        effectiveSide = minSide;
      }
      if (!minSideIsWidth) {
        effectiveWidth = effectiveSide; // retrieve the 20 px of margin
        effectiveHeight = parseInt(effectiveWidth * height / width, 10);
      } else {
        effectiveHeight = effectiveSide;
        effectiveWidth = parseInt(width * effectiveHeight / height, 10);
      }
      var widthAvailable = window.document.getElementsByClassName('website-container')[0].offsetWidth - 20; //remove the margins

      //regulate the width
      if (widthAvailable < effectiveWidth) {
        effectiveWidth = widthAvailable;
        effectiveHeight = parseInt(height * effectiveWidth / width);
      }
      $scope.pixelSideEditor = {
        'width': effectiveWidth + 'px',
        'height': effectiveHeight + 'px'
      };
    };
    $scope.onFileChange = function (imageSource, width, height) {
      //1-first convert it into an image source
      //http://stackoverflow.com/questions/38505673/converting-file-object-to-image-object-in-javascipt
      //DONE in controller
      $scope.imageSource = imageSource;
      console.log('image width is ' + width);
      console.log('image height is ' + height);
      setOptimizedWidthAndHeight(width, height);

      //here open a modal in order to edit the picture
      $scope.modal = $uibModal.open({
        templateUrl: 'profile/change.picture.modal.view.html',
        scope: $scope,
        backdrop: 'static'
      });
      $scope.modal.rendered.then(function () {
        console.log('modal change picture is rendered');
        //this.document.body.get modal-content
        var widthAvailable = window.document.getElementsByClassName('modal-content')[0].offsetWidth - 20; //remove the margins
        //what if prortrait image ?
        if (widthAvailable < width) {
          $scope.pixelSideEditor = {
            'width': widthAvailable + 'px',
            'height': parseInt(height * widthAvailable / width) + 'px'
          };

          //$scope.$apply();
        }
      });

      /**$http.post(uploadUrl, fd, {
       withCredentials: true,
       headers: {'Content-Type': undefined },
       transformRequest: angular.identity
      }).success( console.log('...all right!...').error(console.log('..damn!...');**/
      //console.log(files[0]);
      //2 create an image instance in js
      //canvas pas mal https://tympanus.net/codrops/2014/10/30/resizing-cropping-images-canvas/
      //https://github.com/alexk111/ngImgCrop vraiment pas mal avec directive pour angular :)

      //3 use jic module to compress it and serve it to the server
      //https://github.com/brunobar79/J-I-C/blob/master/src/JIC.js
    };
    vm.displayChangePasswordView = false;
    vm.onChangePassword = function () {
      vm.displayChangePasswordView = true;
    };
    vm.removePasswordChanges = function () {
      vm.oldPassword = '';
      vm.newPassword = '';
      vm.newSecondPassword = '';
      vm.displayChangePasswordView = false;
    };
    $scope.saveProfilePicture = function () {
      //console.log($scope.imageSource);
      console.log('needs to save profile pic through api - not defined yet.');
      var fileBuiltFromeBase64 = dataURLtoFile(this.myCroppedImage, 'avatar'),
        fd = new FormData();
      fd.append('file', fileBuiltFromeBase64); //pass the file newly created

      console.log('the filename is', fileBuiltFromeBase64.filename);
      //put the button in loading mode
      this.user.uploadProfilePicture(fd).then(function () {
        //close the modal
        this.modal.close();
        alert.push('success', 'Votre photo de profil a été mise à jour');
        //init the image to undefined so the view changes accordingly
        this.imageSource = '';
        this.myCroppedImage = '';
      }.bind(this), function () {
        alert.push('danger', "Votre photo n'a pu être uploadée, veuillez réessayer ultérieurement");
      }); //call ofthe upload function that is on the user-model.js
    };
    vm.updateUserInformation = function () {
      console.log('all the information to update', $scope.user);
      var data = {
        'biography': $scope.user.biography,
        'weight': $scope.user.weight ? $scope.user.weight : 0,
        'size': $scope.user.size ? $scope.user.size : 0,
        'website': $scope.user.website,
        'name': $scope.user.name
      };
      console.log('update user information');
      $scope.user.update(data).then(function () {
        alert.push('success', 'Votre profil a été mis à jour');
        $scope.editionMode = false;
      }, function () {
        alert.push('danger', "Votre profil n'a pas été mis à jour, veuillez réessayer ultérieurement");
        $scope.editionMode = true;
      });
    };
    vm.updatePassword = function () {
      if (vm.newSecondPassword === vm.newPassword) {
        var data = {
          oldPassword: vm.oldPassword,
          newPassword: vm.newPassword,
          email: $scope.user.email
        };
        $scope.user.changePassword(data).then(function () {
          alert.push('success', 'Votre mot de passe a été changé');
          vm.removePasswordChanges();
        }, function (error) {
          console.log(error);
          alert.push('danger', "Votre ancien mot de passe est faux");
        });
      } else {
        vm.passwordsNotEqual = true;
        alert.push('danger', "Veuillez vérifier votre nouveau mot de passe");
      }
    };
    vm.getAllRecipesFromUser = function () {
      console.log('get all recipes from user is asked');
      //just the first page for now
      return recipesManager.getAllRecipesFromUser($state.params.id, 1).then(function (recipes) {
        console.log('results of recipes of a given user', recipes);
        return recipes;
      }, function (err) {
        console.log('erreur loading all profiles');
        console.log(err);
      });
    };
    vm.loadMoreRecipes = function () {
      console.log('load more ...');
    };
    vm.onEyeClicked = function () {
      vm.showPassword = !vm.showPassword;
    };
    vm.switchToEdit = function () {
      $scope.editionMode = true;
      $state.go('profile.info');
    };
    vm.switchToRead = function () {
      $scope.editionMode = false;
    };
    vm.logout = function () {
      //TODO User is not defined here
      $rootScope.currentUser.logout(function () {
        $rootScope.isLoggedIn = false;
        alert.push('success', 'Vous êtes déconnecté');
      });
    };
  }
})();
(function () {
  angular.module('meanApp').controller('profileRecipesCtrl', profileRecipesCtrl);
  profileRecipesCtrl.$inject = ['$scope', '$location', '$state', '$rootScope', 'recipesManager', 'utils', 'searchModal'];
  function profileRecipesCtrl($scope, $location, $state, $rootScope, recipesManager, utils, searchModal) {
    console.log('in the profile controller');
    console.log('state params are ', $state);
    var vm = this,
      APIFunctionToCall = recipesManager.getAllRecipesFromUser;
    this._currentPage = 1;
    this._nbPages = 1; //nb of pages in back end
    $scope.$parent._callBeingPerformed = false;
    vm.emptyResultDefaultMessage = "Vous n'avez pas encore de recettes !";
    vm.showRecipeCreation = true;
    switch ($state.current.name) {
      case 'profile.likes':
        APIFunctionToCall = recipesManager.getAllRecipesLikedFromUser;
        vm.emptyResultDefaultMessage = 'Aucune recette aimée pour le moment !';
        vm.showRecipeCreation = false;
        break;
      case 'profile.bookmarks':
        APIFunctionToCall = recipesManager.getAllRecipesBookmarkedFromUser;
        vm.emptyResultDefaultMessage = 'Aucune recette sauvegardée pour le moment !';
        vm.showRecipeCreation = false;
        break;
    }
    var getContainerWidth = function getContainerWidth() {
      if (!this._width) {
        this._width = angular.element(document.querySelector('.profile-submenu-container'))[0].offsetWidth;
      }
      console.log('the width is the following', this._width);
      return this._width;
    };
    var launchCall = function () {
      //init sequence below
      $scope.$parent._callBeingPerformed = true;
      //here check which API needs to be called
      console.log('state of profile controler is', $state.current);
      //recipesManager.getAllRecipesFromUser($state.params.id, this._currentPage)
      //recipesManager.getAllRecipesLikedFromUser($state.params.id, this._currentPage)
      APIFunctionToCall.apply(recipesManager, [$state.params.id, this._currentPage]).then(function (obj) {
        this._nbPages = obj.nbPage;
        //console.log('results of recipes of a given user', recipes);
        $scope.$parent._callBeingPerformed = false;
        obj.recipes.forEach(function (recipe) {
          //recipe.isFolded = true;
          recipe.tags = recipe.tags.reverse();
          recipe.isCrossHidden = false;
        });

        //if(this._currentPage === 1) {
        vm.recipes = obj.recipes;
        //}
        //else {
        //    vm.recipes = vm.recipes.concat(obj.recipes);
        //}

        this._createArraysOfRecipes();
      }.bind(this), function (err) {
        console.log('erreur loading recipes profiles');
        console.log(err);
      });
    }.bind(this);
    launchCall();
    this.addOnScrollListener = function (cssSelector) {
      var scrollContainer = document.querySelector(cssSelector);
      if (scrollContainer) {
        //add a debounce so it is called only when the scroll has ended
        scrollContainer.onscroll = utils.debounce(function () {
          console.log('website container has scrolled');
          //if scroll is close to the end then make the next call
          //do not call if not in the end
          //must be on the proper page so this will fix some issues but not sure that if we gor from one page to another that would work like expected...
          if (['profile.recipes', 'profile.likes', 'profile.bookmarks'].indexOf($state.current.name) > -1) {
            if (this._currentPage < this._nbPages && !vm._callBeingPerformed && scrollContainer.scrollHeight - scrollContainer.scrollTop < scrollContainer.offsetHeight + 100) {
              this._currentPage++;
              launchCall();
            }
          }
        }.bind(this), 200);
      }
    };
    this.addOnScrollListener('.website-container');
    this.addOnScrollListener('body');
    var _checkContainer = function checkContainer(finalContent, callback) {
      if (!finalContent.offsetHeight) {
        window.setTimeout(function () {
          console.log('recheck the container offsetHeight');
          _checkContainer(finalContent, callback);
        }, 20); // this checks the flag every 100 milliseconds
      } else {
        callback();
      }
    };
    vm.goToRecipe = function (recipe) {
      if (recipe.isDraft === true) {
        $state.go('recipecreationstep', {
          id: recipe.slug,
          step: '1'
        });
      } else {
        $state.go('recipe', {
          id: recipe.slug
        });
      }
    };
    vm.goToIntermediateSearch = function () {
      searchModal.open();
    };
    vm.goToRecipeCreation = function () {
      $state.go('recipecreation');
    };
    this._numberOfColumns = 0;
    this._gutterSize = 20;
    this._maxItemSize = 300;
    this._minItemSize = 150; //maybe enlarge the size of the items ?

    //contains the conf of the columns
    this._columns = [];
    this._createArraysOfRecipes = function () {
      if (!this._numberOfColumns) {
        this._computeNumberOfColumns();
        //TODO not reinit the array but concat the recipes 
        vm.arrayOfRecipes = [];
        //Init the arrays
        for (var i = 0, l = this._columns.length; i < l; i++) {
          vm.arrayOfRecipes.push([]);
        }
      }

      //dispatch the recipes on columns
      vm.recipes.forEach(function (recipe, index) {
        //push the recipe in the proper column
        var indexOfColumn = index % this._columns.length;
        vm.arrayOfRecipes[indexOfColumn].push(recipe);
      }.bind(this));
    };
    vm._computeNumberOfColumns = function () {
      var x = 1,
        itemWidth;
      console.log('will compute the number of columns');
      for (var i = 1; i < 4; i++) {
        //if this x fulfill all conditions then break the loop
        //remove the gutters
        itemWidth = (getContainerWidth.apply(this) - 60 * i) / i;
        if (itemWidth <= this._maxItemSize && itemWidth >= this._minItemSize) {
          x = i;
          break;
        }
        //otherwise continue
      }
      this._numberOfColumns = x;
      /*this._cardPixelWidth = itemWidth;*/
      //init the columns conf and position system 
      for (var j = 0; j < x; j++) {
        console.log('in the loop for computing columns');
        this._columns.push({
          //lastPositionBottom : 0
        });
      }
    };
  }
})();
(function () {
  angular.module('meanApp').controller('searchCtrl', searchCtrl);
  searchCtrl.$inject = ['$scope', '$rootScope', '$window', '$location', 'authentication', 'loginModal', 'context', '$state', '$stateParams', 'recipesManager', 'searchData', 'ingredientsManager', 'allergensManager', '$q', 'alert', 'currentUser', 'utils'];
  function searchCtrl($scope, $rootScope, $window, $location, authentication, loginModal, context, $state, $stateParams, recipesManager, searchData, ingredientsManager, allergensManager, $q, alertMatt, currentUser, utils) {
    var vm = this,
      LIMIT_FETCH = 6;

    //init the controller only once
    vm.currentCompletion = parseInt($stateParams.step) * 100 / 3;
    vm.widthProgressBar = {
      width: vm.currentCompletion + '%'
    };
    vm.tagsSelectedModalOpen = false;
    vm.isHelpDisplayed = false;
    vm.mustDisplayHelp = $window.localStorage['searchHelp'] !== 'false';
    vm.tags = searchData.getTags();
    vm.tagsSelected = searchData.getTagsSelected();
    vm.recipesCount = searchData.getRecipesCount();
    vm.ingredients = [];
    vm.odNumberRecipes = null;
    vm.allergens = [];
    vm.listAllergensForCurrentUser = [];
    vm.ingredientsLikedArray = [];
    vm.ingredientsLikeModalOpen = false;
    vm.currentIngredientPage = 1;
    vm.currentIngredientDislikePage = 1;
    vm.isTypeAheadLoading = false;
    vm.searchCurrentPage = 1;
    vm.recipesResults = [];
    vm.thumbRecipesResults = [];
    $scope.$state = $state;
    vm.beingFetched = true;

    //must be true if user is not connected 
    //vm.noAccount = !authentication.isLoggedIn();
    //authentication is LoggedIn is not enough
    currentUser.get().then(function (userModel) {
      vm.noAccount = !(userModel && userModel._id);
    }, function () {
      vm.noAccount = true;
    });
    this._getContextName = function () {
      var stepNumber = parseInt($stateParams.step),
        contextName = '';
      if (stepNumber < 4) {
        contextName = 'Recherche ' + stepNumber + '/3';
      } else if (stepNumber === 4) {
        contextName = 'Personnalisation';
      } else {
        contextName = 'Résultats de recherche';
      }
      return contextName;
    };
    this._getTitle = function () {
      var title = '',
        stepNumber = parseInt($stateParams.step);
      switch (stepNumber) {
        case 1:
          title = 'Recherche de recettes selon vos envies: type de plat, sucré, salé, chaud, froid';
          break;
        case 2:
          title = 'Recherche de recettes selon votre mode de vie: végétarien, paléo, hyperprotéiné, hypocalorique';
          break;
        case 3:
          title = 'Recherche de recettes selon vos contraintes: économique, rapide, sans four';
          break;
        case 4:
          title = 'Personnalisation de vos recettes selon vos allergies et préférences culinaires';
          break;
        default:
          title = 'Résultats de recherche de recette selon les Nutritags';
          break;
      }
      return title;
    };
    this._getNextHref = function () {
      var stepNumber = parseInt($stateParams.step);
      return '/recherche/etape/' + (stepNumber + 1);
    };
    this._goToPreviousStep = function () {
      var stepNumber = parseInt($stateParams.step);
      if (stepNumber > 1 && stepNumber < 5) {
        $state.go('recipeSearchStep', {
          step: stepNumber - 1
        });
      }
    };
    this.goToStep = function (number) {
      $state.go('recipeSearchStep', {
        step: parseInt(number)
      });
    };
    this._goToNextStep = function () {
      var stepNumber = parseInt($stateParams.step);
      if (stepNumber < 4) {
        $state.go('recipeSearchStep', {
          step: stepNumber + 1
        });
      } else {
        vm.gotoSearchResults();
      }
    };

    // Returns a function, that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds. If `immediate` is passed, trigger the function on the
    // leading edge, instead of the trailing.
    var debounce = function debounce(func, wait, immediate) {
      var timeout;
      return function () {
        var context = this,
          args = arguments;
        var later = function later() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    };

    //this function is finally called to take into account
    //- the tags, 
    //- the ingredients liked
    //- the ingredients disliked
    //- the allergens (TODO last)
    var NUMBER_ITEM_PER_ROW = 2;
    this._getAdvancedSearchResultsToBeDebounced = function () {
      var nbResultsLoaded = vm.searchCurrentPage === 1 ? vm.recipesResults.length : vm.thumbRecipesResults.length + 1;
      vm.beingFetched = true;
      //if user not connected trigger usual non advanced search results
      currentUser.get().then(function (userModel) {
        //here check for the cache
        var cachedData = searchData.getCache(vm.tagsSelected, vm.searchCurrentPage);
        if (cachedData && !$stateParams.search) {
          //console.log('data cached is', searchData.getCache(vm.tagsSelected, vm.searchCurrentPage));
          vm.searchCurrentPage = cachedData.currentPage;
          vm.recipesResults = cachedData.recipes; //init the array
          vm.thumbRecipesResults = vm.recipesResults.filter(function (recipe, index) {
            return index > 0;
          });
          nbResultsLoaded = vm.searchCurrentPage === 1 ? vm.recipesResults.length : vm.thumbRecipesResults.length + 1;
          vm.hideLoadMore = nbResultsLoaded === cachedData.totalCount; //hide if there is no more content to be displayed

          if (vm.recipesResults.length === 0) {
            vm.hideLoadMore = true;
            vm.zeroResult = true;
          }
          searchData.setRecipeCount(cachedData.totalCount);
          vm.updateCountOdometer();
          vm.beingFetched = false;
        } else {
          var searchParam = vm.tagsSelected.length > 0 ? vm.tagsSelected : [vm.textSearch];
          recipesManager.searchRecipesAdvanced(searchParam, vm.searchCurrentPage).then(function (recipes) {
            if (userModel && userModel._id) {
              recipes.docs.forEach(function (recipe) {
                vm.extractMatchedIngredients(recipe, userModel);
              });
            } else {
              //just perform a simple prefetch call to have nice data in cache
              recipes.docs.forEach(function (recipe) {
                //perform call only if model is not complete
                var forceCall = !recipe.isModelComplete();
                //force call if imcomplete
                recipesManager.get(recipe.slug, forceCall);
              });
            }

            //if first page init the arrray, otherwise push it in the array
            if (vm.searchCurrentPage === 1) {
              vm.recipesResults = recipes.docs; //init the array
              vm.thumbRecipesResults = vm.recipesResults.filter(function (recipe, index) {
                return index > 0;
              });
            } else {
              vm.thumbRecipesResults = vm.thumbRecipesResults.concat(recipes.docs);
            }
            nbResultsLoaded = vm.searchCurrentPage === 1 ? vm.recipesResults.length : vm.thumbRecipesResults.length + 1;
            vm.hideLoadMore = nbResultsLoaded === recipes.total; //hide if there is no more content to be displayed

            if (vm.recipesResults.length === 0) {
              vm.zeroResult = true;
              vm.hideLoadMore = true;
            }
            vm.recipesCount = recipes.total;
            searchData.setCache(vm.tagsSelected, vm.searchCurrentPage, vm.recipesCount, recipes.docs);
            searchData.setRecipeCount(vm.recipesCount);
            vm.updateCountOdometer();
            vm.beingFetched = false;
          });
        }
      });
    };
    this._getAdvancedSearchResults = debounce(this._getAdvancedSearchResultsToBeDebounced, 250);

    ////extract ingredients from recipe that match the request
    vm.extractMatchedIngredients = function (recipe, currentUser) {
      var idIngredientsLiked = currentUser.ingredientsLike,
        ingredientsMatched = [];
      recipesManager.get(recipe.slug, !recipe.nutriscore).then(function (recipeModel) {
        //console.log('recipe retrieved', recipe);
        recipeModel.ingredientsQuantity.forEach(function (ingredientQuantity) {
          if (idIngredientsLiked.indexOf(ingredientQuantity.ingredient._id) > -1) {
            ingredientsMatched.push(ingredientQuantity.ingredient);
          }
        });
        recipe.ingredientsMatched = ingredientsMatched;
        //console.log('ingredients Matched are',recipe.ingredientsMatched);
      });
    };
    if (!$stateParams.step) {
      //if searchData is not populated from url do it
      //update september 2020 - do it anyway
      //if(searchData.getTagsSelected().length === 0) {

      //console.log('query params are', $stateParams.tags);
      if ($stateParams.tags) {
        var extractedTagsFromUrl = $stateParams.tags.split(',');
        searchData.setTagsSelected(extractedTagsFromUrl);
        vm.tagsSelected = extractedTagsFromUrl;
        //also apply it to the vm.tags data structure
        vm.tagsSelected.forEach(function (tagName) {
          vm.tags[tagName] = true;
        });
      }
      //}
      //else {
      //TODO ? //do nothing ? call has been already made ?
      //}

      if ($stateParams.search) {
        vm.textSearch = $stateParams.search;
        searchData.setTextSearch(vm.textSearch);
        vm.tagsSelected = [];
      }
      vm._getAdvancedSearchResults();
    }
    vm.goToSearchStepOne = function () {
      $state.go('recipeSearchStep', {
        step: '1'
      });
    };
    vm.goToSearchResultByText = function () {
      $state.go('recipeTextSearchResult', {
        search: vm.textSearch
      });
    };
    var isSearchResultPage = $state.current.name.indexOf('SearchResult') > -1,
      stepNumber = parseInt($stateParams.step);
    context.set({
      href: !isSearchResultPage && stepNumber < 4 ? this._getNextHref() : false,
      //TODO set iconcallback only if needed
      iconAction: isSearchResultPage ? navigator && navigator.share ? 'share' : null : 'arrow-left reversed bigger',
      iconCallback: isSearchResultPage || stepNumber === 4 ? function () {
        if (isSearchResultPage) {
          navigator.share({
            title: 'Moteur de recherche de recettes: votre prochain repas se trouve ici',
            url: document.URL,
            text: "Tiens, jète un oeil aux recettes que j'ai trouvées :)"
          });
        } else {
          this.gotoSearchResults();
        }
      }.bind(this) : false,
      contextName: this._getContextName(),
      title: this._getTitle(),
      goBack: true
    });
    vm.onTagClicked = function (event) {
      var domTargetAttribute = event.target && event.target.closest('[tag]') && event.target.closest('[tag]').getAttribute('tag');
      if (domTargetAttribute) {
        vm.tags[domTargetAttribute] = !vm.tags[domTargetAttribute];
        if (vm.tags[domTargetAttribute]) {
          switch (domTargetAttribute) {
            case 'aperitif':
              vm.tags['entry'] = vm.tags['maincourse'] = vm.tags['dessert'] = false;
              break;
            case 'entry':
              vm.tags['aperitif'] = vm.tags['maincourse'] = vm.tags['dessert'] = false;
              break;
            case 'maincourse':
              vm.tags['aperitif'] = vm.tags['entry'] = vm.tags['dessert'] = false;
              break;
            case 'dessert':
              vm.tags['aperitif'] = vm.tags['entry'] = vm.tags['maincourse'] = false;
              break;
            case 'hot':
              vm.tags['cold'] = false;
              break;
            case 'cold':
              vm.tags['hot'] = false;
              break;
            case 'vegetarian':
              vm.tags['vegan'] = true;
              vm.tags['nopig'] = true;
              break;
            case 'vegan':
              vm.tags['nopig'] = true;
              break;
          }
        }
      }
      vm._recomputeTags();
    };

    //TODO do a service to sort the tags by color
    var TAGS_BY_COLOR = ['complicated', 'nohob', 'protein', 'cold', 'eco', 'lowcarb', 'nopig', 'vegan', 'paleo', 'vegetarian', 'local', 'nogluten', 'nooven', 'maincourse', 'nomicrowave', 'entry', 'pleasure', 'savory', 'aperitif', 'lowcalory', 'season', 'dessert', 'fast', 'sweet', 'hot'];
    vm._recomputeTags = function (advancedModeActivated) {
      //var previousTagsSelectedArray = vm.tagsSelected;

      vm.tagsSelected = [];
      Object.keys(vm.tags).forEach(function (key) {
        if (vm.tags[key]) {
          vm.tagsSelected.push(key);
        }
      });
      //sort the tags by color
      vm.tagsSelected.sort(function (tag1, tag2) {
        return TAGS_BY_COLOR.indexOf(tag2) - TAGS_BY_COLOR.indexOf(tag1);
      });
      if (advancedModeActivated) {
        //silently change the URL for the result page with new tags
        $state.go('recipeSearchResult', {
          tags: vm.tagsSelected.join(',')
        });
        //$location.search('tags', vm.tagsSelected.join(','));
        /**var path = $location.path(),
        splittedPath = path.split('tags?');
        
        if(splittedPath) {
            $location.path(splittedPath[0]+'tags?' +vm.tagsSelected.join(','));
        }**/
      }
      searchData.setTagsSelected(vm.tagsSelected);
      if (vm.tagsSelected.length) {
        if (typeof advancedModeActivated != 'undefined' && advancedModeActivated == true) {
          //reinit page to 1 because results may have changed
          vm.searchCurrentPage = 1;
          // remove the previous thumb results and everyhing because it can take time to perform the call
          vm.recipesResults = []; //init the array
          vm.thumbRecipesResults = [];
          vm._getAdvancedSearchResults();
        } else {
          //here call for the recipes, and add some debounce to avoid many calls 
          vm.debouncedSearch();
        }
      } else {
        vm.recipesCount = 0;
        searchData.setRecipeCount(vm.recipesCount);
        vm.updateCountOdometer();
      }
    };
    vm.debouncedSearch = utils.debounce(function () {
      recipesManager.searchRecipes(vm.tagsSelected).then(function (count) {
        vm.recipesCount = count;
        searchData.setRecipeCount(count);
        vm.updateCountOdometer();
      });
    }, 750);
    vm.updateCountOdometer = function () {
      var nodeEl;
      if (Odometer) {
        if (!vm.odNumberRecipes) {
          nodeEl = document.querySelector('.counter .number');
          if (nodeEl) {
            vm.odNumberRecipes = new Odometer({
              el: nodeEl,
              value: vm.recipesCount,
              format: '( ddd),d',
              theme: 'default'
            });
          }
        }
        if (vm.odNumberRecipes) {
          vm.odNumberRecipes.update(vm.recipesCount);
        }
      }
    };
    vm.removeTag = function ($event) {
      //to avoid apply digest cycle issue
      var tag = $event.target.getAttribute('tag-to-remove');
      if (tag && vm.tags[tag]) {
        vm.tags[tag] = false;
        console.log('the state is', $state, $state.current, $state.params);
        //check if on result page or not with state params equal to 4
        vm._recomputeTags($state.current.name === "recipeSearchResult");
      }
    };
    vm.onTagsSelected = function () {
      vm.tagsSelectedModalOpen = true;
    };
    vm.onModalClicked = function (event) {
      var target = event.target;
      if (target.classList.contains('tags-selected-modal')) {
        vm.closeModal();
      }
    };
    vm.onModalRecipeSelectedClicked = function (event) {
      var target = event.target;
      if (target.classList.contains('tags-selected-modal')) {
        vm.selectedRecipe = false;
      }
    };
    vm.closeModal = function () {
      vm.tagsSelectedModalOpen = false;
    };
    vm.ingredientsSearchResult = function (ingredientName) {
      //here return a promise
      //vm.isTypeAheadLoading = true;
      return ingredientsManager.searchAutocomplete(ingredientName).then(function (results) {
        //vm.isTypeAheadLoading = false;
        console.log('results of ingredient search', results);
        return results;
      }, function (err) {
        console.log('erreur loading all profiles');
        console.log(err);
        //vm.isTypeAheadLoading = false;
      });
    };
    vm.typeaheadOnSelect = function (item, model, label, event) {
      vm.ingredientSearch = '';
      vm.isTypeAheadLoading = true; //not sure it it works 
      //here perform a call to the back end and get more info about this ingredient
      var slugOfIngredient = item.data[0];
      ingredientsManager.getQuick(slugOfIngredient).then(function (ingredient) {
        vm.ingredients.unshift(ingredient);
        vm.isTypeAheadLoading = false;
        //$scope.$apply();//needs this because asynchronous
        //check if this ingredient is liked or not by the current user
        ingredient.getInteractions().then(function (data) {
          ingredient.interactions = data;
          console.log('the api interactions on ingredient succeeded', data);
        }, function () {
          console.log('the api like on ingredient failed');
        });
        /**.error(function() {
            console.log('the api like on ingredient failed');
        });*/
      });
      //then push it to the ingredients list
      //console.log(item, model, label, event);
    };
    vm.onLikeIngredient = function (ingredient) {
      if (ingredient.interactions.isLiked) {
        ingredient.unlike();
        currentUser.get().then(function (userModel) {
          userModel.ingredientsLike = userModel.ingredientsLike.filter(function (ingredientId) {
            return ingredientId !== ingredient._id;
          });
        });
      } else {
        ingredient.interactions.isDisliked = false;
        ingredient.like();
        currentUser.get().then(function (userModel) {
          userModel.ingredientsLike.push(ingredient._id);
          userModel.ingredientsDislikes = userModel.ingredientsDislikes.filter(function (ingredientId) {
            return ingredientId !== ingredient._id;
          });
        });
      }
      ingredient.interactions.isLiked = !ingredient.interactions.isLiked;
    };

    //Used to remove a like on some ingredient
    vm.unlikeIngredient = function (ingredient, index) {
      //ingredient.unlike();
      vm.ingredientsLikedArray.splice(index, 1);
      ingredient.unlike();
      currentUser.get().then(function (userModel) {
        userModel.ingredientsLike = userModel.ingredientsLike.filter(function (ingredientId) {
          return ingredientId !== ingredient._id;
        });
      });
    };
    vm.unDislikeIngredient = function (ingredient, index) {
      vm.ingredientsDislikedArray.splice(index, 1);
      ingredient.undislike();
      currentUser.get().then(function (userModel) {
        userModel.ingredientsDislikes = userModel.ingredientsDislikes.filter(function (ingredientId) {
          return ingredientId !== ingredient._id;
        });
      });
    };
    vm.ondislikeIngredient = function (ingredient) {
      if (ingredient.interactions.isDisliked) {
        ingredient.undislike();
        currentUser.get().then(function (userModel) {
          userModel.ingredientsDislikes = userModel.ingredientsDislikes.filter(function (ingredientId) {
            return ingredientId !== ingredient._id;
          });
        });
      } else {
        ingredient.interactions.isLiked = false;
        ingredient.dislike();
        currentUser.get().then(function (userModel) {
          userModel.ingredientsDislikes.push(ingredient._id);
          userModel.ingredientsLike = userModel.ingredientsLike.filter(function (ingredientId) {
            return ingredientId !== ingredient._id;
          });
        });
      }
      ingredient.interactions.isDisliked = !ingredient.interactions.isDisliked;
    };
    vm.getAllergens = function () {
      currentUser.get().then(function (userModel) {
        if (userModel && userModel._id) {
          var deferred = $q.defer();
          allergensManager.getAll().then(function (result) {
            vm.allergens = result.collection;
            vm._populateAllergensUserList();
            //parse the collection
            deferred.resolve([]);
          }, function (err) {
            console.log('error loading all allergens');
          });
          return deferred.promise;
        }
      }, function () {
        //do nothing in this case
        //vm.noAccount = true;
      });
    };
    vm.getIngredientsLiked = function () {
      currentUser.get().then(function (userModel) {
        userModel.getIngredientsLiked(vm.currentIngredientPage).then(function (ingredients) {
          vm.ingredientsLikedArray = ingredients;
        });
      });
    };
    vm.getIngredientsDisliked = function () {
      currentUser.get().then(function (userModel) {
        userModel.getIngredientsDisliked(vm.currentIngredientDislikePage).then(function (ingredients) {
          vm.ingredientsDislikedArray = ingredients;
        });
      });
    };
    vm.onAllergenChange = function () {
      var model = vm.listAllergensForCurrentUser.filter(function (allergen) {
        return allergen._id === vm.allergen; //contains the ID selected
      });
      //add it if not already added
      if (model.length === 0) {
        model = vm.allergens.filter(function (allergen) {
          return allergen._id === vm.allergen; //contains the ID selected
        });
        vm.listAllergensForCurrentUser.push(model[0]);
        currentUser.get().then(function (userModel) {
          userModel.addAllergen(vm.allergen).then(function () {
            console.log('allergenAdded');
          }, function () {
            //TODO remove the allergen
            alertMatt.push('danger', 'Une erreur est survenue, merci de réessayer ultérieurement.');
          });
        });
      }
    };

    //function to compute and populate allergens for the current user
    vm._populateAllergensUserList = function () {
      currentUser.get().then(function (userModel) {
        userModel.allergens.forEach(function (allergenId) {
          vm.allergens.forEach(function (allergenModel) {
            if (allergenModel._id === allergenId) {
              vm.listAllergensForCurrentUser.push(allergenModel);
            }
          });
        });
      });
    };
    vm.onAllergenRemove = function (allergenModel) {
      //search allergen in arrat and remove it
      vm.listAllergensForCurrentUser = vm.listAllergensForCurrentUser.filter(function (allergen) {
        return allergen._id !== allergenModel._id;
      });
      currentUser.get().then(function (userModel) {
        userModel.deleteAllergen(allergenModel._id).then(function () {
          console.log('allergenremved');
        }, function () {
          //TODO remove the allergen
          alertMatt.push('danger', 'Une erreur est survenue, merci de réessayer ultérieurement.');
        });
      });
    };
    vm.displaySubscribeLayer = function () {
      loginModal.open(false); //false means this is for registering
      var modalInstance = loginModal.get();
      modalInstance.closed.then(function () {
        //vm.noAccount = false;//not enough i think we need to reload the page or at least the controller
        $state.reload();
      });
    };

    //extract tags from recipe that match the request
    vm.getTagsThatMatchSearchRequest = function (recipe) {
      return recipe ? recipe.tags.filter(function (n) {
        return vm.tagsSelected.indexOf(n) !== -1;
      }) : [];
    };
    vm.getAlmostTagsThatMatchSearchRequest = function (recipe) {
      return recipe ? recipe.almostTags.filter(function (n) {
        return vm.tagsSelected.indexOf(n) !== -1;
      }) : [];
    };
    vm.goToRecipe = function (slug) {
      $state.go('recipe', {
        id: slug
      });
    };
    vm.goToRecipeCreation = function () {
      $state.go('recipecreation');
    };
    vm.gotoSearchResults = function () {
      //only go to search results if there is at least one tag selected
      if (vm.tagsSelected.length === 0) {
        alertMatt.push('info', 'Veuillez sélectionner au moins 1 tag');
        //specific case when not connected and no tag selected go back to step 1 to select at least one tag
        if (vm.noAccount) {
          $state.go('recipeSearchStep', {
            'step': '1'
          });
        }
      } else {
        $state.go('recipeSearchResult', {
          'tags': vm.tagsSelected.join(',')
        });
      }
    };
    vm.selectRecipe = function (recipe, event) {
      event.preventDefault();
      event.stopPropagation();
      vm.selectedRecipe = recipe;
    };
    vm.displayHelp = function (_boolean, event) {
      event.preventDefault();
      event.stopPropagation();
      vm.isHelpDisplayed = _boolean;
      vm.mustDisplayHelp = false;
      $window.localStorage['searchHelp'] = false;
    };
    vm.loadMore = function () {
      vm.searchCurrentPage++;
      vm._getAdvancedSearchResults();
    };

    //TODO what is this functon used for ?
    vm.onTagPressed = function () {
      alertMatt.push('success', 'button pressed');
      //call a service to display the info on the modal OR navigate to another page (if on desktop ?)
      //javascript detect if mobile or not`
    };
  }
})();
(function () {
  /**This module intension is to share data between all the controller related to the search***/
  angular.module('meanApp').service('searchData', searchData);
  searchData.$inject = ['$rootScope'];
  function searchData($rootScope) {
    this._tagsSelected = [];
    this._textSearch = '';
    this._tags = {
      aperitif: false,
      entry: false,
      maincourse: false,
      dessert: false,
      sweet: false,
      savory: false,
      hot: false,
      cold: false,
      pleasure: false,
      vegan: false,
      vegetarian: false,
      lowcarb: false,
      protein: false,
      lowcalory: false,
      paleo: false,
      season: false,
      local: false,
      nopig: false,
      nogluten: false,
      eco: false,
      fast: false,
      nomicrowave: false,
      nooven: false,
      nohob: false,
      complicated: false
    };
    this._recipesCount = 0;
    //this.odNumberRecipes = null;

    this.getTags = function () {
      return this._tags;
    };
    this.getRecipesCount = function () {
      return this._recipesCount;
    };
    this.setRecipeCount = function (count) {
      this._recipesCount = count;
    };
    this.setTagsSelected = function (arrayTags) {
      this._tagsSelected = arrayTags;
    };
    this.getTagsSelected = function () {
      return this._tagsSelected;
    };
    this.setTextSearch = function (textSearch) {
      this._textSearch = textSearch;
    };
    this.getTextSearch = function () {
      return this._textSearch;
    };
    this._recipesCached = [];
    this._tagsCached = ''; //a string that represents the last request
    this._totalCountCached = null;
    this._currentPageCached = 0;

    //be careful with what kind of data is cached here
    this.setCache = function (tagsSelected, currentPage, totalCount, recipes) {
      //1- if the tags were different then fill cache
      if (tagsSelected.join('') != this._tagsCached) {
        this._tagsCached = tagsSelected.join(''); //cache the tags asked
        this._recipesCached = recipes;
        this._totalCountCached = totalCount;
        this._currentPageCached = currentPage;
      } else if (currentPage - this._currentPageCached === 1) {
        //2- if tags are the same AND page is +1 then concat it
        this._recipesCached = this._recipesCached.concat(recipes);
        this._currentPageCached = currentPage;
        this._totalCountCached = totalCount;
      } else {
        // 3- tags are the same and page is not +1 then clear cache (must not happen normally)
        //but this is cleaned to be careful
        this._recipesCached = [];
        this._tagsCached = ''; //a string that represents the last request
        this._totalCountCached = null;
        this._currentPageCached = 0;
      }
    };
    this.getCache = function (tagsSelected, currentPage) {
      //return the cache if same tags even if not the same page
      var cache = '';
      console.log('same tags cached ?', this._tagsCached == tagsSelected.join(''));
      if (this._tagsCached == tagsSelected.join('')) {
        //if currentPageAsked is smaller or equal to the one cached
        console.log('went here');
        if (this._currentPageCached >= currentPage) {
          console.log('and also went here');
          cache = {};
          cache.recipes = this._recipesCached;
          cache.totalCount = this._totalCountCached;
          cache.currentPage = this._currentPageCached;
        }
      }
      //if else that means we can't rely on cache
      return cache;
    };
    return this;
  }
})();
(function () {
  angular.module('meanApp').controller('recipeCtrl', recipeCtrl);
  recipeCtrl.$inject = ['$scope', '$location', 'authentication', 'currentUser', 'loginModal', 'context', '$uibModal', 'recipesManager', 'ingredientsManager', 'measuresManager', 'Recipe', 'alert', '$state'];
  function recipeCtrl($scope, $location, authentication, currentUser, loginModal, context, $uibModal, recipesManager, ingredientsManager, measuresManager, Recipe, alert, $state) {
    //first thing to do check if user is connected or not
    currentUser.get().then(function (userModel) {
      console.log('ok user connected');
      if (!userModel._id) {
        //hack so if user wants to create a recipe he needs to be logged first
        //then go back to previous context
        loginModal.open(true);
        //history.back();
        if (document.referrer.includes(location.hostname)) {
          history.back();
        } else {
          console.log("Pas de retour possible dans le même site");
          window.location.href = "/";
        }
      }
    }, function () {
      console.log('user not connected for recipe creation go back to home, then go back to profile');
      loginModal.open(true);
      //history.back();
      if (document.referrer.includes(location.hostname)) {
        history.back();
      } else {
        console.log("Pas de retour possible dans le même site");
        window.location.href = "/";
      }
    });
    var vm = this;
    vm.COMPLETION_STEP = 100 / 5;
    vm.realCompletion = 5;
    vm.currentCompletion = 5;
    var INGREDIENTS_COLORS = ['#F49AC2', '#CB99C9', '#C23B22', '#FFD1DC', '#DEA5A4', '#AEC6CF', '#77DD77', '#B39EB5', '#FFB347', '#B19CD9', '#FF6961', '#03C03C', '#FDFD96', '#779ECB', '#966FD6'];
    vm.completionFeatures = [];
    vm.currentPosition = 1;
    vm.widthProgressBar = {
      width: vm.currentCompletion + '%'
    };
    vm.recipe = {
      needsFridge: false,
      //default value
      ingredientsQuantity: [],
      unknownIngredientsQuantity: [],
      instructions: []
    };

    //in this case we are in the edit of a recipe
    if ($state.params.id) {
      recipesManager.get($state.params.id, true).then(function (result) {
        vm.recipe = result;
        //clean removed ingredients in database (by precaution)
        vm.recipe.ingredientsQuantity = vm.recipe.ingredientsQuantity.filter(function (ingredientQuantity) {
          return ingredientQuantity.ingredient;
        });

        //console.log(vm.recipe.ingredientQuantity[0].ingredient.getThumb('xs'));
        vm.currentPosition = vm.recipe.instructions.length ? vm.recipe.instructions.length : 1;
        //now parse the recipe
        //convert the needsbaking or heating + bakingtypes + temps de preparation
        if (vm.recipe.unknownIngredientsQuantity) {
          vm.loadMeasures();
        }
        if ($state.params.step === '1') {
          vm.needsHeat = !!vm.recipe.bakingTime;
          if (vm.needsHeat) {
            //TODO change bakingType for bakingTypeSSSSSS
            vm.recipe.bakingType.forEach(function (bakingMethod) {
              vm.bakingTypes[bakingMethod] = true;
            });
          }
          vm.onHeatChange();
          vm.addCompletionFeature('picture');
          vm.onTitleChange();
          vm.onTypeChange();
          vm.onPeopleChange();
          vm.onBakingTimeChange();
          vm.onBakingTypesChange();
          if (vm.recipe.numberOfMinutes) {
            vm.addCompletionFeature('minutes');
          }
        }
      }, function (err) {
        console.log('error loading the ingredient');
      });
    }

    //default size or editor
    $scope.pixelSideEditor = {
      width: '100px',
      height: '100px'
    };
    $scope.imageSource = '';
    $scope.myCroppedImage = '';
    //$scope.pictureUploading = false;
    $scope.myAeraType = 'square';
    $scope.resultImageSize = 600;
    var setOptimizedWidthAndHeight = function setOptimizedWidthAndHeight(width, height) {
      //compute a square but not larger than 400px max
      var minSide = Math.min(width, height),
        minSideIsWidth = minSide === width,
        effectiveSide = 100,
        effectiveHeight,
        effectiveWidth;
      if (minSide > 400) {
        effectiveSide = 400;
      } else if (minSide > 100) {
        effectiveSide = minSide;
      }
      if (!minSideIsWidth) {
        effectiveWidth = effectiveSide;
        effectiveHeight = parseInt(effectiveWidth * height / width, 10);
      } else {
        effectiveHeight = effectiveSide;
        effectiveWidth = parseInt(width * effectiveHeight / height, 10);
      }
      var widthAvailable = window.document.getElementsByClassName('website-container')[0].offsetWidth - 20; //remove the margins

      //regulate the width
      if (widthAvailable < effectiveWidth) {
        effectiveWidth = widthAvailable;
        effectiveHeight = parseInt(height * effectiveWidth / width);
      }
      $scope.pixelSideEditor = {
        width: effectiveWidth + 'px',
        height: effectiveHeight + 'px'
      };
    };
    $scope.onFileChange = function (imageSource, width, height) {
      vm.addCompletionFeature('picture');
      $scope.imageSource = imageSource;
      console.log('image width is ' + width, 'height', height);
      setOptimizedWidthAndHeight(width, height);

      //here open a modal in order to edit the picture
      $scope.modal = $uibModal.open({
        templateUrl: 'profile/change.picture.modal.view.html',
        scope: $scope,
        backdrop: 'static'
      });
      $scope.modal.rendered.then(function () {
        console.log('modal change picture is rendered');
        //this.document.body.get modal-content
        var widthAvailable = window.document.getElementsByClassName('modal-content')[0].offsetWidth - 20;
        //what if prortrait image ?
        if (widthAvailable < width) {
          $scope.pixelSideEditor = {
            width: widthAvailable + 'px',
            height: parseInt(height * widthAvailable / width) + 'px'
          };
          //$scope.$apply();
        }
      });
    };
    var dataURLtoFile = function dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {
        type: mime
      });
    };

    //TODO rename the function to someone more generic
    $scope.saveProfilePicture = function () {
      var fileBuiltFromeBase64 = dataURLtoFile(this.myCroppedImage, 'recipe'),
        fd = new FormData();
      fd.append('file', fileBuiltFromeBase64); //pass the file newly created

      /**Object.keys(vm.recipe).forEach(function(key) {
      	fd.append(key, JSON.stringify((vm.recipe[key])));
      });**/
      console.log($scope, this);
      //$scope.pictureUploading = true;
      //this.pictureUploading = true;
      console.log('the filename is', fileBuiltFromeBase64.filename);
      //put the button in loading mode

      console.log('the recipe object is', vm.recipe);
      if (vm.recipe._id) {
        //save using PUT with just the image
        vm.recipe.updateWithPicture(fd).then(function (recipe) {
          //then get the ID and put it into the recipe object :)
          //angular.extend(vm.recipe, recipe);
          //vm.recipe = recipe;
          //console.log('thumb construction', vm.recipe.getThumb('s'));

          this.modal.close();
          alert.push('success', 'Image sauvegardée');
        }.bind(this), function (error) {
          //TOOD préciser si déja en base de données ou quoi
          alert.push('danger', "Votre image n'a pu être sauvegardée");
        });
      } else {
        //create and POST the recipe
        //TODO transform the recipe in a suitable structure for the API
        var newRecipe = new Recipe(vm.recipe); //pass the parameters as init
        newRecipe.saveAsDraft(fd).then(function (recipe) {
          //then get the ID and put it into the recipe object :)
          //angular.extend(vm.recipe, recipe);
          vm.recipe = recipe;
          console.log('thum construction', vm.recipe.getThumb('s'));
          this.modal.close();
          alert.push('success', 'Image sauvegardée');
        }.bind(this), function (error) {
          //TOOD préciser si déja en base de données ou quoi
          alert.push('danger', "Votre image n'a pu être sauvegardée");
        });
      }
    };
    vm.bakingTypes = {
      MICROWAVE: false,
      HOB: false,
      OVEN: false
    };
    vm.recipe.numberOfMinutes = 0; //it can't be 0
    vm.sliderOptions = {
      //bindIndexForStepsArray : true,
      stepsArray: [{
        value: '0'
      }, {
        value: '5'
      }, {
        value: '15'
      }, {
        value: '30'
      }, {
        value: '45'
      }, {
        value: '60'
      }, {
        value: '90'
      }, {
        value: '90+'
      }],
      onChange: function onChange() {
        if (parseInt(vm.recipe.numberOfMinutes)) {
          vm.addCompletionFeature('minutes');
        } else {
          vm.removeCompletionFeature('minutes');
        }
      }
    };
    vm.typeOptions = [{
      name: 'Entrée',
      _id: 'ENTRY'
    }, {
      name: 'Plat principal',
      _id: 'MAIN'
    }, {
      name: 'Dessert',
      _id: 'DESSERT'
    }, {
      name: 'Apéritif',
      _id: 'APERITIF'
    }, {
      name: 'Boisson',
      _id: 'DRINK'
    }, {
      name: 'Sauce',
      _id: 'SAUCE'
    }];
    vm.onHeatChange = function () {
      if (vm.needsHeat === true) {
        vm.COMPLETION_STEP = 100 / 7;
      } else {
        //TODO remove here the 2 things from completion features
        vm.COMPLETION_STEP = 100 / 5;
        //reinit the value for baking types and baking time
        vm.recipe.bakingTime = 0;
        vm.bakingTypes = {
          MICROWAVE: false,
          HOB: false,
          OVEN: false
        };
        vm.removeCompletionFeature('bakingTime');
        vm.removeCompletionFeature('bakingType');
      }
      vm.recomputeCompletion();
    };
    vm.onBakingTimeChange = function () {
      if (vm.recipe.bakingTime) {
        vm.addCompletionFeature('bakingTime');
      } else {
        vm.removeCompletionFeature('bakingTime');
      }
    };
    vm.onPeopleChange = function () {
      if (vm.recipe.numberOfPeople) {
        vm.addCompletionFeature('numberOfPeople');
      } else {
        vm.removeCompletionFeature('numberOfPeople');
      }
    };
    vm.onBakingTypesChange = function () {
      //TODO maybe set here a new
      var isSomeValueSet = false;
      vm.recipe.bakingType = []; //reinit and refill that
      Object.keys(vm.bakingTypes).forEach(function (bakingTypeValue) {
        if (vm.bakingTypes[bakingTypeValue] === true) {
          isSomeValueSet = true;
          vm.recipe.bakingType.push(bakingTypeValue);
        }
      });
      if (isSomeValueSet) {
        vm.addCompletionFeature('bakingType');
      } else {
        vm.removeCompletionFeature('bakingType');
      }
    };
    vm.onTypeChange = function () {
      //do nothing for now
      if (typeof vm.recipe.type !== 'undefined') {
        vm.addCompletionFeature('type');
      } else {
        vm.removeCompletionFeature('type');
      }
    };
    vm.onTitleChange = function () {
      if (vm.recipe.title) {
        vm.addCompletionFeature('title');
      } else {
        vm.removeCompletionFeature('title');
      }
    };
    vm.addCompletionFeature = function (featureName) {
      if (vm.completionFeatures.indexOf(featureName) === -1) {
        vm.completionFeatures.push(featureName);
      }
      vm.recomputeCompletion();
    };
    vm.removeCompletionFeature = function (featureName) {
      var index = vm.completionFeatures.indexOf(featureName);
      if (index > -1) {
        //find the element and remove it
        vm.completionFeatures.splice(index, 1);
      }
      vm.recomputeCompletion();
    };
    vm.recomputeCompletion = function () {
      vm.realCompletion = vm.COMPLETION_STEP * vm.completionFeatures.length;
      vm.currentCompletion = parseInt(vm.realCompletion);
      console.log(vm.currentCompletion);
      vm.widthProgressBar = {
        width: vm.currentCompletion + '%'
      };
      if (vm.currentCompletion === 100) {
        context.set({
          iconCallback: function () {
            //alert.push('success', "OK Passer à l'étape suivante");
            /**var fd = new FormData();
            if (this.myCroppedImage) {
            	var fileBuiltFromeBase64 = dataURLtoFile(this.myCroppedImage, 'recipe');
            	fd.append('file', fileBuiltFromeBase64);//pass the file newly created
            }
            
            Object.keys(vm.recipe).forEach(function(key) {
            	fd.append(key, vm.recipe[key]);
            });**/
            vm.goToStepTwo();

            //TODO switch to next step
            /**$state.go('recipecreationstep', {
            	id: vm.recipe.slug,
            	step: '2'
            });
            	//save using PUT with just the image
            vm.recipe.update(vm.recipe, false).then(function (recipe) {
            	//then get the ID and put it into the recipe object :)
            	//angular.extend(vm.recipe, recipe);
            	//vm.recipe = recipe;
            }, function (error) {
            	//TODO treat this case more carefully
            	//alert.push('danger', "Le call a échoué veuillez réessayer ultérieurement");
            });**/
          }.bind($scope),
          iconAction: 'arrow-left reversed bigger'
        });
      } else {
        context.set({
          iconCallback: function iconCallback() {
            vm.formSubmitted = true;
            alert.push('danger', "Veuillez compléter le formulaire pour passer à l'étape suivante");
          },
          iconAction: 'arrow-left reversed bigger'
        });
      }
    };
    context.set({
      goBack: false,
      title: "Création de votre recette et calcul automatique de ses apports nutritionnels",
      contextName: 'Créer ma recette (1/3)',
      iconAction: 'arrow-left reversed bigger',
      iconCallback: function iconCallback() {
        vm.goToStepTwo();
      }
    });
    var stepNumber = $state.params.step;
    if (stepNumber === '1') {
      context.set({
        title: "Création de votre recette et calcul automatique de ses apports nutritionnels",
        contextName: 'Créer ma recette (1/3)',
        iconAction: 'arrow-left reversed bigger',
        iconCallback: function iconCallback() {
          vm.formSubmitted = true;
          alert.push('danger', "Veuillez remplir le formulaire pour passer à l'étape suivante");
        }
      });
    } else if (stepNumber === '2') {
      context.set({
        title: "Création de votre recette et calcul automatique de ses apports nutritionnels",
        contextName: 'Créer ma recette (2/3)',
        iconAction: 'arrow-left reversed bigger',
        iconCallback: function iconCallback() {
          //if there is at least one ingredient save and got next
          vm.goToStepThree();
        }
      });
    } else if (stepNumber === '3') {
      context.set({
        title: "Création de votre recette et calcul automatique de ses apports nutritionnels",
        contextName: 'Créer ma recette (3/3)',
        iconAction: 'arrow-left reversed',
        //TODO icon for
        iconCallback: function iconCallback() {
          vm.publishRecipe();
        }
      });
    }
    var WORDING_FOR_THE_NON_RELEVANT_INGREDIENT = 'Les résultats ne sont pas pertinents';
    vm.ingredientsSearchResult = function (ingredientName) {
      vm.ingredientSelectedBackupName = ingredientName;
      //here return a promise
      return ingredientsManager.searchAutocomplete(ingredientName).then(function (results) {
        console.log('results of ingredient search', results);
        //only push if at least one result
        if (results.length > 0) {
          results.push({
            word: WORDING_FOR_THE_NON_RELEVANT_INGREDIENT,
            data: [WORDING_FOR_THE_NON_RELEVANT_INGREDIENT]
          });
        }
        //add here a non matched result
        return results;
      }, function (err) {
        console.log('erreur loading all profiles');
        console.log(err);
      });
    };
    vm.typeaheadOnSelect = function (item, model, label, event, viewValue) {
      //here perform a call to the back end and get more info about this ingredient
      var slugOfIngredient = item.data[0];

      //if click on ingredient non relevant, display the proper thing
      if (slugOfIngredient === WORDING_FOR_THE_NON_RELEVANT_INGREDIENT) {
        vm.ingredientSelected = vm.ingredientSelectedBackupName;
        vm.noResults = true;
      } else {
        //push it in the thread
        vm.ingredientSelected = '';
        ingredientsManager.getQuick(slugOfIngredient).then(function (result) {
          console.log('and the ingredient is', result);
          vm.recipe.ingredientsQuantity.unshift({
            ingredient: result,
            measures: result.measures,
            position: -vm.recipe.unknownIngredientsQuantity.length - vm.recipe.ingredientsQuantity.length
          });
        });
      }

      //then push it to the ingredients list
      //vm.recipe.ingredients
      console.log(item, model, label, event, viewValue);
    };
    vm.onIngredientDelete = function (ingName) {
      var indexObject = vm.recipe.ingredientsQuantity.map(function (ingredientQuantity) {
        return ingredientQuantity.ingredient.name;
      }).indexOf(ingName);
      vm.recipe.ingredientsQuantity.splice(indexObject, 1);
    };
    vm.onUnkownIngredientDelete = function (ingName) {
      var indexObject = vm.recipe.unknownIngredientsQuantity.map(function (ingredientQuantity) {
        return ingredientQuantity.ingredient;
      }).indexOf(ingName);
      vm.recipe.unknownIngredientsQuantity.splice(indexObject, 1);
    };
    vm.checkIfAllInstructionsAreOk = function () {
      return vm.recipe.instructions.length > 0;
    };
    vm.checkIfAllIngredientsAreOk = function () {
      var ans = true,
        allingredients = vm.recipe.ingredientsQuantity.concat(vm.recipe.unknownIngredientsQuantity);
      if (allingredients.length > 0) {
        allingredients.forEach(function (ingredientQuantity) {
          ingredientQuantity.isValid = ingredientQuantity.ingredient && ingredientQuantity.quantity && ingredientQuantity.measure;
          if (!ingredientQuantity.isValid) {
            ans = false;
          }
        });
      } else {
        ans = false;
      }
      return ans;
    };
    vm.sortIngredientListArray = function (ingredientQuantity, testValue, other) {
      console.log('sortingredients', ingredientQuantity, testValue, other);
      return ingredientQuantity._id || ingredientQuantity.position;
    };
    vm.onAddUnknownIngredient = function () {
      if (!vm.recipe.unknownIngredientsQuantity) {
        //vm.recipe.unknownIngredientsQuantity = [];
        vm.loadMeasures();
      }
      vm.recipe.unknownIngredientsQuantity.unshift({
        ingredient: vm.ingredientSelected,
        position: -vm.recipe.unknownIngredientsQuantity.length - vm.recipe.ingredientsQuantity.length
      });
      //or add measures on the ingredient
    };
    vm.loadMeasures = function () {
      measuresManager.getAll().then(function (measures) {
        console.log('measures are ', measures);
        vm.measures = measures.collection;
      }, function (err) {
        console.log('error loafing all measures');
      });
    };
    vm.getColor = function (ingredientName) {
      var nbColors = INGREDIENTS_COLORS.length,
        toBeReturned = INGREDIENTS_COLORS[0];
      if (ingredientName) {
        var firstLetter = parseInt(ingredientName.charAt(0), 36) - 9;
        if (ingredientName.length > 1) {
          var secondLetter = parseInt(ingredientName.charAt(1), 36) - 9,
            average = (firstLetter + secondLetter) / 2,
            ratio = average / 26; //26 is the number of letters in occidental alphabet
          toBeReturned = INGREDIENTS_COLORS[Math.trunc(ratio * nbColors)];
        } else {
          toBeReturned = INGREDIENTS_COLORS[Math.trunc(firstLetter / 26 * nbColors)];
        }
      }
      console.log(toBeReturned);
      return toBeReturned;
    };
    vm.addInstruction = function () {
      vm.recipe.instructions.push({
        editMode: false,
        instruction: vm.currentInstruction,
        position: vm.currentPosition
      });
      vm.currentInstruction = '';
      vm.currentPosition = vm.recipe.instructions.length + 1;
    };
    vm.removeInstruction = function (index) {
      vm.recipe.instructions.splice(index, 1);
    };
    vm.dragControlListeners = {
      itemMoved: function itemMoved(event) {
        //Do what you want
        console.log('item moved');
      },
      orderChanged: function orderChanged(event) {
        //Do what you want
        var previousIndex = event.source.index,
          newIndex = event.dest.index;
        console.log('order has changed from ', previousIndex, 'to', newIndex);
      },
      containment: '#instructions-container'
    };
    vm.goToStepTwo = function () {
      vm.formSubmitted = true;
      if (vm.currentCompletion === 100) {
        //save using PUT with just the image
        vm.recipe.update(vm.recipe, false).then(function (recipe) {
          //navigate only when I Have the result back ?
          $state.go('recipecreationstep', {
            id: vm.recipe._id,
            step: '2'
          });
        }, function (error) {
          //TODO treat this case more carefully
          alert.push('danger', 'Le call a échoué veuillez réessayer ultérieurement');
        });
      } else {
        alert.push('danger', "Veuillez compléter le formulaire pour passer à l'étape suivante");
      }
    };
    vm.goToStepThree = function () {
      if (vm.checkIfAllIngredientsAreOk()) {
        //alert.push('success', "OK passer à l'étape 3");

        vm.recipe.update(vm.recipe, false).then(function (recipe) {
          //then get the ID and put it into the recipe object :)
          //angular.extend(vm.recipe, recipe);
          $state.go('recipecreationstep', {
            id: vm.recipe._id,
            step: '3'
          });
          //vm.recipe = recipe;
        }, function (error) {
          //TODO treat this case more carefully
          alert.push('danger', 'Le call a échoué veuillez réessayer ultérieurement');
        });
      } else {
        vm.showValidity = true;
        alert.push('danger', "Veuillez renseigner les ingrédients pour passer à l'étape suivante");
      }
    };
    vm.goBackToStep = function (number) {
      $state.go('recipecreationstep', {
        id: vm.recipe._id,
        step: number + ''
      });
    };
    vm.publishRecipe = function () {
      //if there is at least one ingredient save and got next
      if (vm.checkIfAllInstructionsAreOk()) {
        vm.recipe.update(vm.recipe, false).then(function (recipe) {
          vm.recipe = recipe;
          alert.push('success', 'La recette a été publiée');
          $state.go('recipe', {
            id: vm.recipe.slug
          });
        }, function () {
          //TODO treat this case more carefully
          alert.push('danger', 'Le call a échoué veuillez réessayer ultérieurement');
        });
      } else {
        vm.showInstructionsValidity = true;
        alert.push('danger', 'Veuillez décrire au moins une instruction');
      }
    };
  }
})();

/* eslint-disable no-undef */
(function () {
  angular.module('meanApp').controller('recipeReadCtrl', recipeReadCtrl);
  recipeReadCtrl.$inject = ['$scope', '$location', 'context', '$uibModal', 'recipesManager', 'measuresManager', 'Recipe', '$state', 'nutritionService', 'colors', '$sce', '$compile', 'currentUser', 'tagService']; //used for sanityzing html
  function recipeReadCtrl($scope, $location, context, $uibModal, recipesManager, measuresManager, Recipe, $state, nutritionService, Colors, $sce, $compile, currentUser, tagService) {
    var vm = this,
      INGREDIENTS_COLORS = ['#F49AC2', '#CB99C9', '#C23B22', '#FFD1DC', '#DEA5A4', '#AEC6CF', '#77DD77', '#B39EB5', '#FFB347', '#B19CD9', '#FF6961', '#03C03C', '#FDFD96', '#779ECB', '#966FD6'];
    vm.currentCompletion = 0; //used to display the progress bar
    vm.currentIndex = 0;
    vm.widthProgressBar = {
      width: vm.currentCompletion + '%'
    };
    //vm.areGoodthingsExpanded = false;
    vm.goodThings = [];
    vm.badThings = [];
    vm.recipe = {};
    vm.recipe.interactions = {};

    //for widgetisation integration : 
    vm.widgetPreviewOptions = {
      image: true,
      nutriscore: true,
      goodThings: true,
      badThings: true,
      nutritags: true,
      monthProduction: false
    };
    vm.getCodeToSelect = function () {
      var domain = document.location.origin;
      return vm.recipe._id ? $sce.trustAsHtml("<div class='" + vm.getClassesToHide() + "' ng-app=\"meanApp\" id=\"fob-widget\" ng-controller=\"ingredientWidgetCtrl\" widget-data='" + vm.getWidgetData() + "'>Infos nutritionnelles</div><script type=\"text/javascript\" src=\"" + domain + "/ing.w1.js\"></script>") : 'Veuillez chercher une recette pour générer du code HTML';
    };
    vm.onCopyInClipboard = function () {
      navigator.clipboard.writeText(vm.getCodeToSelect()).then(function () {
        vm.copyButtonClicked = true;
      }, function () {
        //note n°3 : if this fails (like on safari for instance... :( ) may be fallback here on the old execCommand API
      });
    };
    vm.getClassesToHide = function () {
      var classes = '';
      if (vm.widgetPreviewOptions.image === false) {
        classes += 'aa ';
      }
      if (vm.widgetPreviewOptions.nutriscore === false) {
        classes += 'bb ';
      }
      classes += 'cc'; //hide the months by default
      if (vm.widgetPreviewOptions.goodThings === false) {
        classes += 'dd ';
      }
      if (vm.widgetPreviewOptions.badThings === false) {
        classes += 'ee ';
      }
      if (vm.widgetPreviewOptions.nutritags === false) {
        classes += 'ff ';
      }
      //vm.classes= classes;
      return classes;
    };
    vm.getWidgetData = function () {
      var widgetData = {
        _id: vm.recipe._id,
        title: vm.recipe.title,
        price: Math.round(vm.recipe.price * 10) / 10,
        slug: vm.recipe.slug,
        hexDominantColor: vm.recipe.hexDominantColor,
        percentageFruitsAndVegetables: vm.recipe.percentageFruitsAndVegetables,
        nutrientsQuantity: vm.recipe.nutrientsQuantity ? vm.recipe.nutrientsQuantity.map(function (nutrientQuantity) {
          //return a cleaned and lighter structure for the widget
          return {
            nutrient: {
              _id: nutrientQuantity.nutrient._id,
              unit: nutrientQuantity.nutrient.unit
            },
            quantity: Math.round(nutrientQuantity.quantity * 10) / 10
          };
        }) : [],
        monthsSoldInFrance: vm.recipe.monthsSoldInFrance,
        nutriscoreLetter: vm.recipe.nutriscore,
        tagNames: vm.recipe.tags,
        almostTags: vm.recipe.almostTags
      };
      //here reduce the amount od data passed
      return JSON.stringify(widgetData);
    };
    vm.triggerCodePreview = function () {
      //1- we need to load the ingredient-nutrition widget file
      var domain = document.location.origin;
      vm.loadScript(domain + '/widget/ingredient-nutrition.js', function () {
        var widgetEl = angular.element(document.getElementById('fob-widget'));
        $compile(widgetEl.contents())($scope);
      });
    };
    vm.onPreviewChange = function () {
      //vm.getCodeToSelect();
      var widgetEl = angular.element(document.getElementById('fob-widget'));
      $compile(widgetEl.contents())($scope);
    };
    vm.getTagTranslated = function (tag) {
      return tagService.wording[tag];
    };
    vm.typeaheadOnSelect = function (item) {
      //here perform a call to the back end and get more info about this ingredient
      var slugOfRecipe = item.slug;
      console.log('the slug of the recipe is ', slugOfRecipe);
      vm.goodThings = [];
      vm.badThings = [];
      recipesManager.get(slugOfRecipe, false, true).then(function (result) {
        vm.recipe = result;
        vm.typedRecipe = vm.recipe.title;
        vm.nutriscoreLetter = vm.recipe.nutriscore;
        vm.recipe.tagNames = vm.recipe.tags;
        var infoGoodAndBad = nutritionService.getGoodAndBadThings(result.nutrientsQuantity);
        vm.goodThings = infoGoodAndBad.goodThings;
        vm.badThings = infoGoodAndBad.badThings;

        //TODO addothergoodthings to be refactored
        vm.addOtherGoodThings(vm.goodThings);
      });
    };

    //TODO to be moved in a utils
    vm.loadScript = function (url, callback) {
      if (url) {
        var script = document.querySelector("script[src*='" + url + "']");
        //if (!script) {
        var heads = document.getElementsByTagName('head');
        if (heads && heads.length) {
          var head = heads[0];
          if (head) {
            script = document.createElement('script');
            script.setAttribute('src', url);
            script.setAttribute('type', 'text/javascript');
            script.onload = function () {
              callback && callback();
            };
            script.onerror = function () {
              callback && callback();
            };
            //if (charset) script.setAttribute('charset', charset);
            head.appendChild(script);
          }
        }
        //}
        return script;
      }
    };
    var updateCompletionAndScroller = function updateCompletionAndScroller() {
      vm.currentCompletion = 100 * (vm.currentIndex + 1) / vm.recipe.instructions.length;
      vm.widthProgressBar = {
        width: vm.currentCompletion + '%'
      };
      //smoooth
      var element = document.getElementById('step-' + vm.currentIndex),
        elementForOffset = document.querySelector('.next-prev-container'),
        isDesktop = document.querySelector('.mobile-nav') && document.querySelector('.mobile-nav').offsetHeight > 0;
      if (isDesktop && elementForOffset) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: elementForOffset.offsetHeight ? 'center' : 'start' //center if desktop
        });
      }
    };
    vm.scrollToInstructions = function () {
      /*var element = document.getElementById('instructions');
               if(element) {
                   element.scrollIntoView({
                       behavior: 'smooth'
                   });
               }*/
      //scroll is not working properly so for now just go to instructions
      vm.goToInstructions();
    };
    vm.goToInstructions = function () {
      $state.go('recipeInstructions', {
        id: vm.recipe.slug
      });
    };
    vm.goToNextInstruction = function (event) {
      event.stopPropagation();
      if (vm.currentIndex < vm.recipe.instructions.length) {
        vm.currentIndex++;
        updateCompletionAndScroller();
      }
    };
    vm.goToInstruction = function (index) {
      vm.currentIndex = index;
      updateCompletionAndScroller();
    };
    vm.goToPreviousInstruction = function (event) {
      event.stopPropagation();
      if (vm.currentIndex !== 0) {
        vm.currentIndex--;
        updateCompletionAndScroller();
      }
    };
    vm.addOtherGoodThings = function (goodThings) {
      if (vm.recipe.pricePerKilo < 5) {
        goodThings.push({
          name: 'Economique',
          description: 'Ce produit est économique',
          level: 1,
          iconName: 'fob-moneybox'
        });
      }
      if (vm.recipe.tags.indexOf('local') > -1) {
        goodThings.push({
          name: 'Local',
          description: 'Ce produit peut provenir de France métropolitaine',
          level: 1,
          iconName: 'fob-crosshair'
        });
      }
      if (vm.recipe.percentageFruitsAndVegetables > 80) {
        goodThings.push({
          name: 'Fruits & Légumes',
          description: 'Ce produit contient plus de 80% de fruits et légumes',
          level: 1,
          iconName: 'fob-carrot-and-apple'
        });
      }
    };

    //this means we are in the context of widgetisation
    if ($state.params.slug) {
      recipesManager.get($state.params.slug, false, true).then(function (result) {
        vm.recipe = result;
        vm.typedRecipe = vm.recipe.title;
        vm.nutriscoreLetter = vm.recipe.nutriscore;
        vm.recipe.tagNames = vm.recipe.tags;
        var infoGoodAndBad = nutritionService.getGoodAndBadThings(result.nutrientsQuantity);
        vm.goodThings = infoGoodAndBad.goodThings;
        vm.badThings = infoGoodAndBad.badThings;

        //TODO addothergoodthings to be refactored
        vm.addOtherGoodThings(vm.goodThings);
      });
    }
    if ($state.params.id) {
      recipesManager.get($state.params.id, false, true).then(function (result) {
        vm.recipe = result;

        // set bad and good things about the recipe
        var infoGoodAndBad = nutritionService.getGoodAndBadThings(result.nutrientsQuantity);
        vm.recipe.goodThings = infoGoodAndBad.goodThings;
        vm.recipe.badThings = infoGoodAndBad.badThings;
        vm.recipe.hexDominantColorAlpha = Colors.hexToHSLLighter(vm.recipe.hexDominantColor, 70);
        //vm.recipe.hexDominantColor = Colors.getClosestColorPossible(vm.recipe.hexDominantColor);
        //ar indexOfInsertion = vm.recipe.hexDominantColor.indexOf(')') -1;
        //vm.recipe.linearStyle = "{background: 'linear-gradient(to left top, "+vm.recipe.hexDominantColorAlpha+" 30%, "+ vm.recipe.hexDominantColor+" 100%)'}";
        vm.recipe.linearStyle = 'linear-gradient(to right top, ' + vm.recipe.hexDominantColor + ' 40%, ' + vm.recipe.hexDominantColorAlpha + ' 100%)';
        console.log('the linear style is', vm.recipe.linearStyle);
        vm.addOtherGoodThings(vm.recipe.goodThings);
        vm.currentCompletion = 100 * 1 / vm.recipe.instructions.length;
        vm.widthProgressBar = {
          width: vm.currentCompletion + '%'
        };

        //If there is a current user and the current user is the author of the recipe, then
        //the edit button must be put in the context bar

        var contextParams = {
          title: this._getTitle(result.title),
          contextName: result.title,
          colorBackground: result.hexDominantColor,
          dropDownActions: [{
            iconName: 'widget',
            actionTitle: 'Widget',
            dropdownActionCallback: function dropdownActionCallback() {
              vm.goToWidgetisation();
            }
          }]
        };
        currentUser.get().then(function (userModel) {
          if (userModel._id === vm.recipe.author._id) {
            vm.displayEditButton = true;
            /*contextParams.iconCallback = function() {
            	vm.goToEditRecipe(vm.recipe);
            };
            contextParams.iconAction = 'pencil';*/
            contextParams.dropDownActions.push({
              iconName: 'pencil',
              actionTitle: 'Modifier',
              dropdownActionCallback: function dropdownActionCallback() {
                vm.goToEditRecipe(vm.recipe);
              }
            });
          }
          context.set(contextParams);
        });
        vm.recipe.getInteractions().then(function (data) {
          vm.recipe.interactions = data;
          console.log('the api interactions on ingredient succeeded', data);
        }, function () {
          console.log('the api like on ingredient failed');
        });

        //do this special treatment only when in the zen mode for instructions otherwise this fucks up the DATA
        if ($state.current.name === 'recipeInstructions') {
          vm.recipe.instructionsHaveMarkup = true;
          vm.performArtificialIntelligenceOnInstructions();
        }
      }.bind(this), function (err) {
        console.log('error loading the ingredient', err);
      });
    } else {
      context.set({
        title: "Widget de recette avec ses infos nutritionnelles",
        contextName: 'Widget'
      });
    }
    this._getTitle = function (title) {
      var ansTitle = title + ", sa recette et ses infos nutritionnelles";
      if ($state.current.name === 'recipeInstructions') {
        ansTitle = "Préparation facile de la recette " + title;
      }
      return ansTitle;
    };
    vm.performArtificialIntelligenceOnInstructions = function () {
      //first go into every instruction and change the dom to highlight keywords
      var ingredientsQuantity = vm.recipe.ingredientsQuantity.concat(vm.recipe.unknownIngredientsQuantity),
        ingredientName,
        splittedIngredient = [],
        wordsBlackList = ['de', 'la', 'les', 'le', 'et', 'en'];
      //splitting by empty space ? what about '-' ?
      //cool test
      ingredientsQuantity.forEach(function (ingredientQuantity) {
        ingredientName = ingredientQuantity.ingredient.name || ingredientQuantity.ingredient; // can be known or unknown ingredients
        if (ingredientName) {
          //replace the words into parenthesis
          ingredientName = ingredientName.replace('(', '').replace(')', '');
          splittedIngredient = ingredientName.split(' ');
          //remove common words
          splittedIngredient = splittedIngredient.filter(function (splittedIngWord) {
            return wordsBlackList.indexOf(splittedIngWord) === -1;
          });
          splittedIngredient.forEach(function (splittedIngredientWord) {
            vm.recipe.instructions.forEach(function (instruction, index) {
              //if the word is found then
              //add the wrapping around ALL words with regexp
              instruction.instruction = instruction.instruction.replace(new RegExp(splittedIngredientWord, 'gi'), function (match) {
                //push the index of the step on the ingredient
                if (!ingredientQuantity.stepRelated) {
                  ingredientQuantity.stepRelated = [index];
                } else if (ingredientQuantity.stepRelated.indexOf(index) === -1) {
                  //if not already into array, push it
                  ingredientQuantity.stepRelated.push(index);
                }
                return '<span class="highlighted-ingredient">' + match + '</span>';
              });
            });
          });
        }
      });

      //sanytize the values now
      vm.recipe.instructions.forEach(function (instruction) {
        instruction.instruction = $sce.trustAsHtml(instruction.instruction);
      });
    };
    vm.goToEditRecipe = function (recipe) {
      $state.go('recipecreationstep', {
        id: recipe.slug,
        step: '1'
      });
    };
    vm.goToWidgetisation = function () {
      $state.go('recipeWidget', {
        slug: vm.recipe.slug
      });
    };
    vm.goToAuthorPage = function () {
      $state.go('profile.info', {
        id: vm.recipe.author._id
      });
    };
    vm.loadMeasures = function () {
      measuresManager.getAll().then(function (measures) {
        console.log('measures are ', measures);
        vm.measures = measures.collection;
      }, function (err) {
        console.log('error loading all measures', err);
      });
    };
    vm.getColor = function (ingredientName) {
      var nbColors = INGREDIENTS_COLORS.length,
        toBeReturned = INGREDIENTS_COLORS[0],
        firstLetter = parseInt(ingredientName.charAt(0), 36) - 9;
      if (ingredientName.length > 1) {
        var secondLetter = parseInt(ingredientName.charAt(1), 36) - 9,
          average = (firstLetter + secondLetter) / 2,
          ratio = average / 26; //26 is the number of letters in occidental alphabet
        toBeReturned = INGREDIENTS_COLORS[Math.trunc(ratio * nbColors)];
      } else {
        toBeReturned = INGREDIENTS_COLORS[Math.trunc(firstLetter / 26 * nbColors)];
      }
      console.log(toBeReturned);
      return toBeReturned;
    };
    vm.onLikeRecipe = function () {
      if (vm.recipe.interactions.isLiked) {
        vm.recipe.unlike();
        vm.recipe.interactions.likeCount--;
      } else {
        vm.recipe.like();
        vm.recipe.interactions.likeCount++;
      }

      //increase counter as well
      vm.recipe.interactions.isLiked = !vm.recipe.interactions.isLiked;
    };
    vm.onBookmarkRecipe = function () {
      if (vm.recipe.interactions.isBookmarked) {
        vm.recipe.unbookmark();
        vm.recipe.interactions.bookmarkCount--;
      } else {
        vm.recipe.bookmark();
        vm.recipe.interactions.bookmarkCount++;
      }
      vm.recipe.interactions.isBookmarked = !vm.recipe.interactions.isBookmarked;
    };
    vm.absoluteRef = function (id) {
      return 'url(' + $location.absUrl() + '#' + id + ')';
    };
    vm.recipesSearchResult = function (recipeTitle) {
      //here return a promise
      return recipesManager.searchRecipes([recipeTitle], 1).then(function (results) {
        //eventual special treatment
        return results.docs;
      }, function (err) {
        console.log('err', err);
      });
    };
    vm.onExportFirst = function (id) {
      html2canvas(document.getElementById(id), {
        allowTaint: true
      }).then(function (canvas) {
        var link = document.createElement("a");
        document.body.appendChild(link);
        link.download = vm.recipe.title + '_' + id;
        link.href = canvas.toDataURL("image/png");
        link.target = '_blank';
        link.click();
      });
    };
  }
})();
(function () {
  angular.module('meanApp').controller('homeCtrl', homeCtrl);
  homeCtrl.$inject = ['$scope', '$rootScope', '$location', 'authentication', 'loginModal', 'searchModal', 'context', '$state'];
  function homeCtrl($scope, $rootScope, $location, authentication, loginModal, searchModal, context, $state) {
    var vm = this;
    /*vm.triggerFacebook = function () {
    	if ( FB && FB.XFBML) {
    				FB.XFBML.parse();
    			}
    };*/

    context.set({
      href: '/about',
      contextName: 'Home',
      iconAction: 'info',
      goBack: false
    });
    vm.width = window.innerWidth;
    vm.height = window.innerHeight - vm.width / 5;
    if (vm.width < 768) {
      //height is bigger
      if (vm.width < vm.height) {
        vm.url = '/api/images/saladspinach-min.jpg?dim=250x350';
      } else {
        vm.url = '/api/images/saladspinach-min.jpg?dim=350x250';
      }
    } else if (vm.width < 992) {
      vm.url = '/api/images/saladspinach-min.jpg?dim=600';
    } else {
      vm.url = '/api/images/saladspinach-min-30.jpg?dim=850';
      //vm.url = '/api/images/saladspinach-min-blur.jpg?dim=900'
      //test
    }
    vm.loaded = false;
    vm.tabSelected = 0;
    vm.email = '';
    vm.provider = 'local';
    vm.isHidden = false; //routeParams.emailSaved ? true : false;

    vm.showSendEmail = false;
    vm.nutrition = {
      bacon: {
        first: {
          title: 'Lettre A',
          text: "Le meilleur score nutritionnel qu'un repas puisse obtenir au code 5 couleurs dit '5-C' élaboré par le professeur Hercberg."
        },
        second: {
          text: 'Quantité de protéines présente dans les fraises',
          title: '0%'
        },
        third: {
          text: 'Quantité de matières grasses saturées présente dans les fraises',
          title: '0%'
        },
        fourth: {
          text: 'Nombre de calories pour 100g de fraise',
          title: '33'
        }
      },
      strawberry: {
        first: {
          title: 'Lettre E',
          text: "Le score nutritionnel le plus faible qu'un repas puisse obtenir au code 5 couleurs dit '5-C' élaboré par le professeur Hercberg"
        },
        second: {
          text: 'Quantité de protéines présente dans le bacon grillé',
          title: '37%'
        },
        third: {
          text: 'Quantité de matières grasses saturées présente dans le bacon grillé',
          title: '14%'
        },
        fourth: {
          text: 'Nombre de calories pour 100g de bacon grillé',
          title: '541'
        }
      }
    };
    vm.selectTab = function (tabNumber) {
      console.log('select tab in home controller');
      vm.tabSelected = tabNumber;
      window.scrollTo(0, 0);
    };
    vm.goToIntermediateSearch = function () {
      //if on mobile YES, otherwise must go to the direct search by tag
      /*if($rootScope.isMobile) {
                   searchModal.open();
               }
               else {*/
      $state.go('recipeSearchStep', {
        step: 1
      });
      //}
    };
    vm.goTo = function (hash) {
      $location.hash(hash);
    };
  }
})();
(function () {
  angular.module('meanApp').controller('intermediateSearchCtrl', intermediateSearchCtrl);
  intermediateSearchCtrl.$inject = ['$scope', '$location', 'authentication', 'loginModal', 'searchModal', 'context', '$state', 'searchData'];
  function intermediateSearchCtrl($scope, $location, authentication, loginModal, searchModal, context, $state, searchData) {
    var vm = this;
    if (searchData.getTextSearch()) {
      vm.searchQueryPrefilled = true;
      vm.searchQuery = searchData.getTextSearch();
    }
    vm.goToSearchStepOne = function () {
      searchModal.modalInstance.close();
      $state.go('recipeSearchStep', {
        step: '1'
      });
    };
    vm.goToSearchResultByText = function () {
      searchModal.modalInstance.close();
      $state.go('recipeTextSearchResult', {
        search: vm.searchQuery
      });
    };
  }
})();
(function () {
  angular.module('meanApp').controller('PersonaController', personaController);
  personaController.$inject = ['$scope'];
  function personaController($scope) {
    this.index = Math.floor(Math.random() * 4) + 0;
    this.personasInfos = [{
      text: 'Marie est soucieuse de sa santé et de son bien être. Elle souhaite perdre quelques kilos sans perdre de temps à cuisiner.',
      tags: [{
        value: 'fast'
      }, {
        value: 'lowcalory'
      }],
      avatarClass: 'marieavatar',
      name: 'Marie'
    }, {
      text: 'Nathan est étudiant et souhaite manger pour peu cher. Mais il ne possède ni four ni micro ondes.',
      tags: [{
        value: 'fast'
      }, {
        value: 'nooven'
      }, {
        value: 'nomicrowave'
      }],
      avatarClass: 'nathanavatar',
      name: 'Nathan'
    }, {
      text: "Ce soir c'est vendredi et il fait très chaud. Clara invite ses collègues à prendre l'apéro. Un des convives ne mange pas de porc.",
      tags: [{
        value: 'aperitif'
      }, {
        value: 'cold'
      }, {
        value: 'nopig'
      }],
      avatarClass: 'fatihaavatar',
      name: 'Clara'
    }, {
      text: "Lito fréquente les salles de sport régulièrement. Son objectif est d'avoir un corps musclé. Il compose des menus protéinés pour accompagner sa métamorphose.",
      tags: [{
        value: 'protein'
      } /*, {value : 'lowcalory'}*/],
      avatarClass: 'litoavatar',
      name: 'Lito'
    }, {
      text: "Fatiha, jeune grand mère végétarienne accueille ses petits enfants pour le week end. Le plus jeune est allergique au gluten. Elle cherche une recette de crêpes sans gluten.",
      tags: [{
        value: 'vegetarian'
      }, {
        value: 'nogluten'
      }, {
        value: 'dessert'
      }],
      avatarClass: 'claraavatar',
      name: 'Fatiha'
    }];
    this.persona = this.personasInfos[this.index || 0];

    /**this.init = function () {
    	this.index = 0;
    	console.log('will init the value');	
    };**/

    this.onClick = function () {
      if (this.index === 4) {
        this.index = 0;
      } else {
        this.index = this.index + 1;
        //$scope.index = this.index;
      }
      this.persona = this.personasInfos[this.index || 0];
    };

    //function to increase the  index
  }
})();
(function () {
  angular.module('meanApp').controller('TagsController', tagsController);
  tagsController.$inject = ['$scope'];
  function tagsController($scope) {
    this.means = [{
      position: 0,
      name: 'complicated'
    }, {
      position: 0,
      name: 'nohob'
    }, {
      position: 3,
      name: 'eco'
    }, {
      position: 11,
      name: 'nooven'
    }, {
      position: 13,
      name: 'nomicrowave'
    }, {
      position: 21,
      name: 'fast'
    }];
    this.wayoflife = [{
      position: 1,
      name: 'protein'
    }, {
      position: 4,
      name: 'lowcarb'
    }, {
      position: 5,
      name: 'nopig'
    }, {
      position: 6,
      name: 'vegan'
    }, {
      position: 7,
      name: 'paleo'
    }, {
      position: 8,
      name: 'vegetarian'
    }, {
      position: 10,
      name: 'nogluten'
    }, {
      position: 9,
      name: 'local'
    }, {
      position: 18,
      name: 'lowcalory'
    }, {
      position: 19,
      name: 'season'
    }];
    this.desire = [{
      position: 2,
      name: 'cold'
    }, {
      position: 12,
      name: 'maincourse'
    }, {
      position: 14,
      name: 'entry'
    }, {
      position: 15,
      name: 'pleasure'
    }, {
      position: 16,
      name: 'savory'
    }, {
      position: 17,
      name: 'aperitif'
    }, {
      position: 20,
      name: 'dessert'
    }, {
      position: 22,
      name: 'sweet'
    }, {
      position: 23,
      name: 'hot'
    }];
    this.returnTagList = function () {
      var toBeReturned = [];
      if (this.meanActivated) {
        toBeReturned = toBeReturned.concat(this.means);
      }
      if (this.desireActivated) {
        toBeReturned = toBeReturned.concat(this.desire);
      }
      if (this.wayoflifeactivated) {
        toBeReturned = toBeReturned.concat(this.wayoflife);
      }

      //now sort the positions
      toBeReturned.sort(function (a, b) {
        if (a.position > b.position) {
          return -1;
        } else {
          return 1;
        }
      });
      this.tagList = toBeReturned;
    };
    this.all = true;
    this.meanActivated = true;
    this.desireActivated = true;
    this.wayoflifeactivated = true;
    this.returnTagList();

    //TODO creer des onclick
    this.onMeanClicked = function () {
      this.meanActivated = true;
      this.desireActivated = false;
      this.wayoflifeactivated = false;
      this.returnTagList();
    };
    this.ondesireClicked = function () {
      this.meanActivated = false;
      this.desireActivated = true;
      this.wayoflifeactivated = false;
      this.returnTagList();
    };
    this.onwayoflifeClicked = function () {
      this.meanActivated = false;
      this.desireActivated = false;
      this.wayoflifeactivated = true;
      this.returnTagList();
    };
    this.allClicked = function () {
      this.meanActivated = true;
      this.desireActivated = true;
      this.wayoflifeactivated = true;
      this.returnTagList();
    };
    this.data = {
      availableOptions: [{
        name: 'Tous les Tags',
        id: '1'
      }, {
        name: 'Tags de Mode de vie',
        id: '2'
      }, {
        name: "Tags d'Envies",
        id: '3'
      }, {
        name: "Tags d'Exigences",
        id: '4'
      }],
      selectedOption: {
        name: 'Tous les Tags',
        id: '1'
      }
    };
    this.selectChanged = function () {
      switch (this.data.selectedOption.id) {
        case '1':
          this.allClicked();
          break;
        case '2':
          this.onwayoflifeClicked();
          break;
        case '3':
          this.ondesireClicked();
          break;
        case '4':
          this.onMeanClicked();
          break;
      }
    };

    //function to increase the  index
  }
})();
(function () {
  angular.module('meanApp').filter('firstLetter', function () {
    return function (x) {
      if (!x) {
        return x;
      }
      x = x.toUpperCase();
      return x.charAt(0) || '';
    };
  }).filter('capitalizeFirst', function () {
    return function (x) {
      if (!x) {
        return x;
      }
      x = x.toLowerCase();
      return x.charAt(0).toUpperCase() + x.slice(1);
    };
  }).filter('roundToDecimal', function () {
    return function (x) {
      console.log('into decimal filter', x);
      if (!x) {
        return x;
      }
      x = parseFloat(x);
      x = Math.round(x * 10) / 10 + '';
      x = x.replace('.', ',');
      return x;
    };
  });
})();
(function () {
  angular.module('meanApp').factory('confirmationModal', ['$uibModal', function ($uibModal) {
    return {
      open: function open(scopeParam, controllerParam) {
        $uibModal.open({
          templateUrl: 'common/factories/confirmation.modal.view.html',
          controller: controllerParam,
          controllerAs: 'vm',
          scope: scopeParam
        });
      }
    };
  }]);
})();
(function () {
  angular.module('meanApp').factory('httpAuth', ['$http', 'authentication', 'loginModal', function ($http, auth, loginModal) {
    return {
      /**Make a call using the Bearer authenticationHeader**/
      _getAuthorizationHeader: function _getAuthorizationHeader() {
        return 'Bearer ' + auth.getToken();
      },
      _onAuthFailure: function _onAuthFailure(json, errorCode) {
        //TODO check if this is a 401
        //console.log('on auth failure', arguments);
        if (errorCode === 401) {
          loginModal.open(true);
        }
      },
      get: function get(url) {
        return $http.get(url, {
          headers: {
            Authorization: this._getAuthorizationHeader()
          }
        }).error(this._onAuthFailure);
      },
      put: function put(url, formData, config) {
        var configMerged = config;
        if (!configMerged['headers']) {
          configMerged['headers'] = {
            Authorization: this._getAuthorizationHeader()
          };
        } else {
          configMerged['headers']['Authorization'] = this._getAuthorizationHeader();
        }
        return $http.put(url, formData, configMerged).error(this._onAuthFailure);
      },
      post: function post(url, formData, config) {
        var configMerged = config;
        //add the header for auth without removing previous options passed away by JS.
        if (!configMerged['headers']) {
          configMerged['headers'] = {
            Authorization: this._getAuthorizationHeader()
          };
        } else {
          configMerged['headers']['Authorization'] = this._getAuthorizationHeader();
        }
        return $http.post(url, formData, configMerged).error(this._onAuthFailure);
      },
      "delete": function _delete(url) {
        return $http["delete"](url, {
          headers: {
            Authorization: this._getAuthorizationHeader()
          }
        }).error(this._onAuthFailure);
      }
    };
  }]);
})();
(function () {
  angular.module('meanApp').factory('searchModal', ['$uibModal', function ($uibModal) {
    this.modalInstance = null;
    return {
      /**Will open the register or login function according to controller**/
      open: function open(isLogin) {
        this.modalInstance = $uibModal.open({
          ariaLabelledBy: 'modal-title',
          ariaDescribedBy: 'modal-body',
          templateUrl: 'common/factories/search.modal.view.html',
          controller: 'intermediateSearchCtrl',
          controllerAs: 'vm',
          windowClass: 'intermediate-search-modal'
        });
      },
      get: function get() {
        return this.modalInstance;
      }
    };
  }]);
})();
(function () {
  angular.module('meanApp').factory('loginModal', ['$uibModal', function ($uibModal) {
    this.modalInstance = null;
    return {
      /**Will open the register or login function according to controller**/
      open: function open(isLogin) {
        this.modalInstance = $uibModal.open({
          ariaLabelledBy: 'modal-title',
          ariaDescribedBy: 'modal-body',
          templateUrl: 'auth/subscribe.view.html',
          controller: 'subscribeCtrl',
          controllerAs: 'vm',
          resolve: {
            isLogin: isLogin
          }
        });
      },
      get: function get() {
        return this.modalInstance;
      }
    };
  }]);
})();
(function () {
  angular.module('meanApp').factory('titleFactory', ['$rootScope', function ($rootScope) {
    //default title

    console.log('the title set is ', $rootScope.title);
    return {
      setTitle: function setTitle(newTitle) {
        $rootScope.title = newTitle;
        //$rootScope.$apply(); //force the refresh
      }
    };
  }]);
})();
(function () {
  angular.module('meanApp').factory('allergensManager', allergensManager);
  allergensManager.$inject = ["Allergen", "modelManager"];
  function allergensManager(Allergen, modelManager) {
    return angular.extend({}, modelManager.init(Allergen));
  }
  ;
})();
(function () {
  angular.module('meanApp').factory('departmentsManager', departmentsManager);
  departmentsManager.$inject = ["Department", "modelManager"];
  function departmentsManager(Department, modelManager) {
    return angular.extend({}, modelManager.init(Department));
  }
  ;
})();
(function () {
  angular.module('meanApp').factory('featuresManager', featuresManager);
  featuresManager.$inject = ["Feature", "modelManager"];
  function featuresManager(Feature, modelManager) {
    return angular.extend({}, modelManager.init(Feature));
  }
  ;
})();
(function () {
  // eslint-disable-next-line no-undef
  angular.module('meanApp').factory('ingredientsManager', ingredientsManager);
  ingredientsManager.$inject = ['Ingredient', 'modelManager', 'httpAuth', '$q'];
  function ingredientsManager(Ingredient, modelManager, httpAuth, $q) {
    // eslint-disable-next-line no-undef
    return angular.extend({
      //TODO later array of search texts ?? for now on just one word
      search: function search(text) {
        var deferred = $q.defer();
        httpAuth.get('/api/ingredients/?search=' + encodeURI(text)).success(function (ingredientsArray) {
          /**var users = []; 
                       usersArray.docs.forEach(function(userData) {
                           console.log(userData);
                           var user = scope._retrieveInstance(userData._id, userData);
                           users.push(user);
                       });**/
          //TODO if some ingredients are loaded push them here in the manager so they are cached :)
          deferred.resolve(ingredientsArray);
        }).error(function (err) {
          deferred.reject(err);
        });
        return deferred.promise;
      },
      _loadAutocomplete: function _loadAutocomplete(id, deferred) {
        var scope = this;
        httpAuth.get('/api/' + Ingredient.APIPath + '/' + id + '/?quick=true').success(function (data) {
          var instance = scope._retrieveInstance(data[Ingredient.idAttribute], data);
          deferred.resolve(instance);
        }).error(function () {
          console.log('user collection get GOT rejected');
          deferred.reject();
        });
      },
      _measuresHaveBeenPopulated: function _measuresHaveBeenPopulated(instance) {
        var ans = true;
        if (instance.measures && instance.measures.length) {
          ans = !(typeof instance.measures[0] === 'string');
        }
        return ans;
      },
      getQuick: function getQuick(slug) {
        var deferred = $q.defer(),
          instance = this._search(slug);
        if (instance && this._measuresHaveBeenPopulated(instance)) {
          deferred.resolve(instance);
        } else {
          //get it from quick search
          this._loadAutocomplete(slug, deferred);
        }
        return deferred.promise;
      },
      searchAutocomplete: function searchAutocomplete(text) {
        var deferred = $q.defer();
        httpAuth.get('/api/ingredients/?searchAutocomplete=' + encodeURI(text)).success(function (ingredientsArray) {
          /**var users = []; 
                           usersArray.docs.forEach(function(userData) {
                               console.log(userData);
                               var user = scope._retrieveInstance(userData._id, userData);
                               users.push(user);
                           });**/
          //TODO if some ingredients are loaded push them here in the manager so they are cached :)
          deferred.resolve(ingredientsArray);
        }).error(function (err) {
          deferred.reject(err);
        });
        return deferred.promise;
      }
    }, modelManager.init(Ingredient));
  }
})();
(function () {
  angular.module('meanApp').factory('measuresManager', measuresManager);
  measuresManager.$inject = ["Measure", "modelManager"];
  function measuresManager(Measure, modelManager) {
    return angular.extend({}, modelManager.init(Measure));
  }
  ;
})();
(function () {
  angular.module('meanApp').service('modelManager', modelManager);
  modelManager.$inject = ['$http', 'httpAuth', '$q'];
  function modelManager($http, httpAuth, $q) {
    var makeId = function makeId() {
      var text = "",
        possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 5; i++) text += possible.charAt(Math.floor(Math.random() * possible.length));
      return text;
    };
    var modelManager = function modelManager(Model) {
      return {
        _defaultIdAttribute: '_id',
        _pool: {},
        //list all the current users loaded

        //si l'instance est deja chargee on la redonne, sinon on crée un nouvelle instance
        //peut etre factorisée mais il doit y avoir un lien avec le module du model pour créer une nouvelle instance
        _retrieveInstance: function _retrieveInstance(id, data, forceCall) {
          var instance = this._pool[id],
            forceCall = typeof forceCall === 'undefined' ? false : forceCall;
          if (instance && !forceCall) {
            instance.setData(data);
          } else {
            instance = new Model(data);
            this._pool[id] = instance;
          }
          return instance;
        },
        //TODO must be working and the list should get refreshed since the value disappears
        _removeInstance: function _removeInstance(id) {
          //delete just remove one attribute. have to do it for all attributes...
          var instance = this._pool[id],
            keys;
          if (instance) {
            keys = Object.keys(instance);
            for (var i = 0, l = keys.length; i < l; i++) {
              delete instance[keys[i]]; //delete every reference
            }
          }
          delete this._pool[id]; //TODO check this works
        },
        _search: function _search(id) {
          return this._pool[id];
        },
        _load: function _load(id, deferred, forceCall) {
          var scope = this;
          httpAuth.get('/api/' + Model.APIPath + '/' + id).success(function (data) {
            var instance = scope._retrieveInstance(data[Model.idAttribute || scope._defaultIdAttribute], data, forceCall);

            //TODO here get other model managers and load them with data
            deferred.resolve(instance);
          }).error(function () {
            console.log('user collection get GOT rejected');
            deferred.reject();
          });
        },
        //implement something to delete user
        'delete': function _delete(id) {
          var deferred = $q.defer(),
            instance = this._search(id);
          httpAuth["delete"]('/api/' + Model.APIPath + '/' + id).success(function () {
            if (instance) {
              this._removeInstance(id);
            }
            //return something ??
            deferred.resolve();
          }.bind(this)).error(function (err) {
            deferred.reject(err);
          });
          return deferred.promise;
        },
        /* Public Methods */
        /* Use this function in order to get a book instance by it's id */
        get: function get(id, forceCall, needsComplete) {
          console.log('model manager the call is forced : ', forceCall);
          forceCall = typeof forceCall === 'undefined' ? false : forceCall;
          var deferred = $q.defer(),
            instance = this._search(id);
          if (needsComplete && instance && instance.isModelComplete) {
            forceCall = !instance.isModelComplete();
          }
          if (instance && !forceCall) {
            deferred.resolve(instance);
          } else {
            this._load(id, deferred, forceCall);
          }
          return deferred.promise;
        },
        //to be overrided
        isModelComplete: function isModelComplete() {
          return true;
        },
        getAll: function getAll() {
          var deferred = $q.defer(),
            scope = this;
          httpAuth.get('/api/' + Model.APIPath + '/').success(function (resultArray) {
            var array = [],
              result = {};
            resultArray.forEach(function (itemArray) {
              var instance = scope._retrieveInstance(itemArray[Model.idAttribute || scope._defaultIdAttribute], itemArray);
              array.push(instance);
            });
            result.collection = array;
            deferred.resolve(result);
          }).error(function (err) {
            deferred.reject(err);
          });
          return deferred.promise;
        },
        set: function set(data) {
          var scope = this,
            id = data[Model.idAttribute || scope._defaultIdAttribute] || makeId(),
            instance = this._search(id);
          if (instance) {
            instance.setData(data);
          } else {
            instance = scope._retrieveInstance(id, data);
          }
          return instance;
        }
      };
    };
    return {
      init: function init(Model) {
        return modelManager(Model);
      }
    };
  }
})();
(function () {
  angular.module('meanApp').factory('productsManager', productsManager);
  productsManager.$inject = ["Product", "modelManager", 'httpAuth', '$q'];
  function productsManager(Product, modelManager, httpAuth, $q) {
    return angular.extend({
      search: function search(searchString, resultPerPage) {
        var deferred = $q.defer(),
          scope = this;
        httpAuth.get('/api/products/search' + '?searchString=' + encodeURI(searchString) + '&resultPerPage=' + resultPerPage).success(function (result) {
          /**var users = []; 
          usersArray.docs.forEach(function(userData) {
              console.log(userData);
              var user = scope._retrieveInstance(userData._id, userData);
              users.push(user);
          });**/
          deferred.resolve(result);
        }).error(function (err) {
          deferred.reject(err);
        });
        return deferred.promise;
      }
    }, modelManager.init(Product));
  }
  ;
})();
(function () {
  // eslint-disable-next-line no-undef
  angular.module('meanApp').factory('recipesManager', recipesManager);
  recipesManager.$inject = ['Recipe', 'modelManager', 'httpAuth', '$http', '$q', 'currentUser'];
  function recipesManager(Recipe, modelManager, httpAuth, $http, $q, currentUser) {
    // eslint-disable-next-line no-undef
    return angular.extend({
      executeCleverAlgo: function executeCleverAlgo() {
        return httpAuth.get('/api/recipes/cleveralgo');
      },
      getAllRecipesFromUser: function getAllRecipesFromUser(id, pageNumber) {
        var deferred = $q.defer(),
          scope = this;
        //do we want that to be authenticated ??
        httpAuth.get('/api/users/' + id + '/recipes/page/' + pageNumber).success(function (recipesArray) {
          var array = [];
          recipesArray.docs.forEach(function (itemArray) {
            var instance = scope._retrieveInstance(itemArray['slug'], itemArray);
            array.push(instance);
          });
          deferred.resolve({
            recipes: array,
            nbPage: recipesArray.totalPages //remove 1 because starts at 1 for this API for bookmarks and likes pageindex starts
          });
        }).error(function (err) {
          deferred.reject(err);
        });
        return deferred.promise;
      },
      getAllRecipesLikedFromUser: function getAllRecipesLikedFromUser(id, pageNumber) {
        var deferred = $q.defer(),
          scope = this;
        //do we want that to be authenticated ??
        httpAuth.get('/api/users/' + id + '/recipes/likes/page/' + pageNumber).success(function (recipesArray) {
          var array = [];
          recipesArray.docs.forEach(function (itemArray) {
            var instance = scope._retrieveInstance(itemArray['slug'], itemArray);
            array.push(instance);
          });
          deferred.resolve({
            recipes: array,
            nbPage: recipesArray.totalPages
          });
        }).error(function (err) {
          deferred.reject(err);
        });
        return deferred.promise;
      },
      getAllRecipesBookmarkedFromUser: function getAllRecipesBookmarkedFromUser(id, pageNumber) {
        var deferred = $q.defer(),
          scope = this;
        //do we want that to be authenticated ??
        httpAuth.get('/api/users/' + id + '/recipes/bookmarks/page/' + pageNumber).success(function (recipesArray) {
          var array = [];
          recipesArray.docs.forEach(function (itemArray) {
            var instance = scope._retrieveInstance(itemArray['slug'], itemArray);
            array.push(instance);
          });
          deferred.resolve({
            recipes: array,
            nbPage: recipesArray.totalPages
          });
        }).error(function (err) {
          deferred.reject(err);
        });
        return deferred.promise;
      },
      _cachedRecipes: [],
      //if connected call the advanced search
      //otherwise call the regular search
      searchRecipesAdvanced: function searchRecipesAdvanced(tags, pageNumber) {
        var deferred = $q.defer(),
          scope = this;
        currentUser.get().then(function (userModel) {
          if (userModel._id) {
            //user connected
            //needs authenticate for currentuser //TODO implement the API
            httpAuth.get('/api/recipes/user/page/' + parseInt(pageNumber) + '?tags=' + tags.join(',')).success(function (recipesArray) {
              var array = [];
              recipesArray.docs.forEach(function (itemArray) {
                var instance = scope._retrieveInstance(itemArray['slug'], itemArray);
                array.push(instance);
              });
              recipesArray.docs = array;
              deferred.resolve(recipesArray);
            }).error(function (err) {
              deferred.reject(err);
            });
          } else {
            //return a paginated SEARCH
            this.searchRecipes(tags, pageNumber).then(deferred.resolve, deferred.reject); //no user connected
          }
        }.bind(this));
        return deferred.promise;
      },
      //this API can be used for tags as well as the textual search
      searchRecipes: function searchRecipes(tags, pageNumber) {
        var deferred = $q.defer(),
          that = this;
        if (typeof pageNumber === 'undefined') {
          $http.get('/api/recipes?tags=' + tags.join(',')).success(function (count) {
            deferred.resolve(count);
          }).error(function (err) {
            deferred.reject(err);
          });
        } else {
          //perform a paginated recipes call
          $http.get('/api/recipes/page/' + parseInt(pageNumber) + '?tags=' + tags.join(',')).success(function (recipesArray) {
            var array = [];
            recipesArray.docs.forEach(function (itemArray) {
              var instance = that._retrieveInstance(itemArray['slug'], itemArray);
              array.push(instance);
            });
            recipesArray.docs = array;
            deferred.resolve(recipesArray);
          }).error(function (err) {
            deferred.reject(err);
          });
        }
        return deferred.promise;
      },
      getAllRecipesAdmin: function getAllRecipesAdmin(page, filters) {
        var deferred = $q.defer(),
          scope = this,
          queryString = '',
          QUESTION_MARK = '?',
          EQUAL = '=',
          AMPERSAND = '&';
        if (filters) {
          var filtersArray = Object.keys(filters),
            key;
          for (var i = 0, l = filtersArray.length; i < l; i++) {
            key = filtersArray[i];
            queryString += (i !== 0 ? AMPERSAND : '') + key + EQUAL + filters[key];
          }
          queryString = QUESTION_MARK + queryString;
        }
        httpAuth.get('/api/recipes/adminpage/' + page + queryString).success(function (recipesArray) {
          console.log(recipesArray.docs);
          var recipes = [],
            toBeResolved = {};
          recipesArray.docs.forEach(function (recipeData) {
            var recipe = scope._retrieveInstance(recipeData['slug'], recipeData);
            recipes.push(recipe);
          });
          toBeResolved.collection = recipes;
          toBeResolved.pages = recipesArray.totalPages;
          toBeResolved.total = recipesArray.totalDocs;
          deferred.resolve(toBeResolved);
        }).error(function (err) {
          deferred.reject(err);
        });
        return deferred.promise;
      }
    }, modelManager.init(Recipe));
  }
})();
(function () {
  angular.module('meanApp').factory('usersManager', usersManager);
  usersManager.$inject = ['User', "modelManager", 'httpAuth', '$q'];
  function usersManager(User, modelManager, httpAuth, $q) {
    return angular.extend({
      _searchByEmail: function _searchByEmail(email) {
        var user = null,
          keys = Object.keys(this._pool),
          key;
        for (var i = 0, l = keys.length; i < l; i++) {
          if (this._pool[keys[i]].email.toLowerCase() === email.toLowerCase()) {
            user = this._pool[keys[i]];
            break;
          }
        }
        return user;
      },
      /**Use this function in order to search for a user by its email, must be extended maybe sometime*/
      searchUserByEmail: function searchUserByEmail(email) {
        var deferred = $q.defer(),
          scope = this,
          user = this._searchByEmail(email); //FIRST search if user not already loaded in collection

        if (user) {
          deferred.resolve(user);
        } else {
          httpAuth.get('/api/users/page/1?email=' + email).success(function (usersArray) {
            var users = [];
            usersArray.docs.forEach(function (userData) {
              console.log(userData);
              var user = scope._retrieveInstance(userData._id, userData);
              users.push(user);
            });
            deferred.resolve(users[0]);
          }).error(function (err) {
            deferred.reject(err);
          });
        }
        return deferred.promise;
      },
      getAllUsers: function getAllUsers(page, filters) {
        var deferred = $q.defer(),
          scope = this,
          queryString = '',
          QUESTION_MARK = '?',
          EQUAL = '=',
          AMPERSAND = '&';
        if (filters) {
          var filtersArray = Object.keys(filters),
            key;
          for (var i = 0, l = filtersArray.length; i < l; i++) {
            key = filtersArray[i];
            queryString += (i !== 0 ? AMPERSAND : '') + key + EQUAL + filters[key];
          }
          queryString = QUESTION_MARK + queryString;
        }
        httpAuth.get('/api/users/page/' + page + queryString).success(function (usersArray) {
          console.log(usersArray.docs);
          var users = [],
            toBeResolved = {};
          usersArray.docs.forEach(function (userData) {
            console.log(userData);
            var user = scope._retrieveInstance(userData._id, userData);
            users.push(user);
          });
          toBeResolved.collection = users;
          toBeResolved.pages = usersArray.totalPages;
          toBeResolved.total = usersArray.totalDocs;
          deferred.resolve(toBeResolved);
        }).error(function (err) {
          deferred.reject(err);
        });
        return deferred.promise;
      }
    }, modelManager.init(User));
  }
  ;
})();
(function () {
  angular.module('meanApp').service('alert', alert);
  alert.$inject = ['$rootScope'];
  function alert($rootScope) {
    //initialize the functions and arrays
    console.log('rootscope - init alert');
    var pendingList = [];
    $rootScope.alerts = [];
    $rootScope.closeAlert = function (index) {
      console.log('rootscope - close alert');
      $rootScope.alerts.splice(index, 1);
      pendingList.shift(); //remove first item
      //check if there is some alert to push left in the pendingList
      var firstItem = pendingList[0];
      if (firstItem) {
        $rootScope.alerts.push(firstItem);
      }
    };
    this.push = function (type, msg) {
      console.log('rootscope - push alert');
      var alertObject = {
        type: type,
        msg: msg
      };

      //if pending list empty push the alert directly

      if (pendingList.length === 0) {
        $rootScope.alerts.push(alertObject);
      }
      pendingList.push(alertObject);
    };
    return this;
  }
})();
(function () {
  angular.module('meanApp').service('authentication', ['$http', '$window', '$cookies', function ($http, $window, $cookies) {
    var LOCAL_STORAGE_TOKEN = 'mean-token',
      COOKIE_TOKEN_NAME = 'token',
      saveToken = function saveToken(token) {
        $window.localStorage[LOCAL_STORAGE_TOKEN] = token;
      },
      getToken = function getToken() {
        console.log('token found' + $window.localStorage[LOCAL_STORAGE_TOKEN]);
        var cookieTokenValue = $cookies.get(COOKIE_TOKEN_NAME);
        console.log('cookie retrieved is', cookieTokenValue);
        //token can be in localstorage or found as a cookie
        // is the cookie persisted over session ?
        return $window.localStorage[LOCAL_STORAGE_TOKEN] || cookieTokenValue;
      },
      removeToken = function removeToken() {
        $cookies.remove(COOKIE_TOKEN_NAME);
        $window.localStorage.removeItem(LOCAL_STORAGE_TOKEN);
      },
      isLoggedIn = function isLoggedIn() {
        var token = getToken(),
          payload;
        if (token) {
          payload = token.split('.')[1];
          payload = $window.atob(payload);
          payload = JSON.parse(payload);
          return payload.exp > Date.now() / 1000;
        } else {
          return false;
        }
      },
      getCurrentUserId = function getCurrentUserId() {
        var userId = '';
        if (isLoggedIn()) {
          var token = getToken(),
            payload = token.split('.')[1];
          payload = $window.atob(payload);
          payload = JSON.parse(payload);
          userId = payload._id;
        }
        return userId;
      };
    return {
      getCurrentUserId: getCurrentUserId,
      saveToken: saveToken,
      getToken: getToken,
      isLoggedIn: isLoggedIn,
      removeToken: removeToken
    };
  }]);
})();
(function () {
  angular.module('meanApp').service('colors', colors);
  colors.$inject = ['$rootScope'];
  function colors($rootScope) {
    var allColorsAvailableForBackGround = ['#462c2c', '#d9b826', '#de994a', '#de6f4a', '#c34a32', '#bd637a', '#ce85b6', '#a375b3', '#8073bf', '#5b6696', '#5176a7', '#449cad', '#318c75', '#27986c', '#279847', '#a27d4a', '#b37e57'];
    var hexToHSL = function hexToHSL(H) {
      // Convert hex to RGB first
      var r = 0,
        g = 0,
        b = 0;
      if (H.length == 4) {
        r = "0x" + H[1] + H[1];
        g = "0x" + H[2] + H[2];
        b = "0x" + H[3] + H[3];
      } else if (H.length == 7) {
        r = "0x" + H[1] + H[2];
        g = "0x" + H[3] + H[4];
        b = "0x" + H[5] + H[6];
      }
      // Then to HSL
      r /= 255;
      g /= 255;
      b /= 255;
      var cmin = Math.min(r, g, b),
        cmax = Math.max(r, g, b),
        delta = cmax - cmin,
        h = 0,
        s = 0,
        l = 0;
      if (delta == 0) h = 0;else if (cmax == r) h = (g - b) / delta % 6;else if (cmax == g) h = (b - r) / delta + 2;else h = (r - g) / delta + 4;
      h = Math.round(h * 60);
      if (h < 0) h += 360;
      l = (cmax + cmin) / 2;
      s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
      s = +(s * 100).toFixed(1);
      l = +(l * 100).toFixed(1);

      //return "hsl(" + h + "," + 40 + "%," + 50 + "%)";
      return {
        'h': h,
        's': s,
        'l': l
      };
    };
    this.hexToHSLLighter = function (hexColor, lightness) {
      var hsl = hexToHSL(hexColor);
      return "hsl(" + hsl['h'] + "," + 40 + "%," + lightness + "%)";
    };
    this.getClosestColorPossible = function (hexDominantColor) {
      if (!this._hueToColorMapping) {
        this._hueToColorMapping = {};
        allColorsAvailableForBackGround.forEach(function (hexColor) {
          this._hueToColorMapping[hexToHSL(hexColor).h] = hexColor;
        }.bind(this));
      }
      var hueDominantColor = hexToHSL(hexDominantColor).h,
        closestKey = '',
        minDist = 1000; //arbitrary distance

      Object.keys(this._hueToColorMapping).forEach(function (hueKey) {
        if (Math.abs(parseInt(hueDominantColor) - parseInt(hueKey)) < minDist) {
          closestKey = hueKey;
          minDist = Math.abs(parseInt(hueDominantColor) - parseInt(hueKey));
        }
      });
      return this._hueToColorMapping[closestKey];
    };
    return this;
  }
})();
(function () {
  angular.module('meanApp').service('context', context);
  context.$inject = ['$rootScope', '$state', 'titleFactory'];
  function context($rootScope, $state, titleFactory) {
    var DEFAULT_COLOR_BACKGROUND = 'salmon',
      BACK_LISTING_NAME_SUPPORTED = ['recipeWidgetNone', 'faq', 'about', 'contact', 'recipe', 'recipeInstructions', 'recipeSearchResult', 'recipeSearchStep', 'recipecreationstep'];
    this._previousState = null;
    this._currentState = null;
    this.getContextName = function () {
      return this._contextName;
    };
    this.onContextChange = function (callback) {
      this._callback = callback;
    };
    this._dispatchContextChange = function () {
      if (this._callback) {
        this._callback(this);
      }
    };
    this.get = function () {
      return {
        href: this._href,
        //this variable is used to optimize SEO
        iconAction: this._iconAction,
        iconCallback: this._iconCallback,
        contextName: this._contextName,
        colorBackground: this._colorBackground,
        goBack: typeof this._goBack === 'undefined' ? true : this._goBack,
        dropDownActions: this._dropDownActions
      };
    };
    this.setPreviousState = function (previousState) {
      this._previousState = previousState;
    };

    //This computes if the current state can get a back
    this.isCurrentStateSupposedToGetBack = function () {
      var currentstateName = $state.current.name;
      return BACK_LISTING_NAME_SUPPORTED.indexOf(currentstateName) > -1;
    };
    this.getPreviousState = function () {
      return this._previousState;
    };
    this.setCurrentState = function (currentState) {
      this._currentState = currentState;
    };
    this.getCurrentState = function () {
      return this._currentState;
    };
    this.set = function (params) {
      var dispatchEvent = false;
      if (params.contextName) {
        this._contextName = params.contextName;
        dispatchEvent = true;
      }
      if (params.colorBackground) {
        this._colorBackground = params.colorBackground;
        dispatchEvent = true;
      } else {
        //set a default background color
        this._colorBackground = DEFAULT_COLOR_BACKGROUND;
        dispatchEvent = true;
      }
      if (params.iconAction) {
        this._iconAction = params.iconAction;
        this._dropDownActions = null;
        dispatchEvent = true;
      } else {
        this._iconAction = null;
        dispatchEvent = true;
      }
      this._href = params.goBack !== 'undefined' ? params.href : false;
      //always dispatch the event ? if yes, then remove all the other occurrences
      dispatchEvent = true;
      if (typeof params.iconCallback === 'function') {
        this._iconCallback = params.iconCallback;
        dispatchEvent = true;
        this._href = false;
      } else {
        this._iconCallback = null;
      }
      if (typeof params.goBack !== 'undefined') {
        console.log('reset go back to', params.goBack);
        this._goBack = params.goBack;
        dispatchEvent = true;
      }
      if (params.dropDownActions && params.dropDownActions.length > 0) {
        this._iconAction = null;
        this._dropDownActions = params.dropDownActions;
        dispatchEvent = true;
      }
      if (dispatchEvent === true) {
        console.log('dispatch context change with the following params : ', this);
        this._dispatchContextChange();
      }
      if (params.title) {
        titleFactory.setTitle(params.title + ' | fraiseoubacon');
      } else {
        titleFactory.setTitle('Moteur de recherche de recettes et aide à la nutrition' + ' | fraiseoubacon');
      }
    };
    return this;
  }
})();
(function () {
  angular.module('meanApp').service('currentUser', currentUser);
  currentUser.$inject = ['$rootScope', 'authentication',
  //'usersManager',
  '$q', '$injector'];
  function currentUser($rootScope, authentication,
  //usersManager,
  $q, $injector) {
    this._currentUser = null;
    this._isBeingFetched = false;
    this._promise = null;

    //tobe used just right after registration or login
    this.set = function (currentUser) {
      this._currentUser = currentUser;
    };

    //this init the singleton user
    this.get = function () {
      var deferred = $q.defer();
      if (this._currentUser) {
        console.log('user service already fetched');
        deferred.resolve(this._currentUser);
      } else if (!this._isBeingFetched) {
        console.log('user service will be fetched');
        this._isBeingFetched = true;
        this._promise = $q.defer();
        var idCurrentUser = authentication.getCurrentUserId();
        if (idCurrentUser) {
          //dynamic dependency to avoid circular dependency
          var usersManager = $injector.get('usersManager');
          usersManager.get(idCurrentUser).then(function (result) {
            this._currentUser = result;
            this._isBeingFetched = false;
            this._promise.resolve(this._currentUser);
            deferred.resolve(this._currentUser);
          }.bind(this), function (err) {
            /**this._promise.reject(err);
            deferred.reject(err);**/
            this._promise.reject(null);
            deferred.reject(null);
          }.bind(this));
        } else {
          this._currentUser = {};
          this._promise.resolve(this._currentUser);
          deferred.resolve(this._currentUser);
        }
      } else {
        //wait for the result and give it
        //here do a deffered resolve
        console.log('user service pending');
        this._promise.promise.then(function (currentUser) {
          console.log('will be deffered after the being fetched');
          deferred.resolve(currentUser);
        }, function (err) {
          deferred.resolve(null);
          //deferred.reject(err);
          //resolve it anyway but with null inside
        });
      }
      return deferred.promise;
    };
    return this;
  }
})();
(function () {
  angular.module('meanApp').service('nutritionService', nutritionService);
  nutritionService.$inject = [];
  function nutritionService() {
    //BELOW constants about good and bad things
    var SALTCATEGORIES = [0, 0.46, 0.92, 1.62, 2.3],
      SALTNAMING = ['Pas de sel', 'Peu de sel', 'Faible impact', 'Un peu trop salé', 'Trop salé'],
      SUGARCATEGORIES = [0, 9, 18, 21, 45],
      SUGARNAMING = ['Pas de sucre', 'Peu de sucre', 'Faible impact', 'Un peu trop sucré', 'Trop sucré'],
      FATCATEGORIES = [0, 2, 4, 7, 10],
      FATNAMING = ['Pas de graisses saturées', 'Peu de graisses saturées', 'Faible impact', 'Un peu trop de graisses saturées', 'Trop de graisses saturées'],
      CALORYCATEGORIES = [0, 160, 360, 560, 800],
      CALORYNAMING = ['Pas de calories', 'Peu de calories', 'Faible impact', 'Un peu trop calorique', 'Trop calorique'],
      FIBERCATEGORIES = [0, 3.5, 7],
      //always good
      FIBERNAMING = ['Quelques protéines', 'Excellente quantité'],
      PROTEINCATEGORIES = [0, 8, 16],
      //always good
      PROTEINNAMING = ['Quelques protéines', 'Excellente quantité'];
    this._getLevel = function (value, arrayLevel) {
      var level = 1;
      if (value < arrayLevel[1]) {
        level = 1;
      } else if (value < arrayLevel[2]) {
        level = 2;
      } else if (value < arrayLevel[3]) {
        level = 3;
      } else {
        level = 4;
      }
      return level;
    };
    this._roundQuantity = function (value) {
      return (Math.round(value * 10) / 10 + '').replace('.', ',');
    };

    //return good things and bad things when passing nutrients of ingredients or recipes
    this.getGoodAndBadThings = function (nutrientsQuantity) {
      var goodThings = [],
        badThings = [];
      nutrientsQuantity.forEach(function (nutrientQuantity) {
        var nutrient = nutrientQuantity.nutrient,
          quantity = nutrientQuantity.quantity,
          unit = nutrient.unit,
          level,
          dataStructure;
        switch (nutrient._id) {
          //fibers
          case 291:
            if (quantity > 0) {
              goodThings.push({
                name: 'Fibres',
                description: quantity < FIBERCATEGORIES[1] ? FIBERNAMING[0] : FIBERNAMING[1],
                level: quantity < FIBERCATEGORIES[1] ? 2 : 1,
                iconName: 'fob-wheat',
                quantity: this._roundQuantity(quantity),
                unit: unit
              });
            }
            break;
          //proteins
          case 203:
            if (quantity > 0) {
              goodThings.push({
                name: 'Protéines',
                description: quantity < PROTEINCATEGORIES[1] ? PROTEINNAMING[0] : PROTEINNAMING[1],
                level: quantity < PROTEINCATEGORIES[1] ? 2 : 1,
                iconName: 'fob-muscles',
                quantity: this._roundQuantity(quantity),
                unit: unit
              });
            }
            break;
          //kilocalories energy
          case 208:
            level = this._getLevel(quantity, CALORYCATEGORIES);
            dataStructure = {
              name: 'Calories',
              description: CALORYNAMING[level],
              iconName: 'fob-fire',
              level: level,
              quantity: this._roundQuantity(quantity),
              unit: unit
            };
            if (level <= 2) {
              goodThings.push(dataStructure);
            } else {
              badThings.push(dataStructure);
            }
            break;
          //fatty acids saturated
          case 606:
            level = this._getLevel(quantity, FATCATEGORIES);
            dataStructure = {
              name: 'Graisses saturées',
              description: FATNAMING[level],
              iconName: 'fob-oil',
              level: level,
              quantity: this._roundQuantity(quantity),
              unit: unit
            };
            if (level <= 2) {
              goodThings.push(dataStructure);
            } else {
              badThings.push(dataStructure);
            }
            break;
          //sodium converted into salt
          case 307:
            quantity = quantity / 1000 * 2.54; //convert sodium into grams of salt
            level = this._getLevel(quantity, SALTCATEGORIES);
            dataStructure = {
              name: 'Sel',
              description: SALTNAMING[level],
              iconName: 'fob-salt',
              level: level,
              quantity: this._roundQuantity(quantity),
              unit: 'g'
            };
            if (level <= 2) {
              goodThings.push(dataStructure);
            } else {
              badThings.push(dataStructure);
            }
            break;
          //case sugars
          case 269:
            level = this._getLevel(quantity, SUGARCATEGORIES);
            dataStructure = {
              name: 'Sucre',
              description: SUGARNAMING[level],
              iconName: 'fob-toffee',
              level: level,
              quantity: this._roundQuantity(quantity),
              unit: unit
            };
            if (level <= 2) {
              goodThings.push(dataStructure);
            } else {
              badThings.push(dataStructure);
            }
            break;
        }
      }.bind(this));

      //sort good and badthings
      goodThings.sort(function (a, b) {
        return a.level - b.level;
      });
      badThings.sort(function (a, b) {
        return b.level - a.level;
      });
      return {
        goodThings: goodThings,
        badThings: badThings
      };
    };
    return this;
  }
})();
(function () {
  angular.module('meanApp').service('utils', utils);
  utils.$inject = ['$rootScope'];
  function utils() {
    //Returns a function, that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds. If `immediate` is passed, trigger the function on the
    // leading edge, instead of the trailing.
    this.debounce = function (func, wait, immediate) {
      var timeout;
      return function () {
        var context = this,
          args = arguments;
        var later = function later() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    };
    return this;
  }
})();
(function () {
  angular.module('meanApp').factory('Allergen', Allergen);
  Allergen.$inject = ['$http', 'httpAuth', '$rootScope', 'Model'];
  function Allergen($http, httpAuth, $rootScope, Model) {
    var Allergen = function Allergen(userData) {
      Model.apply(this, arguments);
    };
    Allergen.APIPath = 'allergens';
    Allergen.prototype = {
      getAPIPath: function getAPIPath() {
        return Allergen.APIPath;
      },
      getRisk: function getRisk() {
        var risk = 'LOW';
        if (this.risk > 50) {
          risk = 'MEDIUM';
        } else if (risk === 100) {
          risk = 'HIGH';
        }
        return risk;
      }
    };
    angular.extend(Allergen.prototype, Model.prototype);
    return Allergen;
  }
  ;
})();
(function () {
  angular.module('meanApp').factory('Department', Department);
  Department.$inject = ['$http', 'httpAuth', '$rootScope', 'Model'];
  function Department($http, httpAuth, $rootScope, Model) {
    var Department = function Department(userData) {
      Model.apply(this, arguments);
    };
    Department.APIPath = 'departments';
    Department.prototype = {
      getAPIPath: function getAPIPath() {
        return Department.APIPath;
      }
    };
    angular.extend(Department.prototype, Model.prototype);
    return Department;
  }
  ;
})();
(function () {
  angular.module('meanApp').factory('Feature', Feature);
  Feature.$inject = ['$http', 'httpAuth', '$rootScope', 'Model'];
  function Feature($http, httpAuth, $rootScope, Model) {
    var Feature = function Feature(userData) {
      Model.apply(this, arguments);
    };
    Feature.APIPath = 'features';
    Feature.prototype = {
      getAPIPath: function getAPIPath() {
        return Feature.APIPath;
      }
    };
    angular.extend(Feature.prototype, Model.prototype);
    return Feature;
  }
  ;
})();
(function () {
  angular.module('meanApp').factory('Ingredient', Ingredient);
  Ingredient.$inject = ['$http', 'httpAuth', '$rootScope', 'Model', 'currentUser', '$q'];
  function Ingredient($http, httpAuth, $rootScope, Model, currentUser, $q) {
    var Ingredient = function Ingredient(userData) {
        Model.apply(this, arguments);
      },
      TAGS_BY_COLOR = ['complicated', 'nohob', 'protein', 'cold', 'eco', 'lowcarb', 'nopig', 'vegan', 'paleo', 'vegetarian', 'local', 'nogluten', 'nooven', 'maincourse', 'nomicrowave', 'entry', 'pleasure', 'savory', 'aperitif', 'lowcalory', 'season', 'dessert', 'fast', 'sweet', 'hot'];
    Ingredient.APIPath = 'ingredients';
    Ingredient.idAttribute = 'slug';
    Ingredient.prototype = {
      _load: function _load(id, deferred) {
        var scope = this;
        $http.get('/api/' + Ingredient.APIPath + '/' + id).success(function (data) {
          var instance = scope._retrieveInstance(data._id, data);
          deferred.resolve(instance);
        }).error(function () {
          console.log('user collection get GOT rejected');
          deferred.reject();
        });
      },
      updateWithPicture: function updateWithPicture(formData) {
        var deferred = $q.defer(),
          scope = this;
        httpAuth.put('/api/' + this.getAPIPath() + '/' + this._id, formData, {
          headers: {
            'Content-Type': undefined
          }
        }).success(function (data) {
          //TODO merge the result and everything ?
          //just merge slug _id and the recipeFilePath
          this.setData(data);
          deferred.resolve(this);
        }.bind(this)).error(function (err) {
          console.log('JS front end success for saving recipe');
          deferred.reject(err);
        });
        return deferred.promise;
      },
      like: function like() {
        //step 1 get the id of current user
        //step 2 perform the call
        httpAuth.post('/api/users/' + $rootScope.currentUser._id + '/' + Ingredient.APIPath + '/' + this._id + '/likes', {}, {
          headers: {
            "Content-Type": "application/json"
          }
        }).success(function (data) {
          console.log('the api like on ingredient succeeded');
        }).error(function () {
          console.log('the api like on ingredient failed');
        });
      },
      unlike: function unlike() {
        //step 1 get the id of current user
        //step 2 perform the call
        httpAuth["delete"]('/api/users/' + $rootScope.currentUser._id + '/' + Ingredient.APIPath + '/' + this._id + '/likes', {}, {
          headers: {
            "Content-Type": "application/json"
          }
        }).success(function (data) {
          console.log('the api like on ingredient succeeded');
        }).error(function () {
          console.log('the api like on ingredient failed');
        });
      },
      dislike: function dislike() {
        //step 1 get the id of current user
        //step 2 perform the call
        httpAuth.post('/api/users/' + $rootScope.currentUser._id + '/' + Ingredient.APIPath + '/' + this._id + '/dislikes', {}, {
          headers: {
            "Content-Type": "application/json"
          }
        }).success(function (data) {
          console.log('the api like on ingredient succeeded');
        }).error(function () {
          console.log('the api like on ingredient failed');
        });
      },
      undislike: function undislike() {
        //step 1 get the id of current user
        //step 2 perform the call
        httpAuth["delete"]('/api/users/' + $rootScope.currentUser._id + '/' + Ingredient.APIPath + '/' + this._id + '/dislikes', {}, {
          headers: {
            "Content-Type": "application/json"
          }
        }).success(function (data) {
          console.log('the api like on ingredient succeeded');
        }).error(function () {
          console.log('the api like on ingredient failed');
        });
      },
      getInteractions: function getInteractions() {
        //step 1 get the id of current user
        //step 2 perform the call
        /*return httpAuth.get('/api/users/'+$rootScope.currentUser._id +'/'+ Ingredient.APIPath + '/' + this._id+'/interactions', {}, {
            headers: {
                "Content-Type": "application/json"
            }
        });*/

        var deferred = $q.defer(),
          url = '',
          that = this;
        //step 1 get the id of current user
        //step 2 perform the call
        currentUser.get().then(function (userModel) {
          //2 different APIs requested according to user connection or not
          url = userModel._id ? '/api/users/' + userModel._id + '/' + Ingredient.APIPath + '/' + that._id + '/interactions' : '/api/' + Ingredient.APIPath + '/' + that._id + '/interactions';
          httpAuth.get(url, {}, {
            headers: {
              "Content-Type": "application/json"
            }
          }).success(function (result) {
            deferred.resolve(result);
          }).error(function (err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      getAPIPath: function getAPIPath() {
        return Ingredient.APIPath;
      },
      getIdAttribute: function getIdAttribute() {
        return Ingredient.idAttribute;
      },
      getThumb: function getThumb(size) {
        return 'api/thumb/ingredients/' + this._id + '/size/' + size + '/update/' + this.ingredientUpdate;
      },
      _getEnergyDensityPoints: function _getEnergyDensityPoints(numberInKj) {
        var ans = 10;
        switch (true) {
          case numberInKj <= 335:
            ans = 0;
            break;
          case numberInKj <= 670:
            ans = 1;
            break;
          case numberInKj <= 1005:
            ans = 2;
            break;
          case numberInKj <= 1340:
            ans = 3;
            break;
          case numberInKj <= 1675:
            ans = 4;
            break;
          case numberInKj <= 2010:
            ans = 5;
            break;
          case numberInKj <= 2345:
            ans = 6;
            break;
          case numberInKj <= 2680:
            ans = 7;
            break;
          case numberInKj <= 3015:
            ans = 8;
            break;
          case numberInKj <= 3350:
            ans = 9;
            break;
          case numberInKj > 3350:
            ans = 10;
            break;
        }
        return ans;
      },
      _getEnergyDensityPointsForDrink: function _getEnergyDensityPointsForDrink(numberInKj) {
        var ans = 10;
        switch (true) {
          case numberInKj <= 0:
            ans = 0;
            break;
          case numberInKj <= 30:
            ans = 1;
            break;
          case numberInKj <= 60:
            ans = 2;
            break;
          case numberInKj <= 90:
            ans = 3;
            break;
          case numberInKj <= 120:
            ans = 4;
            break;
          case numberInKj <= 150:
            ans = 5;
            break;
          case numberInKj <= 180:
            ans = 6;
            break;
          case numberInKj <= 210:
            ans = 7;
            break;
          case numberInKj <= 240:
            ans = 8;
            break;
          case numberInKj <= 270:
            ans = 9;
            break;
          case numberInKj > 270:
            ans = 10;
            break;
        }
        return ans;
      },
      _getSaturatedFatPoints: function _getSaturatedFatPoints(numberInKj) {
        var ans = 10;
        switch (true) {
          case numberInKj <= 1:
            ans = 0;
            break;
          case numberInKj <= 2:
            ans = 1;
            break;
          case numberInKj <= 3:
            ans = 2;
            break;
          case numberInKj <= 4:
            ans = 3;
            break;
          case numberInKj <= 5:
            ans = 4;
            break;
          case numberInKj <= 6:
            ans = 5;
            break;
          case numberInKj <= 7:
            ans = 6;
            break;
          case numberInKj <= 8:
            ans = 7;
            break;
          case numberInKj <= 9:
            ans = 8;
            break;
          case numberInKj <= 10:
            ans = 9;
            break;
          case numberInKj > 10:
            ans = 10;
            break;
        }
        return ans;
      },
      _getSaturatedFatPointsForAddedFat: function _getSaturatedFatPointsForAddedFat(numberInKj) {
        var ans = 10;
        switch (true) {
          case numberInKj < 10:
            ans = 0;
            break;
          case numberInKj < 16:
            ans = 1;
            break;
          case numberInKj < 22:
            ans = 2;
            break;
          case numberInKj < 28:
            ans = 3;
            break;
          case numberInKj < 34:
            ans = 4;
            break;
          case numberInKj < 40:
            ans = 5;
            break;
          case numberInKj < 46:
            ans = 6;
            break;
          case numberInKj < 52:
            ans = 7;
            break;
          case numberInKj < 58:
            ans = 8;
            break;
          case numberInKj < 64:
            ans = 9;
            break;
          case numberInKj >= 64:
            ans = 10;
            break;
        }
        return ans;
      },
      _getSugarPoints: function _getSugarPoints(numberInKj) {
        var ans = 10;
        switch (true) {
          case numberInKj <= 4.5:
            ans = 0;
            break;
          case numberInKj <= 9:
            ans = 1;
            break;
          case numberInKj <= 13.5:
            ans = 2;
            break;
          case numberInKj <= 18:
            ans = 3;
            break;
          case numberInKj <= 22.5:
            ans = 4;
            break;
          case numberInKj <= 27:
            ans = 5;
            break;
          case numberInKj <= 31:
            ans = 6;
            break;
          case numberInKj <= 36:
            ans = 7;
            break;
          case numberInKj <= 40:
            ans = 8;
            break;
          case numberInKj <= 45:
            ans = 9;
            break;
          case numberInKj > 45:
            ans = 10;
            break;
        }
        return ans;
      },
      _getSugarPointsForDrink: function _getSugarPointsForDrink(numberInKj) {
        var ans = 10;
        switch (true) {
          case numberInKj <= 0:
            ans = 0;
            break;
          case numberInKj <= 1.5:
            ans = 1;
            break;
          case numberInKj <= 3:
            ans = 2;
            break;
          case numberInKj <= 4.5:
            ans = 3;
            break;
          case numberInKj <= 6:
            ans = 4;
            break;
          case numberInKj <= 7.5:
            ans = 5;
            break;
          case numberInKj <= 9:
            ans = 6;
            break;
          case numberInKj <= 10.5:
            ans = 7;
            break;
          case numberInKj <= 12:
            ans = 8;
            break;
          case numberInKj <= 13.5:
            ans = 9;
            break;
          case numberInKj > 13.5:
            ans = 10;
            break;
        }
        return ans;
      },
      _getSodiumPoints: function _getSodiumPoints(numberInKj) {
        var ans = 10;
        switch (true) {
          case numberInKj <= 90:
            ans = 0;
            break;
          case numberInKj <= 180:
            ans = 1;
            break;
          case numberInKj <= 270:
            ans = 2;
            break;
          case numberInKj <= 360:
            ans = 3;
            break;
          case numberInKj <= 450:
            ans = 4;
            break;
          case numberInKj <= 540:
            ans = 5;
            break;
          case numberInKj <= 630:
            ans = 6;
            break;
          case numberInKj <= 720:
            ans = 7;
            break;
          case numberInKj <= 810:
            ans = 8;
            break;
          case numberInKj <= 900:
            ans = 9;
            break;
          case numberInKj > 900:
            ans = 10;
            break;
        }
        return ans;
      },
      _getFruitsAndVegetablesPoints: function _getFruitsAndVegetablesPoints(quantity) {
        var ans = 0;
        switch (true) {
          case quantity <= 40:
            ans = 0;
            break;
          case quantity <= 60:
            ans = 1;
            break;
          case quantity <= 80:
            ans = 2;
            break;
          case quantity > 80:
            ans = 5;
            break;
        }
        return ans;
      },
      _getFruitsAndVegetablesPointsForDrink: function _getFruitsAndVegetablesPointsForDrink(quantity) {
        var ans = 0;
        switch (true) {
          case quantity <= 40:
            ans = 0;
            break;
          case quantity > 40:
            ans = 2;
            break;
          case quantity > 60:
            ans = 4;
            break;
          case quantity > 80:
            ans = 10;
            break;
        }
        return ans;
      },
      _getFiberPoints: function _getFiberPoints(quantity) {
        var ans = 0;
        switch (true) {
          case quantity <= 0.9:
            ans = 0;
            break;
          case quantity <= 1.9:
            ans = 1;
            break;
          case quantity <= 2.8:
            ans = 2;
            break;
          case quantity <= 3.7:
            ans = 3;
            break;
          case quantity <= 4.7:
            ans = 4;
            break;
          case quantity > 4.7:
            ans = 5;
            break;
        }
        return ans;
      },
      _getProteinsPoints: function _getProteinsPoints(quantity) {
        var ans = 0;
        switch (true) {
          case quantity <= 1.6:
            ans = 0;
            break;
          case quantity <= 3.2:
            ans = 1;
            break;
          case quantity <= 4.8:
            ans = 2;
            break;
          case quantity <= 6.4:
            ans = 3;
            break;
          case quantity <= 8.0:
            ans = 4;
            break;
          case quantity > 8.0:
            ans = 5;
            break;
        }
        return ans;
      },
      _isCheese: function _isCheese() {
        var ans = false,
          features = this['features'];
        features.forEach(function (feature) {
          if (feature.easyID === 4) {
            ans = true;
          }
        });
        return ans;
      },
      _isAddedFat: function _isAddedFat() {
        var ans = false,
          features = this['features'];
        features.forEach(function (feature) {
          if (feature.easyID === 5) {
            ans = true;
          }
        });
        return ans;
      },
      _isDrink: function _isDrink() {
        var ans = false,
          features = this['features'];
        features.forEach(function (feature) {
          if (feature.easyID === 7) {
            ans = true;
          }
        });
        return ans;
      },
      getNutriscoreLetter: function getNutriscoreLetter() {
        //create some JS cache
        if (!this.nutriscoreLetter) {
          var nutriscore = this._getNutriscore(),
            departmentId = this.department.easyID,
            nutriscoreLetter;
          if (this._isDrink() === true) {
            switch (true) {
              //TODO consider having something for mineral waters
              case nutriscore <= 0:
                nutriscoreLetter = 'A';
                break;
              case nutriscore <= 1:
                nutriscoreLetter = 'B';
                break;
              case nutriscore <= 5:
                nutriscoreLetter = 'C';
                break;
              case nutriscore <= 9:
                nutriscoreLetter = 'D';
                break;
              case nutriscore >= 10:
                nutriscoreLetter = 'E';
                break;
            }
          } else {
            switch (true) {
              //TODO consider having something for mineral waters otherwise some drinks might be A even if it is reserved for mineral waters
              case nutriscore <= -1:
                nutriscoreLetter = 'A';
                break;
              case nutriscore <= 2:
                nutriscoreLetter = 'B';
                break;
              case nutriscore <= 10:
                nutriscoreLetter = 'C';
                break;
              case nutriscore <= 18:
                nutriscoreLetter = 'D';
                break;
              case nutriscore > 18:
                nutriscoreLetter = 'E';
                break;
            }
          }
          //specific letter for alcohol that is not beer
          if (departmentId < 71 && departmentId > 61 && departmentId != 65) {
            nutriscoreLetter = 'F';
          }
          //force the letter to be F if this is an alcohol
          this.nutriscoreLetter = nutriscoreLetter;
        }
        return this.nutriscoreLetter;
      },
      _getNutriscore: function _getNutriscore() {
        var nutrientsQuantity = this['nutrientsQuantity'],
          percentageFruitsAndVegetables = this['percentageFruitsAndVegetables'] || 0,
          negativeComposante = 0,
          positiveComposante = 0,
          saturatedFat,
          sugarsQuantity = 0,
          fibersQuantity,
          totalLipidQuantity,
          totalSaturatedFatQuantity = 0,
          carbohydratesQuantity,
          sodiumQuantity,
          proteinsQuantity,
          kilocalories,
          kilojoules,
          nutriscore,
          isCheese = this._isCheese(),
          isAddedFat = this._isAddedFat(),
          isDrink = this._isDrink(),
          fatPointsForAddedFat;
        nutrientsQuantity.forEach(function (nutrientQuantity) {
          switch (nutrientQuantity.nutrient._id) {
            case 291:
              fibersQuantity = nutrientQuantity.quantity;
              break;
            //fibers in g
            case 205:
              carbohydratesQuantity = nutrientQuantity.quantity;
              break;
            //carbohydrates in g (not used for nutriscore)
            case 204:
              totalLipidQuantity = nutrientQuantity.quantity;
              break;
            //total lipids, (not used for nutriscore)
            case 606:
              totalSaturatedFatQuantity = nutrientQuantity.quantity;
              break;
            case 203:
              proteinsQuantity = nutrientQuantity.quantity;
              break;
            case 307:
              sodiumQuantity = nutrientQuantity.quantity;
              break;
            case 269:
              sugarsQuantity = nutrientQuantity.quantity;
              break;
            case 208:
              kilocalories = nutrientQuantity.quantity;
              break;
            case 268:
              kilojoules = nutrientQuantity.quantity;
              break;
          }
        });
        if (isDrink) {
          return this._getEnergyDensityPointsForDrink(kilojoules || kilocalories * 4.184) + this._getSugarPointsForDrink(sugarsQuantity) - this._getFruitsAndVegetablesPointsForDrink(percentageFruitsAndVegetables);
        }
        fatPointsForAddedFat = isAddedFat ? this._getSaturatedFatPointsForAddedFat(100 * totalSaturatedFatQuantity / totalLipidQuantity) : this._getSaturatedFatPoints(totalSaturatedFatQuantity);
        negativeComposante = this._getEnergyDensityPoints(kilojoules || kilocalories * 4.184) + fatPointsForAddedFat + this._getSugarPoints(sugarsQuantity) + this._getSodiumPoints(sodiumQuantity);
        var pointsFruitsAndVegetables = this._getFruitsAndVegetablesPoints(percentageFruitsAndVegetables);
        //specific scoring rules
        if (pointsFruitsAndVegetables < 5 && negativeComposante > 10 && !isCheese) {
          //except if this is cheese (weird)
          positiveComposante = pointsFruitsAndVegetables + this._getFiberPoints(fibersQuantity);
        } else {
          positiveComposante = pointsFruitsAndVegetables + this._getFiberPoints(fibersQuantity) + this._getProteinsPoints(proteinsQuantity);
        }
        nutriscore = negativeComposante - positiveComposante;
        return nutriscore;
      },
      //we consider that a nutriscore with letter D or E means it has a lot of fat and or lot of salt so the body tends to love it
      _hasPleasureTag: function _hasPleasureTag() {
        var nutriscoreLetter = this.getNutriscoreLetter();
        return nutriscoreLetter === 'E' || nutriscoreLetter === 'D';
      },
      _hasNoGlutenTag: function _hasNoGlutenTag() {
        var ans = true;
        this['allergensRisk'].forEach(function (allergenRisk) {
          if (allergenRisk.allergen.easyID === 0 && allergenRisk.risk === "HIGH") {
            ans = false;
          }
        });
        return ans;
      },
      _hasEcoTag: function _hasEcoTag() {
        return this.price && this.price < 5;
      },
      _hasSeasonTag: function _hasSeasonTag() {
        var date = new Date();
        return this.monthsSoldInFrance && this.monthsSoldInFrance.indexOf(date.getMonth()) > -1;
      },
      _getFeaturesIntoTags: function _getFeaturesIntoTags() {
        var ans = [],
          hasPork = false;
        this.features.forEach(function (feature) {
          switch (feature.easyID) {
            case 0:
              ans.push('vegan');
              break;
            case 1:
              ans.push('vegetarian');
              break;
            case 2:
              ans.push('paleo');
              break;
            case 6:
              hasPork = true;
              break;
            case 8:
              ans.push('local');
              break;
            //case 8: ans.push('local'); break; //TODO add a new tag ? local ? and also from season ?
          }
        });

        //if no pork push the no pork tag
        if (!hasPork) {
          ans.push('nopig');
        }
        return ans;
      },
      //must be more than 8g //TODO mutualize constant with ingredient controller
      _getNutrientsIntoTags: function _getNutrientsIntoTags() {
        var ans = [],
          nutrientsQuantity = this['nutrientsQuantity'],
          sugarsQuantity = 0,
          sodiumQuantity = 0,
          proteinsQuantity = 0,
          kilocalories = 0,
          kilojoules = 0;
        nutrientsQuantity.forEach(function (nutrientQuantity) {
          switch (nutrientQuantity.nutrient._id) {
            case 307:
              sodiumQuantity = nutrientQuantity.quantity;
              break;
            case 269:
              sugarsQuantity = nutrientQuantity.quantity;
              break;
            case 203:
              proteinsQuantity = nutrientQuantity.quantity;
              break;
            case 208:
              kilocalories = nutrientQuantity.quantity;
              break;
            case 268:
              kilojoules = nutrientQuantity.quantity;
              break;
          }
        });
        if (sugarsQuantity > 5.5) {
          ans.push('sweet');
        } else if (sugarsQuantity > 4 && sodiumQuantity < 10) {
          ans.push('sweet');
        }
        if (sodiumQuantity > 50) {
          ans.push('savory');
        } else if (sodiumQuantity > 10 && sugarsQuantity < 5.5) {
          ans.push('savory');
        }
        if (proteinsQuantity > 8) {
          ans.push('protein');
        }
        kilocalories = kilocalories ? kilocalories : kilojoules * 4.184;
        if (kilocalories < 160) {
          ans.push('lowcalory');
        }
        return ans;
      },
      getTagNames: function getTagNames() {
        var tagNames = [];
        if (this._hasPleasureTag()) {
          tagNames.push('pleasure');
        }
        if (this._hasNoGlutenTag()) {
          tagNames.push('nogluten');
        }
        if (this._hasEcoTag()) {
          tagNames.push('eco');
        }
        if (this._hasSeasonTag()) {
          tagNames.push('season');
        }
        return tagNames.concat(this._getFeaturesIntoTags()).concat(this._getNutrientsIntoTags()).sort(function (tag1, tag2) {
          return TAGS_BY_COLOR.indexOf(tag2) - TAGS_BY_COLOR.indexOf(tag1);
        });
      }
    };
    angular.extend(Ingredient.prototype, Model.prototype);
    return Ingredient;
  }
  ;
})();
(function () {
  angular.module('meanApp').factory('Measure', Measure);
  Measure.$inject = ['$http', 'httpAuth', '$rootScope', 'Model'];
  function Measure($http, httpAuth, $rootScope, Model) {
    var Measure = function Measure(userData) {
      Model.apply(this, arguments);
    };
    Measure.APIPath = 'measures';
    Measure.prototype = {
      getAPIPath: function getAPIPath() {
        return Measure.APIPath;
      }
    };
    angular.extend(Measure.prototype, Model.prototype);
    return Measure;
  }
  ;
})();
(function () {
  angular.module('meanApp').factory('Model', Model);
  Model.$inject = ['$http', 'httpAuth', '$window', '$q', '$rootScope', 'authentication'];
  function Model($http, httpAuth, $window, $q, $rootScope, authentication) {
    var Model = function Model(data) {
      if (data) {
        this.setData(data);
      }
    };
    Model.prototype = {
      setData: function setData(data) {
        if (this.setDataOverrided) {
          this.setDataOverrided(data);
        } else {
          angular.extend(this, data);
        }
      },
      save: function save() {
        //if fd this is the priority
        var deferred = $q.defer();
        httpAuth.post("/api/" + this.getAPIPath() + "/", this, {
          headers: {
            "Content-Type": "application/json"
          }
        }).success(function (instance) {
          this.setData(instance);
          deferred.resolve(instance);
        }.bind(this)).error(function (err) {
          console.log("JS front end error for creating new measure");
          deferred.reject(err);
        });
        return deferred.promise;
      },
      update: function update(data, updateFromServer) {
        var deferred = $q.defer();
        httpAuth.put("/api/" + this.getAPIPath() + "/" + this._id, data, {
          headers: {
            "Content-Type": "application/json"
          }
        }).success(function (data) {
          console.log("JS front end success for updating");
          if (typeof updateFromServer !== 'undefined' && updateFromServer !== false) {
            this.setData(data);
          }
          deferred.resolve(data);
        }.bind(this)).error(function (err) {
          console.log("JS front end error for updating");
          deferred.reject(err);
        });
        return deferred.promise;
      }
    };
    return Model;
  }
  ;
})();

/**! function() {
    function t(t, e, n, o, r, i) {
        var s = function(t) {
            t && this.setData(t)
        };
        return s.prototype = {
            setData: function(t) {
                angular.extend(this, t)
            },
            save: function() {
                var t = o.defer();
                return e.post("/api/" + this.getAPIPath() + "/", this, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }).success(function(e) {
                    this.setData(e), t.resolve(e)
                }.bind(this)).error(function(e) {
                    console.log("JS front end error for creating new measure"), t.reject(e)
                }), t.promise
            },
            update: function(t) {
                var n = o.defer();
                return e.put("/api/" + this.getAPIPath() + "/" + this._id, t, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }).success(function(t) {
                    console.log("JS front end success for updating"), this.setData(t), n.resolve(t)
                }.bind(this)).error(function(t) {
                    console.log("JS front end error for updating"), n.reject(t)
                }), n.promise
            }
        }, s
    }
    angular.module("meanApp").factory("Model", t), t.$inject = ["$http", "httpAuth", "$window", "$q", "$rootScope", "authentication"]
}();**/
/**(function() {

    angular
    .module('meanApp')
    .factory('Payment', Payment);
  
    Payment.$inject = [
          '$http', 
          'httpAuth', 
          '$rootScope', 
          'Model', 
          '$q', 
          'ingredientsManager', 
          'usersManager',
          'currentUser'];
    function Payment (
          $http, 
          httpAuth, 
          $rootScope, 
          Model, 
          $q, 
          ingredientsManager, 
          usersManager,
          currentUser) {
      var Payment = function () {
          Model.apply(this, arguments);
      };
  
      Payment.APIPath = 'recipes';
      Payment.prototype = {
          like: function() {
              //step 1 get the id of current user
              //step 2 perform the call
              httpAuth.post('/api/users/'+$rootScope.currentUser._id +'/'+ Recipe.APIPath + '/' + this._id+'/likes', {}, {
                  headers: {
                      "Content-Type": "application/json"
                  }
              })
              .success(function(data) {
                  console.log('the api like on ingredient succeeded');
              })
              .error(function() {
                  console.log('the api like on ingredient failed');
              });
          },
  
  
            getAPIPath: function() {
                return Payment.APIPath;
            }
        };
      
        angular.extend(Recipe.prototype, Model.prototype);
        return Recipe;
    };
})();**/
(function () {
  angular.module('meanApp').factory('Product', Product);
  Product.$inject = ['$http', 'httpAuth', '$rootScope', 'Model'];
  function Product($http, httpAuth, $rootScope, Model) {
    var Product = function Product(userData) {
      Model.apply(this, arguments);
    };
    Product.APIPath = 'products';
    Product.prototype = {
      getAPIPath: function getAPIPath() {
        return Product.APIPath;
      }
    };
    angular.extend(Product.prototype, Model.prototype);
    return Product;
  }
  ;
})();
(function () {
  angular.module('meanApp').factory('Recipe', Recipe);
  Recipe.$inject = ['$http', 'httpAuth', '$rootScope', 'Model', '$q', 'ingredientsManager', 'usersManager', 'currentUser'];
  function Recipe($http, httpAuth, $rootScope, Model, $q, ingredientsManager, usersManager, currentUser) {
    var Recipe = function Recipe(recipeData) {
      //here check for ingredients and create subobjects
      var ingredient;
      if (recipeData && Array.isArray(recipeData.ingredientsQuantity)) {
        recipeData.ingredientsQuantity.forEach(function (ingredientQuantity) {
          ingredient = ingredientQuantity.ingredient;
          if (ingredient && ingredient.slug) {
            ingredientQuantity.ingredient = ingredientsManager._retrieveInstance(ingredient.slug, ingredient);
          }
        });
      }

      //put author in usermanager
      if (recipeData && recipeData.author) {
        recipeData.author = usersManager._retrieveInstance(recipeData.author._id, recipeData.author);
      }
      if (recipeData && recipeData.monthsSoldInFrance) {
        if (recipeData.monthsSoldInFrance.indexOf(new Date().getMonth()) > -1) {
          recipeData.tags.push('season');
        }
      }
      Model.apply(this, arguments);
    };
    Recipe.APIPath = 'recipes';
    Recipe.idAttribute = 'slug';
    Recipe.prototype = {
      //used after a put ?
      /**setData: function(recipeData) {
          var ingredient;
           if(recipeData && Array.isArray(recipeData.ingredientsQuantity)) {    
              recipeData.ingredientsQuantity.forEach(function(ingredientQuantity) {
                  ingredient = ingredientQuantity.ingredient;
                  if (ingredient && ingredient.slug) {
                      ingredientQuantity.ingredient = ingredientsManager._retrieveInstance(ingredient.slug, ingredient);
                  }
              });
          }
          Model.apply(this, arguments);
      },**/

      //do not update it since we don't want to have non complete data.
      setDataOverrided: function setDataOverrided(data) {
        if (data.isDraft === false) {
          var firstIngredient = data.ingredientsQuantity[0],
            firstAllergen = data.allergensRisk && data.allergensRisk.length > 0 && data.allergensRisk[0];
          if (typeof firstIngredient.ingredient === 'string') {
            delete data.ingredientsQuantity;
          }
          if (firstAllergen && typeof firstAllergen.allergen === 'string') {
            delete data.allergensRisk;
          }
        }
        console.log('object overrided', this, data);
        angular.extend(this, data);
      },
      //puts here the necessary stuff
      isModelComplete: function isModelComplete() {
        var isModelComplete = false;
        if (this.isDraft === false) {
          var firstIngredient = this.ingredientsQuantity && this.ingredientsQuantity[0];
          if (firstIngredient && firstIngredient.ingredient && firstIngredient.ingredient.name) {
            isModelComplete = true;
          }
        }
        return isModelComplete;
      },
      like: function like() {
        //step 1 get the id of current user
        //step 2 perform the call
        httpAuth.post('/api/users/' + $rootScope.currentUser._id + '/' + Recipe.APIPath + '/' + this._id + '/likes', {}, {
          headers: {
            "Content-Type": "application/json"
          }
        }).success(function (data) {
          console.log('the api like on ingredient succeeded');
        }).error(function () {
          console.log('the api like on ingredient failed');
        });
      },
      unlike: function unlike() {
        //step 1 get the id of current user
        //step 2 perform the call
        httpAuth["delete"]('/api/users/' + $rootScope.currentUser._id + '/' + Recipe.APIPath + '/' + this._id + '/likes', {}, {
          headers: {
            "Content-Type": "application/json"
          }
        }).success(function (data) {
          console.log('the api like on ingredient succeeded');
        }).error(function () {
          console.log('the api like on ingredient failed');
        });
      },
      bookmark: function bookmark() {
        //step 1 get the id of current user
        //step 2 perform the call
        httpAuth.post('/api/users/' + $rootScope.currentUser._id + '/' + Recipe.APIPath + '/' + this._id + '/bookmarks', {}, {
          headers: {
            "Content-Type": "application/json"
          }
        }).success(function () {
          console.log('the api like on ingredient succeeded');
        }).error(function () {
          console.log('the api like on ingredient failed');
        });
      },
      unbookmark: function unbookmark() {
        //step 1 get the id of current user
        //step 2 perform the call
        httpAuth["delete"]('/api/users/' + $rootScope.currentUser._id + '/' + Recipe.APIPath + '/' + this._id + '/bookmarks', {}, {
          headers: {
            "Content-Type": "application/json"
          }
        }).success(function () {
          console.log('the api like on ingredient succeeded');
        }).error(function () {
          console.log('the api like on ingredient failed');
        });
      },
      getInteractions: function getInteractions() {
        var deferred = $q.defer(),
          url = '',
          that = this;
        //step 1 get the id of current user
        //step 2 perform the call
        currentUser.get().then(function (userModel) {
          //2 different APIs requested according to user connection or not
          url = userModel._id ? '/api/users/' + userModel._id + '/' + Recipe.APIPath + '/' + that._id + '/interactions' : '/api/' + Recipe.APIPath + '/' + that._id + '/interactions';
          httpAuth.get(url, {}, {
            headers: {
              "Content-Type": "application/json"
            }
          }).success(function (result) {
            deferred.resolve(result);
          }).error(function (err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      getAPIPath: function getAPIPath() {
        return Recipe.APIPath;
      },
      getIdAttribute: function getIdAttribute() {
        return Recipe.idAttribute;
      },
      saveAsDraft: function saveAsDraft(formData) {
        var deferred = $q.defer(),
          scope = this;
        httpAuth.post('/api/' + this.getAPIPath() + '/', formData, {
          headers: {
            'Content-Type': undefined
          }
        }).success(function (result) {
          //TODO merge the result and everything ?
          var resultSubset = {};
          if (result._id) {
            resultSubset._id = result._id;
          }
          if (result.slug) {
            resultSubset.slug = result.slug;
          }
          if (result.recipeFilePath) {
            resultSubset.recipeFilePath = result.recipeFilePath;
          }
          this.setData(resultSubset);
          deferred.resolve(this);
        }.bind(this)).error(function (err) {
          console.log('JS front end success for saving recipe');
          deferred.reject(err);
        });
        return deferred.promise;
      },
      //there is not always a picture in the request !!
      updateWithPicture: function updateWithPicture(formData) {
        var deferred = $q.defer(),
          scope = this;
        httpAuth.put('/api/' + this.getAPIPath() + '/' + this._id, formData, {
          headers: {
            'Content-Type': undefined
          }
        }).success(function (data) {
          //TODO merge the result and everything ?
          //just merge slug _id and the recipeFilePath
          this.setData(data);
          deferred.resolve(this);
        }.bind(this)).error(function (err) {
          console.log('JS front end success for saving recipe');
          deferred.reject(err);
        });
        return deferred.promise;
      },
      getThumb: function getThumb(size) {
        var ans = 'undefined';
        if (this._id) {
          ans = 'api/thumb/' + this.getAPIPath() + '/' + this._id + '/size/' + size + '/update/' + new Date(this.updatedAt).getTime();
        }
        return ans;
      },
      getCreationDate: function getCreationDate() {
        //TODO one day convert this in other languages
        return new Date(this.createdAt).toLocaleString('fr-FR');
      },
      getTextualUnkownIngredients: function getTextualUnkownIngredients() {
        var text = '';
        this.unknownIngredientsQuantity.forEach(function (unknownIngredientQuantity) {
          text += text.length > 0 ? ', ' + unknownIngredientQuantity.ingredient : unknownIngredientQuantity.ingredient;
        });
        return text;
      },
      getPriceLevel: function getPriceLevel() {
        //here compute the percentage, use log to improve the way we see difference between prices
        //let's assume that 50 euros per kilo is the maximum
        //take the log + 1 so only positive values
        // 0 euro --> would give 0 euro
        // 50 euro --> would give 3.93 maximum
        var MAX_VALUE = 3.93,
          color = blueLevel5,
          valueAfterLog = Math.min(Math.log(Math.max(this.pricePerKilo, 1)), MAX_VALUE),
          percentage = 100 * (valueAfterLog / MAX_VALUE),
          blueLevel1 = '#cce6ff',
          blueLevel2 = '#89bff8',
          blueLevel4 = '#165b93',
          blueLevel5 = '#012951';
        if (percentage < 75 && percentage >= 50) {
          color = blueLevel4;
        } else if (percentage < 50 && percentage >= 25) {
          color = blueLevel2;
        } else if (percentage < 25) {
          color = blueLevel1;
        }
        //Display
        return {
          'background-color': color,
          'width': percentage + '%'
        };
      }
    };
    angular.extend(Recipe.prototype, Model.prototype);
    return Recipe;
  }
  ;
})();
(function () {
  angular.module('meanApp').factory('User', User);
  User.$inject = ['$http', 'httpAuth', '$window', '$q', '$rootScope', 'authentication', 'Model', 'Allergen', 'ingredientsManager'];
  function User($http, httpAuth, $window, $q, $rootScope, authentication, Model, Allergen, ingredientsManager) {
    var User = function User(userData) {
        Model.apply(this, arguments);
      },
      USER_COLORS = ['#F49AC2', '#CB99C9', '#C23B22', '#FFD1DC', '#DEA5A4', '#AEC6CF', '#77DD77', '#B39EB5', '#FFB347', '#B19CD9', '#FF6961', '#03C03C', '#FDFD96', '#779ECB', '#966FD6'];
    User.APIPath = 'users';
    User.prototype = {
      getAPIPath: function getAPIPath() {
        return User.APIPath;
      },
      getName: function getName() {
        var name = this.name || this.email.split('@')[0],
          firstChar = name.charAt(0);
        return firstChar.toUpperCase() + name.slice(1);
      },
      /***Returns the role of the user **/
      getRole: function getRole() {
        var role = this.role,
          ans = '';
        switch (role) {
          case 'admin':
            ans = 'Administrateur';
            break;
          //red
          case 'author':
            ans = 'Auteur';
            break;
          // yellow
          default:
            ans = 'Membre';
          //blue
        }
        return ans;
      },
      getLabelClassRole: function getLabelClassRole() {
        var role = this.role,
          ans = '';
        switch (role) {
          case 'admin':
            ans = 'label-danger';
            break;
          //red
          case 'author':
            ans = 'label-success';
            break;
          // yellow
          default:
            ans = 'label-primary';
          //blue
        }
        return ans;
      },
      hasProfilePicture: function hasProfilePicture() {
        return !!this.avatarFilePath;
      },
      getThumb: function getThumb(size) {
        return 'api/thumb/users/' + this._id + '/size/' + size + '/update/' + this.avatarUpdate;
      },
      getColor: function getColor() {
        var initials = this.getInitials(),
          nbColors = USER_COLORS.length,
          toBeReturned = USER_COLORS[0],
          firstLetter = parseInt(initials.charAt(0), 36) - 9;
        if (initials.length === 2) {
          var secondLetter = parseInt(initials.charAt(1), 36) - 9,
            average = (firstLetter + secondLetter) / 2,
            ratio = average / 26; //26 is the number of letters in occidental alphabet
          toBeReturned = USER_COLORS[Math.trunc(ratio * nbColors)];
        } else {
          toBeReturned = USER_COLORS[Math.trunc(firstLetter / 26 * nbColors)];
        }
        console.log(toBeReturned);
        return toBeReturned;
      },
      getIMC: function getIMC() {
        var IMC = '';
        if (this.size && this.weight) {
          IMC = this.weight / (this.size / 100 * this.size / 100);
          IMC = Math.trunc(IMC * 10) / 10;
        }
        return IMC;
      },
      //return the margin left to apply in percentage
      getIMCIndicatorPosition: function getIMCIndicatorPosition() {
        //alert('in imc position');
        return 100 * this.getIMC() / 55 + '%';
      },
      getCreationDate: function getCreationDate() {
        //TODO one day convert this in other languages
        return new Date(this.createdAt).toLocaleString('fr-FR');
      },
      getIMCStatus: function getIMCStatus() {
        var IMCValue = this.getIMC(),
          IMCStatus = 'Anorexie/dénutrition';
        if (IMCValue > 40) {
          IMCStatus = 'Obésité morbide';
        } else if (IMCValue > 35) {
          IMCStatus = 'Obésité élevée';
        } else if (IMCValue > 30) {
          IMCStatus = 'Obésité modérée';
        } else if (IMCValue > 25) {
          IMCStatus = 'Surpoids';
        } else if (IMCValue > 18.5) {
          IMCStatus = 'Corpulence normale';
        } else if (IMCValue > 16.5) {
          IMCStatus = 'Maigreur';
        }
        return IMCStatus;
      },
      isAdmin: function isAdmin() {
        return this.role === 'admin';
      },
      getInitials: function getInitials() {
        var initials = '';
        if (this.name) {
          initials = this.name.charAt(0);
        } else {
          initials = this.email ? this.email.charAt(0) : '';
        }
        return initials.toUpperCase();
      },
      logout: function logout(callback) {
        authentication.removeToken();
        if (callback) {
          callback();
        }
      },
      resetPassword: function resetPassword(userData) {
        console.log('resetPassword triggered');
        console.log('user data is ' + userData);
        return $http.post('/api/password', userData);
      },
      login: function login() {
        var deferred = $q.defer();
        var scope = this;
        $http.post('/api/login', scope).success(function (result) {
          //merge data in Js with data from server, priority given to data from server
          angular.extend(scope, result.user);
          $rootScope.currentUser = scope;
          console.log('token to save after login' + result.token);
          authentication.saveToken(result.token);
          $rootScope.isLoggedIn = true;
          deferred.resolve(result);
        }).error(function (err) {
          deferred.reject(err);
        });
        return deferred.promise;
      },
      register: function register() {
        var deferred = $q.defer();
        var scope = this;
        $http.post('/api/register', scope).success(function (result) {
          //merge data in Js with data from server, priority given to data from server
          angular.extend(scope, result.user);
          $rootScope.currentUser = scope;
          authentication.saveToken(result.token);
          $rootScope.isLoggedIn = true;
          deferred.resolve(result);
        }).error(function (err) {
          deferred.reject(err);
        });
        return deferred.promise;
      },
      changePassword: function changePassword(formData) {
        var deferred = $q.defer(),
          scope = this;
        httpAuth.post('/api/changepassword/', formData, {
          headers: {
            'Content-Type': 'application/json'
          }
        }).success(function (result) {
          console.log('JS front end success for updating password user profile');
          deferred.resolve(result);
        }.bind(this)).error(function (err) {
          console.log('JS front end error for updating password user profile');
          deferred.reject(err);
        });
        return deferred.promise;
      },
      //the API is the following : /api/users/{id}/avatars/1
      uploadProfilePicture: function uploadProfilePicture(formData) {
        var deferred = $q.defer(),
          scope = this;
        httpAuth.post('/api/users/' + this._id + '/avatars/1', formData, {
          headers: {
            'Content-Type': undefined
          }
        }).success(function (result) {
          console.log('JS front end success for uploadProfilePicture');
          //merge data in Js with data from server, priority given to data from server
          /**angular.extend(scope, result.user);
          $rootScope.currentUser = scope;
          authentication.saveToken(result.token);
          $rootScope.isLoggedIn = true;**/
          this.avatarUpdate = result.avatarUpdate;
          console.log('avatar update ' + this.avatarUpdate);
          deferred.resolve(result);
        }.bind(this)).error(function (err) {
          console.log('JS front end success for uploadProfilePicture');
          deferred.reject(err);
        });
        return deferred.promise;
      },
      addAllergen: function addAllergen(allergenId) {
        var deferred = $q.defer();
        //step 1 get the id of current user
        //step 2 perform the call
        httpAuth.post('/api/users/' + this._id + '/' + Allergen.APIPath + '/' + allergenId, {}, {
          headers: {
            "Content-Type": "application/json"
          }
        }).success(function () {
          console.log('the api add allergen succeeded');
          deferred.resolve();
        }).error(function (err) {
          deferred.reject(err);
        });
        return deferred.promise;
      },
      deleteAllergen: function deleteAllergen(allergenId) {
        var deferred = $q.defer();
        //step 1 get the id of current user
        //step 2 perform the call
        httpAuth["delete"]('/api/users/' + this._id + '/' + Allergen.APIPath + '/' + allergenId, {}, {
          headers: {
            "Content-Type": "application/json"
          }
        }).success(function () {
          console.log('the api add allergen succeeded');
          deferred.resolve();
        }).error(function (err) {
          deferred.reject(err);
        });
        return deferred.promise;
      },
      getIngredientsLiked: function getIngredientsLiked(page) {
        var deferred = $q.defer();
        //step 1 get the id of current user
        //step 2 perform the call
        httpAuth.get('/api/users/' + this._id + '/ingredientsLike/page/' + page, {}, {
          headers: {
            "Content-Type": "application/json"
          }
        }).success(function (ingredients) {
          //put ingredient in the cache and transform them into models
          var ingredientsArray = [];
          ingredients.forEach(function (ingredient) {
            ingredientsArray.push(ingredientsManager._retrieveInstance(ingredient.slug, ingredient));
          });
          console.log('the api add allergen succeeded');
          deferred.resolve(ingredientsArray);
        }).error(function (err) {
          deferred.reject(err);
        });
        return deferred.promise;
      },
      getIngredientsDisliked: function getIngredientsDisliked(page) {
        var deferred = $q.defer();
        //step 1 get the id of current user
        //step 2 perform the call
        httpAuth.get('/api/users/' + this._id + '/ingredientsDislike/page/' + page, {}, {
          headers: {
            "Content-Type": "application/json"
          }
        }).success(function (ingredients) {
          //put ingredient in the cache and transform them into models
          var ingredientsArray = [];
          ingredients.forEach(function (ingredient) {
            ingredientsArray.push(ingredientsManager._retrieveInstance(ingredient.slug, ingredient));
          });
          console.log('the api add allergen succeeded');
          deferred.resolve(ingredientsArray);
        }).error(function (err) {
          deferred.reject(err);
        });
        return deferred.promise;
      }
    };
    angular.extend(User.prototype, Model.prototype);
    return User;
  }
  ;
})();
(function () {
  angular.module('meanApp').directive('bgImage', bgImage);
  function bgImage() {
    return {
      link: function link(scope, element, attr) {
        attr.$observe('bgImage', function () {
          if (!attr.bgImage) {
            // No attribute specified, so use default
            element.css("background-image", "url(" + scope.defaultImage + ")");
          } else {
            var image = new Image();
            image.src = attr.bgImage;
            image.onload = function () {
              //Image loaded- set the background image to it
              if (attr.bgImage) {
                element.css("background-image", "url(" + attr.bgImage + ")");
              }
            };
            image.onerror = function () {
              //Image failed to load- use default
              if (scope.defaultImage) {
                element.css("background-image", "url(" + scope.defaultImage + ")");
              }
            };
          }
        });
      }
    };
  }
})();
(function () {
  angular.module('meanApp').directive('bgHomeImage', bgHomeImage);
  function bgHomeImage() {
    return {
      link: function link(scope, element, attr) {
        attr.$observe('bgHomeImage', function () {
          if (!attr.bgHomeImage) {
            // No attribute specified, so use default
            element.css("background", "url(" + scope.defaultImage + ")");
          } else {
            var image = new Image();
            image.src = attr.bgHomeImage;
            image.onload = function () {
              //Image loaded- set the background image to it
              //element.css("background-image","url("+attr.bgHomeImage+")");
              element.css("background-image", "linear-gradient( rgba(0, 0, 0, 0), rgba(63, 34, 3, 0.5), rgba(63, 34, 3, 0.6) ), url(" + attr.bgHomeImage + ")");
              element.css("background-repeat", "no-repeat");
              element.css("background-size", "cover");
            };
            image.onerror = function () {
              //Image failed to load- use default
              element.css("background-image", "url(" + scope.defaultImage + ")");
            };
          }
        });
      }
    };
  }
})();
(function () {
  angular.module('meanApp').directive('customOnChange', function () {
    return {
      //scope : true,
      restrict: 'A',
      //controller: 'profileCtrl as vm',
      link: function link(scope, element, attrs) {
        console.log('in the custon on change input directive');
        console.log(scope);
        console.log(element);
        console.log(attrs);
        var onChangeHandler = scope.$eval(attrs.customOnChange);
        //TODO faire le base64 ici et changer directement le dom de l'image ??? non ce nest pas possible
        //element.bind('change', onChangeHandler);
        element.bind('change', function (event) {
          var that = this,
            files = event.target.files,
            reader = new FileReader();
          reader.onload = function (event) {
            var imageSource = event.target.result,
              img = new Image();
            img.onload = function () {
              //TODO do post treatment here and get the file data source here :) so no callback is called
              scope.$apply(function () {
                onChangeHandler(imageSource, img.width, img.height);
                //that.value = null;
              });
            };
            img.src = imageSource;
          };
          reader.readAsDataURL(files[0]);
        });
      }
    };
  });
})();
(function () {
  angular.module('meanApp').directive('keepScrollPos', keepScrollPos);
  keepScrollPos.$inject = ['$rootScope', '$state', '$window', '$timeout', '$location', '$anchorScroll'];
  function keepScrollPos($rootScope, $state, $window, $timeout, $location, $anchorScroll) {
    // cache scroll position of each route's templateUrl
    var scrollPosCache = {};

    // compile function
    return {
      restrict: 'EA',
      link: function link(scope, element, attrs) {
        scope.$on('$locationChangeStart', function (rootscope, nextURL, previousURL) {
          // store scroll position for the current view
          if (previousURL) {
            scrollPosCache[previousURL] = [$window.pageXOffset, $window.pageYOffset];
          }
        });
        scope.$on('$locationChangeSuccess', function (rootscope, nextURL, previousURL) {
          // if hash is specified explicitly, it trumps previously stored scroll position
          if ($location.hash()) {
            $anchorScroll();

            // else get previous scroll position; if none, scroll to the top of the page
          } else {
            var prevScrollPos = scrollPosCache[nextURL] || [0, 0];
            $timeout(function () {
              $window.scrollTo(prevScrollPos[0], prevScrollPos[1]);
            }, 0);
          }
        });
      }
    };
  }
})();
(function () {
  angular.module('meanApp').controller('mobileNavCtrl', mobileNavCtrl);
  mobileNavCtrl.$inject = ['$rootScope', '$scope', '$location', 'alert', 'User', 'context', '$state'];
  function mobileNavCtrl($rootScope, $scope, $location, alert, User, context, $state) {
    var vm = this;
    $scope.mobileNavHeader = '';
    $scope.goBack = 'visible';
    $scope.iconCallback = function () {
      console.log('nothing has been defined');
    };
    $scope.clickOnBack = function () {
      var previousState = context.getPreviousState();
      if (previousState) {
        console.log('state is', $state);
        console.log('state current', $state.current.name);
        history.back();
      }
    };
    $scope.hasBackPreviousPath = function () {
      return context.getPreviousState() && context.isCurrentStateSupposedToGetBack();
    };
    context.onContextChange(function (contextInstance) {
      var params = contextInstance.get();
      $scope.goBack = params.goBack === true ? 'visible' : 'hidden',
      //console.log('the value of context name is ', contextparam.getContextName());
      $scope.mobileNavHeader = params.contextName;
      $scope.iconName = params.iconAction;
      $scope.iconCallback = params.iconCallback;
      $scope.colorBackground = params.colorBackground;
      $scope.dropDownActions = params.dropDownActions;
      $scope.href = params.href;
    });
  }
})();
(function () {
  angular.module('meanApp').directive('mobilenav', mobilenav);
  function mobilenav() {
    return {
      restrict: 'EA',
      templateUrl: '/common/directives/mobileNav/mobile.nav.template.html',
      replace: true,
      controller: 'mobileNavCtrl as vm'
    };
  }
})();
(function () {
  angular.module('meanApp').directive('mobiletoolbar', mobiletoolbar);
  function mobiletoolbar() {
    return {
      restrict: 'EA',
      templateUrl: '/common/directives/mobileToolbar/mobile.toolbar.template.html',
      replace: true,
      controller: 'navigationCtrl as vm'
    };
  }
})();
(function () {
  angular.module('meanApp').directive('footercusto', footercusto);
  function footercusto() {
    return {
      restrict: 'EA',
      templateUrl: '/common/directives/footer/footer.template.html',
      replace: true
      /**,
      controller: 'navigationCtrl as navvm'**/
    };
  }
})();
(function () {
  //this directive is an override of the pagination template from uIB to customize href and enables google to index the pages :)
  angular.module('meanApp').directive('uibCustomPagination', function () {
    return {
      restrict: 'A',
      require: 'uibPagination',
      link: function link($scope, $element, $attr, uibPaginationCtrl) {
        uibPaginationCtrl.createRecipeHrefLink = function (pageNum) {
          return '/cool';
        };
      }
    };
  });
})();
(function () {
  angular.module('meanApp').controller('navigationCtrl', navigationCtrl);
  navigationCtrl.$inject = ['$location', 'titleFactory', 'authentication', 'loginModal', 'alert', 'searchData', 'User', '$rootScope', 'usersManager', '$state', '$scope', '$q', 'currentUser', 'searchModal'];
  function navigationCtrl($location, titleFactory, authentication, loginModal, alert, searchData, User, $rootScope, usersManager, $state, $scope, $q, currentUser, searchModal) {
    var vm = this;
    $rootScope.currentYear = new Date().getFullYear();
    $rootScope.hasScrolled = false;
    $rootScope.isMobile = window.innerWidth < 465;
    //always keep the variable for window width up to date
    // Returns a function, that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds. If `immediate` is passed, trigger the function on the
    // leading edge, instead of the trailing.
    var debounce = function debounce(func, wait, immediate) {
      var timeout;
      return function () {
        var context = this,
          args = arguments;
        var later = function later() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    };
    $scope.$state = $state; //This is used in the mobile toolbar

    //For Google indexation strategy and have nice cards to be checked on production
    $scope.$root.ld = {
      '@context': 'http://schema.org/',
      '@type': 'WebSite',
      name: 'Fraise ou Bacon',
      image: 'https://fraiseoubacon.com/images/coloredlogo.svg',
      description: 'Moteur de recherche de recettes. Votre prochain repas se trouve ici',
      url: 'https://fraiseoubacon.com/'
    };

    /*window.onResize = debounce(function() {
              $rootScope.isMobile = window.innerWidth < 400;
          }, 250);*/
    window.addEventListener('resize', debounce(function () {
      $rootScope.isMobile = window.innerWidth < 465;
      $rootScope.$apply(); //force the refresh
    }, 250));
    /*window.onResize = function() {
              console.log('resized');
          };*/
    /*$rootScope.loadMoreRecipes = function() {
              console.log('in the nav end scroll detected');
          };*/

    //TODO maybe not useful anymore in that way when everything has been migrated
    currentUser.get().then(function (userModel) {
      $rootScope.currentUser = userModel;
    });
    console.log('current user is in controller navigation test');
    console.log($rootScope.currentUser);
    $rootScope.isLoggedIn = authentication.isLoggedIn();
    vm.getCentralButtonHref = function () {
      var href = '/',
        step = $state.params && $state.params.step && parseInt($state.params.step);
      if (!step) {
        href = '/recherche/etape/1';
      } else if (step < 4) {
        href = '/recherche/etape/' + (step + 1);
      }
      return href;
    };
    vm.canGoToNextSearchPageWithNoCheck;
    vm.isAtLeastOneTagSelected = function () {
      return searchData.getTagsSelected().length > 0;
    };
    vm.selectTab = function (tabNumber) {
      console.log('select tab in navigation controller');
      //alert.push('success', 'tab number is' +tabNumber);
      vm.tabSelected = tabNumber;
      window.scrollTo(0, 0);
      //alert.push('success', 'after windo scroll');
      switch (tabNumber) {
        case 0:
          $state.go('home');
          break;
        case 1:
          console.log('state is', $state, $state.current, $state.params);
          //if we are in search mode go to next, otherwise access the search mode
          if ($state.current.name === 'recipeSearchStep') {
            //go to next
            var step = parseInt($state.params.step);
            if (step < 4) {
              $state.go('recipeSearchStep', {
                step: step + 1 + ''
              });
            } else {
              var tagsSelected = searchData.getTagsSelected();
              if (tagsSelected.length > 0) {
                $state.go('recipeSearchResult');
              } else {
                alert.push('info', 'Veuillez sélectionner au moins 1 tag');
                if (!($rootScope.currentUser && $rootScope.currentUser._id)) {
                  //means no user is logged in
                  $state.go('recipeSearchStep', {
                    step: '1'
                  });
                }
              }
            }
          } else {
            //searchModal.open();
            $state.go('recipeSearchStep', {
              step: '1'
            });
          }
          break;
        case 2:
          currentUser.get().then(function (userModel) {
            if (!userModel._id) {
              //alert.push('success', 'open subscribe view');
              vm.openSubscribeView(true);
            } else {
              //alert.push('success', 'go to profilebecause if is set');
              $state.go('profile.info', {
                id: userModel._id
              });
            }
          }, function () {
            //alert.push('danger', 'failed retrieving the user');
            //then here just prompt the layer to get authentication !
            vm.openSubscribeView(true);
          });
          break;
      }
    };
    vm.goToHome = function () {
      $state.go('home');
    };
    vm.openSubscribeView = function (isLogin) {
      loginModal.open(isLogin);
    };
    vm.goToSearchStepOne = function () {
      $state.go('recipeSearchStep', {
        step: '1'
      });
    };
    vm.goToSearchResultByText = function () {
      $state.go('recipeTextSearchResult', {
        search: vm.searchQuery
      });
    };
  }
})();
(function () {
  angular.module('meanApp').directive('navigation', navigation);
  function navigation() {
    return {
      restrict: 'EA',
      templateUrl: '/common/directives/navigation/navigation.template.html',
      controller: 'navigationCtrl as navvm'
    };
  }
})();
(function () {
  angular.module('meanApp').directive('nutriscore', nutriscore);
  function nutriscore() {
    return {
      restrict: 'EA',
      templateUrl: '/common/directives/nutriscore/nutriscore.template.html',
      replace: true,
      scope: {
        nutriscoreLetter: '@',
        size: '@'
      }
    };
  }
})();
(function () {
  angular.module('meanApp').directive('richCard', ['$sce', '$filter', function ($sce, $filter) {
    return {
      restrict: 'EA',
      link: function link(scope, element) {
        scope.$watch('ld', function (val) {
          var val = $sce.trustAsHtml($filter('json')(val));
          if (val) {
            element[0].outerHTML = '<script type="application/ld+json">' + val + '</script>';
          }
        });
      }
    };
  }]);
})();
(function () {
  angular.module('meanApp').directive('recipeThumb', recipeThumb);
  function recipeThumb() {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        'recipe': '=',
        'size': '@'
      },
      templateUrl: '/common/directives/recipeThumb/recipeThumb.template.html'
    };
  }
})();
(function () {
  angular.module('meanApp').directive('burgerSpinner', burgerSpinner);
  function burgerSpinner() {
    return {
      restrict: 'E',
      replace: true,
      /*scope : {
      'recipe': '=',
      'size' : '@'
      },*/
      templateUrl: '/common/directives/spinner/burger.spinner.template.html'
    };
  }
})();
(function () {
  angular.module('meanApp').controller('recipeCardCtrl', recipeCardCtrl);
  recipeCardCtrl.$inject = ['$scope', '$location', 'authentication', 'loginModal', 'User', '$rootScope', 'usersManager', '$state'];
  function recipeCardCtrl($scope, $location, authentication, loginModal, User, $rootScope, usersManager, $state) {
    var vm = this,
      DEFAUlT_INITIAL_HEIGHT = 110,
      INGREDIENTS_COLORS = ['#F49AC2', '#CB99C9', '#C23B22', '#FFD1DC', '#DEA5A4', '#AEC6CF', '#77DD77', '#B39EB5', '#FFB347', '#B19CD9', '#FF6961', '#03C03C', '#FDFD96', '#779ECB', '#966FD6'];
    //(in pixels)
    vm.sharePossible = navigator && navigator.share; //later modify and put a real condition on browser
    vm.goToRecipe = function (recipe, hash) {
      if (hash) {
        $state.go('recipe', {
          id: recipe.slug,
          '#': hash
        });
      } else {
        $state.go('recipe', {
          id: recipe.slug
        });
      }
    };
    vm.onShare = function (recipe) {
      if (vm.sharePossible) {
        navigator.share({
          title: recipe.title,
          url: document.URL,
          text: "Regarde, j'ai trouvé cette recette sur Fraiseoubacon.com :)"
        });
      }
    };

    /**below function to go back to previous mode ***/
    vm.goBackToLandscapeMode = function (recipe) {
      //step 0 hide the cross
      recipe.isCrossHidden = true;
      //step 1 retrieve the element
      var finalContent = angular.element(document.querySelector('#' + recipe.slug + ' .final-content'))[0];
      //step 2 reset its natural height
      finalContent.style.height = finalContent.offsetHeight + 'px';
      recipe.offsetHeight = finalContent.offsetHeight;
      setTimeout(function () {
        //step 3 make it decrease to 0
        finalContent.style.height = DEFAUlT_INITIAL_HEIGHT + 'px';
        setTimeout(function () {
          //step 4 do the hide and show process
          recipe.isFolded = true;
          recipe.isCrossHidden = false;
          $scope.$apply();
        }, 2001);
      }, 50);
    };
    vm.goToEditRecipe = function (recipe) {
      $state.go('recipecreationstep', {
        id: recipe.slug,
        step: '1'
      });
    };
    vm.goToAuthorPage = function (recipe) {
      $state.go('profile.info', {
        id: recipe.author._id
      });
    };
    vm.goToInstructions = function (recipe) {
      $state.go('recipeInstructions', {
        id: recipe.slug
      });
    };
    vm.activateNumbers = function (cssSelector) {
      //1- find all the data-odometer-value
      var value, od;
      document.querySelectorAll('.nutrition-fact-quantity' + cssSelector).forEach(function (nodeEl) {
        value = nodeEl.getAttribute('data-odometer-value');
        if (Odometer) {
          od = new Odometer({
            el: nodeEl,
            value: 0,
            format: '( ddd),d',
            theme: 'default'
          });
          od.update(value);
        }
      });
    };
    vm.getColor = function (ingredientName) {
      var nbColors = INGREDIENTS_COLORS.length,
        toBeReturned = INGREDIENTS_COLORS[0],
        firstLetter = parseInt(ingredientName.charAt(0), 36) - 9;
      if (ingredientName.length > 1) {
        var secondLetter = parseInt(ingredientName.charAt(1), 36) - 9,
          average = (firstLetter + secondLetter) / 2,
          ratio = average / 26; //26 is the number of letters in occidental alphabet
        toBeReturned = INGREDIENTS_COLORS[Math.trunc(ratio * nbColors)];
      } else {
        toBeReturned = INGREDIENTS_COLORS[Math.trunc(firstLetter / 26 * nbColors)];
      }
      console.log(toBeReturned);
      return toBeReturned;
    };

    //THe following code is duplicated in recipe.read.controller, that should be factorized....
    vm.onLikeRecipe = function (recipe) {
      if (recipe.interactions.isLiked) {
        recipe.unlike();
        recipe.interactions.likeCount--;
      } else {
        recipe.like();
        recipe.interactions.likeCount++;
      }

      //increase counter as well
      recipe.interactions.isLiked = !recipe.interactions.isLiked;
    };
    vm.onBookmarkRecipe = function (recipe) {
      if (recipe.interactions.isBookmarked) {
        recipe.unbookmark();
        recipe.interactions.bookmarkCount--;
      } else {
        recipe.bookmark();
        recipe.interactions.bookmarkCount++;
      }
      recipe.interactions.isBookmarked = !recipe.interactions.isBookmarked;
    };
  }
})();
(function () {
  angular.module('meanApp').directive('recipeCard', recipeCard);
  function recipeCard() {
    return {
      scope: {
        recipe: '=',
        isdetailedview: '@'
      },
      restrict: 'EA',
      templateUrl: '/common/directives/recipe/recipe.card.template.html',
      replace: true,
      controller: 'recipeCardCtrl as subVm' /**,
                                            link: function(scope, element, attrs){
                                            console.log('attributes of the directive are', attrs);
                                            scope.isDetailedView = 'isDetailedView' in attrs;
                                            }**/
    };
  }
})();
(function () {
  angular.module('meanApp').controller('tagCtrl', tagCtrl);
  tagCtrl.$inject = ['$scope', '$uibModal', 'loginModal', 'tagService', '$state', 'searchData'];
  function tagCtrl($scope, $uibModal, loginModal, tagService, $state, searchData) {
    var vm = this,
      iconName = {
        fast: 'thunder.png',
        complicated: 'chef.png',
        protein: 'muscle.png',
        cold: 'fresh.png',
        eco: 'bank.png',
        lowcarb: 'diet.png',
        nopig: 'no-pig.png',
        vegan: 'vegan.png',
        paleo: 'stone-age.png',
        vegetarian: 'vegan.png',
        nogluten: 'gluten-free.png',
        nooven: 'barbecue.png',
        maincourse: 'maincourse.png',
        nomicrowave: 'barbecue.png',
        entry: 'starters.png',
        pleasure: 'fast-food.png',
        savory: 'cheese.png',
        aperitif: 'cocktail.png',
        lowcalory: 'diet.png',
        dessert: 'cake.png',
        sweet: 'donut.png',
        hot: 'fried.png',
        local: 'earth.png',
        season: 'earth.png',
        nohob: 'barbecue.png'
      };
    vm.onTagSearchClicked = function (nameSent, event) {
      //if tag is not on search mode then do not go to search and block event
      console.log('event is', event);
      if (event.target.parentElement.getAttribute('buttonSearch') === 'true') {
        //go to the search result of the tags directly
        //searchData.setTagsSelected([nameSent]);
        $state.go('recipeSearchResult', {
          tags: nameSent
        });
      } else if (event.target.parentElement.getAttribute('buttonLike') !== 'true') {
        //display the modal directly
        this.modalInstance = $uibModal.open({
          templateUrl: 'common/directives/tag/modal.tag.template.html',
          //relative path to app_client
          controller: 'tagCtrl',
          scope: $scope,
          windowClass: 'tag-description-modal'
        });
      }
    };
    vm.onTagPressed = function (nameSent) {
      //now display the proper modal layout to explain the tag
      //destroy the reference of the previous modal ?
      setTimeout(function () {
        this.modalInstance = $uibModal.open({
          templateUrl: 'common/directives/tag/modal.tag.template.html',
          //relative path to app_client
          controller: 'tagCtrl',
          scope: $scope,
          windowClass: 'tag-description-modal'
        });
      }.bind(this), 252); //just set a timeout just right above the limit of press recognition
    };
    $scope.goToSearchStepOne = function () {
      $state.go('recipeSearchStep', {
        step: '1'
      });
    };

    //vm.fast =  {nameHTML : 'Rapide'};
    $scope.name = tagService.wording[$scope.tag] || $scope.tag;
    $scope.description = tagService.descriptions[$scope.tag] || '';
    $scope.iconName = iconName[$scope.tag] || '';
  }
})();
(function () {
  angular.module('meanApp').directive('tagDescription', tagDescription);
  tagDescription.$inject = ['$compile'];
  function tagDescription($compile) {
    return {
      restrict: 'AE',
      templateUrl: 'common/directives/tag/modal.tag.template.html',
      controller: 'tagCtrl',
      replace: true,
      scope: {
        tag: '@tagdesc',
        searchbutton: '@'
      },
      link: function link(scope, element, attrs) {
        element[0].className = 'tag-description-modal category ';
        //element[0].setAttribute('hm-press', 'that.onTagPressed('+attrs.tag+')');
        //$compile(element)(scope);
      }
    };
  }
})();
(function () {
  angular.module('meanApp').directive('tag', tag);
  tag.$inject = ['$compile'];
  function tag($compile) {
    return {
      restrict: 'A',
      templateUrl: '/common/directives/tag/tag.template.html',
      controller: 'tagCtrl as that',
      scope: {
        tag: '@',
        almostTag: '@'
      },
      link: function link(scope, element, attrs) {
        element[0].className = 'pricetag ' + attrs.tag + (attrs.almostTag == 'true' ? ' is-almost-tag' : '');
        //element[0].setAttribute('hm-press', 'that.onTagPressed('+attrs.tag+')');
        //$compile(element)(scope);
      }
    };
  }
})();
(function () {
  angular.module('meanApp').service('tagService', tagService);
  tagService.$inject = [];
  function tagService() {
    var MATCHING_WORDING = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
        fast: 'Rapide',
        complicated: 'Élaboré',
        protein: 'Hyperprotéiné',
        cold: 'Froid',
        eco: 'Économique',
        lowcarb: 'Peu de glucides',
        nopig: 'Sans porc',
        vegan: 'Végétalien',
        paleo: 'Paléo',
        vegetarian: 'Végétarien',
        nogluten: 'Sans gluten',
        nooven: 'Sans four',
        maincourse: 'Plat de résistance',
        nomicrowave: 'Sans micro-ondes',
        entry: 'Entrée',
        pleasure: 'Plaisir',
        savory: 'Salé',
        aperitif: 'Apéro',
        lowcalory: 'Hypocalorique',
        dessert: 'Dessert'
      }, "fast", 'Rapide'), "sweet", 'Sucré'), "hot", 'Chaud'), "local", 'Local'), "season", 'De saison'), "nohob", 'Sans plaque de cuisson'),
      DESCRIPTIONS = {
        fast: 'Vous souhaitez cuisiner et garder le contrôle sur ce que vous mangez mais manquez de temps ? Ce Nutritag est fait pour vous ! Il caractérise toutes les recettes prenant moins de 15 min.',
        complicated: 'Vous souhaitez réaliser une cuisine plus élaborée ? Plus complexe ? Epater vos invités ? Ce Nutritag répertorie toutes les recettes représentant une certaine complexité (nombre d’ingrédients élevés, beaucoup d’instructions)',
        protein: 'Les recettes ciblées par ce Nutritag ont une quantité de protéines bien au-dessus de la moyenne. Parfait pour les personnes suivant un régime hyperprotéiné, permettant d’allier prise de muscles et/ou perte de poids. A compléter avec un nutriscore élevé afin d’en augmenter l’efficacité',
        cold: 'Les recettes proposées par ce Nutritag vous apporteront une sensation de fraîcheur. Idéal pour affronter les grosses chaleurs !',
        eco: 'Vous préférez investir votre argent dans un projet personnel plutôt que dans l’alimentation ? Ce Nutritag sélectionnant les recettes les plus économiques est fait pour vous ! Vive les économies !',
        lowcarb: 'Ce Nutritag identifie les recettes hypoglucidiques, elles contiennent en proportion peu de glucides. De nombreux régimes adoptent cette stratégie et promettent de perdre du poids rapidement',
        nopig: 'Les recettes proposées par ce Nutritag ne contiendront aucun ingrédient à base de porc',
        vegan: 'A l’aide de ce Nutritag vous trouverez l’ensemble des recettes excluant tout produit animal',
        paleo: 'Le régime paléolithique ou plus simplement régime paléo, consiste à ne consommer que des aliments disponibles à l’époque du paléolithique. Ce régime, ou philosophie, a pour but de faire perdre du poids mais aussi d’éliminer naturellement tous les aliments transformés de l’industrie agroalimentaire, produits laitiers, céréales. Ceux-ci seraient moins bien assimilés par le corps humain, non adapté',
        vegetarian: 'Que ce soit par conviction ou dans un souci de bien-être physique, découvrez au travers de ce Nutritag des recettes qui excluent toute chaire animale',
        nogluten: 'Les recettes proposées par ce Nutritag excluent tout aliment contenant du gluten',
        nooven: 'Vous n’avez pas de four ? Ou souhaitez cuisiner de façon éco-responsable ? Ce Nutritag vous propose des recettes sans four',
        maincourse: 'Ce tag cible uniquement les recettes catégorisées en tant que plat principal',
        nomicrowave: 'Vous n’avez pas de micro-ondes ? Ce Nutritag vous propose des recettes sans micro-ondes',
        entry: 'Ce Nutritag cible uniquement les recettes catégorisées en tant qu’entrée',
        pleasure: 'Vous souhaitez vous faire plaisir ? Le corps humain adore le gras, le sucre, et le sel ! Les recettes ayant un nutriscore très faible seront donc favorisées',
        savory: 'Plutôt salé ou sucré ? Ce Nutritag s’applique à toute recette ayant une certaine quantité de sel',
        aperitif: "Ce Nutritag identifie toutes les recettes pouvant être réalisées juste avant un repas, au moment de \"l'apéro\". Vous retrouverez des amuse-gueules, tapas, idées de cocktails...",
        lowcalory: 'Ce Nutritag cible les recettes ayant un indice calorique faible. Très utile pour les personnes ayant une santé nécessitant un amaigrissement. Attention, un risque en déficit de micronutriments ou de fonte musculaire est possible à long terme avec ce type de régime',
        dessert: 'Ce Nutritag cible uniquement les recettes catégorisées en tant que dessert',
        sweet: 'Plutôt salé ou sucré ? Ce Nutritag s’applique à toute recette qui fera vibrer vos papilles sous l’action du sucre',
        hot: 'Certaines recettes sont meilleures chaudes. Avec ce Nutritag trouvez une recette qui saura vous réchauffer !',
        local: 'Ce Nutritag favorise toutes les recettes créées à partir d’aliments provenant de France métropolitaine. Le bilan carbone d’une telle recette sera beaucoup plus faible que les autres recettes en moyenne. C’est bon pour la planète ! Consommer français c’est aussi bon pour l’emploi en France !',
        season: 'Ce Nutritag favorise tous les recettes ayant des ingrédients de saison. Certains ingrédients comme les fruits et légumes frais ont une saisonnalité marquée. Manger de saison permet de faire des économies tout en préservant la planète !',
        nohob: 'Vous n’avez pas de plaques de cuisson, ou souhaitez cuisiner de façon eco-responsable ? Ce Nutritag vous propose des recettes n’utilisant pas de plaques de cuisson'
      };
    var TITLES = {
      fast: 'Recettes rapides pour les personnes qui veulent gagner du temps !',
      complicated: 'Recettes sophistiquées pour impressionner vos invités !',
      protein: 'Recettes hyperprotéinées pour prendre de la masse musculaire',
      cold: 'Recettes froides pour vous rafraîchir',
      eco: "Recettes économiques pour mettre de l'argent de côté",
      lowcarb: 'Recettes hypoglucidiques pour perdre du poids, ou pour diabétiques',
      nopig: 'Recettes sans porc',
      vegan: 'Recettes végan sans aucune ingrédient de provenance animale',
      paleo: 'Recettes paléo pour une cuisine saine et facile',
      vegetarian: 'Recettes végétariennes pour protéger la planète',
      nogluten: 'Recettes sans gluten',
      nooven: 'Recettes ne nécessitant pas de four',
      maincourse: 'Idées de recettes pour plat principal',
      nomicrowave: 'Recettes ne nécessitant pas de micro-ondes',
      entry: 'Idées de recettes pour entrée',
      pleasure: 'Idées de recettes pour se faire plaisir',
      savory: 'Idées de recettes salées',
      aperitif: "Idées de recettes pour l'apéritif",
      lowcalory: 'Idées de recettes peu caloriques pour perdre du poids',
      dessert: 'Idées de recettes pour dessert',
      sweet: 'Idées de recettes sucrées',
      hot: 'Idées de recettes chaudes pour vous réchauffer !',
      local: "Idées de recettes locales pour protéger l'environnement",
      season: "Idées de recettes de saison pour protéger la planète",
      nohob: "Idées de recettes sans plaques de cuisson"
    };
    this.wording = MATCHING_WORDING;
    this.descriptions = DESCRIPTIONS;
    this.titles = TITLES;
    return this;
  }
})();
(function () {
  angular.module('meanApp').directive('userThumb', userThumb);
  function userThumb() {
    return {
      restrict: 'E',
      scope: {
        'user': '=',
        'size': '@'
      },
      templateUrl: '/common/directives/userthumb/userthumb.template.html'
    };
  }
})();